/* tslint:disable */
/* eslint-disable */
/**
 * RIC API
 * Renewed Incentive Point API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdminDashboardGroupUsers
 */
export interface AdminDashboardGroupUsers {
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardGroupUsers
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDashboardGroupUsers
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDashboardGroupUsers
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDashboardGroupUsers
     */
    'hierarchy': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardGroupUsers
     */
    'organization': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardGroupUsers
     */
    'parent_group': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardGroupUsers
     */
    'users_count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDashboardGroupUsers
     */
    'sub_groups_count': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDashboardGroupUsers
     */
    'parent_group_name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AdminDashboardGroupUsers
     */
    'sub_groups': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface AdminThanksGivingList200Response
 */
export interface AdminThanksGivingList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof AdminThanksGivingList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof AdminThanksGivingList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof AdminThanksGivingList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ThanksGivingAdminGet>}
     * @memberof AdminThanksGivingList200Response
     */
    'results'?: Array<ThanksGivingAdminGet>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BpfInvoiceOutputFlagEnum = {
    NUMBER_1: 1,
    NUMBER_0: 0
} as const;

export type BpfInvoiceOutputFlagEnum = typeof BpfInvoiceOutputFlagEnum[keyof typeof BpfInvoiceOutputFlagEnum];


/**
 * 
 * @export
 * @interface CSVUploadTask
 */
export interface CSVUploadTask {
    /**
     * 
     * @type {string}
     * @memberof CSVUploadTask
     */
    'task_id': string;
    /**
     * 
     * @type {number}
     * @memberof CSVUploadTask
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface CreditCardDetails
 */
export interface CreditCardDetails {
    /**
     * 
     * @type {number}
     * @memberof CreditCardDetails
     */
    'id': number;
    /**
     * credit card point required
     * @type {number}
     * @memberof CreditCardDetails
     */
    'credit_use_point': number;
    /**
     * credit card amount in yen
     * @type {number}
     * @memberof CreditCardDetails
     */
    'credit_use_price': number;
    /**
     * tax on credit card amount
     * @type {number}
     * @memberof CreditCardDetails
     */
    'credit_tax': number;
    /**
     * total credit card amount with tax
     * @type {number}
     * @memberof CreditCardDetails
     */
    'credit_use_price_in_tax': number;
}
/**
 * 
 * @export
 * @interface CreditCardDetailsRequest
 */
export interface CreditCardDetailsRequest {
    /**
     * credit card point required
     * @type {number}
     * @memberof CreditCardDetailsRequest
     */
    'credit_use_point': number;
    /**
     * credit card amount in yen
     * @type {number}
     * @memberof CreditCardDetailsRequest
     */
    'credit_use_price': number;
    /**
     * tax on credit card amount
     * @type {number}
     * @memberof CreditCardDetailsRequest
     */
    'credit_tax': number;
    /**
     * total credit card amount with tax
     * @type {number}
     * @memberof CreditCardDetailsRequest
     */
    'credit_use_price_in_tax': number;
}
/**
 * 
 * @export
 * @interface CustomUser
 */
export interface CustomUser {
    /**
     * 
     * @type {number}
     * @memberof CustomUser
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomUser
     */
    'email'?: string;
    /**
     * 全ての権限を持っているとみなされます。
     * @type {boolean}
     * @memberof CustomUser
     */
    'is_superuser'?: boolean;
}
/**
 * A year-month pair for a given month
 * @export
 * @interface DateMonth
 */
export interface DateMonth {
    /**
     * Integer of available month
     * @type {number}
     * @memberof DateMonth
     */
    'year': number;
    /**
     * Integer of available month, in the paired year. Months starting from 1
     * @type {number}
     * @memberof DateMonth
     */
    'month': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DirectionEnum = {
    Up: 'up',
    Down: 'down',
    Top: 'top',
    Bottom: 'bottom'
} as const;

export type DirectionEnum = typeof DirectionEnum[keyof typeof DirectionEnum];


/**
 * 
 * @export
 * @interface ExpiringPointsDataList200Response
 */
export interface ExpiringPointsDataList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof ExpiringPointsDataList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof ExpiringPointsDataList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof ExpiringPointsDataList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ExpiringPointsHistory>}
     * @memberof ExpiringPointsDataList200Response
     */
    'results'?: Array<ExpiringPointsHistory>;
}
/**
 * 
 * @export
 * @interface ExpiringPointsHistory
 */
export interface ExpiringPointsHistory {
    /**
     * 
     * @type {number}
     * @memberof ExpiringPointsHistory
     */
    'pk': number;
    /**
     * 
     * @type {string}
     * @memberof ExpiringPointsHistory
     */
    'expiry_date': string;
    /**
     * 
     * @type {number}
     * @memberof ExpiringPointsHistory
     */
    'points': number;
    /**
     * 
     * @type {PointTypeEnum}
     * @memberof ExpiringPointsHistory
     */
    'point_type'?: PointTypeEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof ExpiringPointsHistory
     */
    'user': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ExpiringPointsHistory
     */
    'group': number;
    /**
     * for getting points only
     * @type {number}
     * @memberof ExpiringPointsHistory
     */
    'remaining_points'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExpiringPointsHistory
     */
    'expire'?: string | null;
}
/**
 * 
 * @export
 * @interface ExpiringPointsHistoryList200Response
 */
export interface ExpiringPointsHistoryList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof ExpiringPointsHistoryList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof ExpiringPointsHistoryList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof ExpiringPointsHistoryList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PointExpiryHistory>}
     * @memberof ExpiringPointsHistoryList200Response
     */
    'results'?: Array<PointExpiryHistory>;
}
/**
 * csv failure report serializer
 * @export
 * @interface FailCSVFileDownload
 */
export interface FailCSVFileDownload {
    /**
     * errors file containing errors related to CSV upload
     * @type {string}
     * @memberof FailCSVFileDownload
     */
    'errorFile': string;
    /**
     * 
     * @type {FeatureTypeEnum}
     * @memberof FailCSVFileDownload
     */
    'feature_type': FeatureTypeEnum;
    /**
     * 
     * @type {any}
     * @memberof FailCSVFileDownload
     */
    'name': any;
    /**
     * 
     * @type {number}
     * @memberof FailCSVFileDownload
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface FailCsvUploadReportsList200Response
 */
export interface FailCsvUploadReportsList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof FailCsvUploadReportsList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof FailCsvUploadReportsList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof FailCsvUploadReportsList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<FailCSVFileDownload>}
     * @memberof FailCsvUploadReportsList200Response
     */
    'results'?: Array<FailCSVFileDownload>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FeatureTypeEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80
} as const;

export type FeatureTypeEnum = typeof FeatureTypeEnum[keyof typeof FeatureTypeEnum];


/**
 * 
 * @export
 * @interface FooterList200Response
 */
export interface FooterList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof FooterList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof FooterList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof FooterList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<OrganizationFooter>}
     * @memberof FooterList200Response
     */
    'results'?: Array<OrganizationFooter>;
}
/**
 * 
 * @export
 * @interface GiveThanksPointRequest
 */
export interface GiveThanksPointRequest {
    /**
     * 
     * @type {number}
     * @memberof GiveThanksPointRequest
     */
    'points_to_send': number;
    /**
     * 
     * @type {string}
     * @memberof GiveThanksPointRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GiveThanksPointRequest
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof GiveThanksPointRequest
     */
    'to_user': number;
    /**
     * 
     * @type {number}
     * @memberof GiveThanksPointRequest
     */
    'thanks_point_giving_type': number;
}
/**
 * 
 * @export
 * @interface GrantCriteria
 */
export interface GrantCriteria {
    /**
     * 
     * @type {number}
     * @memberof GrantCriteria
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteria
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteria
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrantCriteria
     */
    'points': number;
    /**
     * 
     * @type {KindEnum}
     * @memberof GrantCriteria
     */
    'kind'?: KindEnum;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantCriteria
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantCriteria
     */
    'updated_at': string;
    /**
     * Random unique id (easy to remember) given by admin to a grant criteria.
     * @type {string}
     * @memberof GrantCriteria
     */
    'grant_criteria_id'?: string | null;
    /**
     * Used to store the icon id for grant criteria.
     * @type {number}
     * @memberof GrantCriteria
     */
    'grant_criteria_icon_id'?: number | null;
    /**
     * Order given by admin user will reflect for general user
     * @type {number}
     * @memberof GrantCriteria
     */
    'order': number;
    /**
     * 
     * @type {boolean}
     * @memberof GrantCriteria
     */
    'is_used': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GrantCriteria
     */
    'is_fully_used': boolean;
    /**
     * Soft deletion date and time.
     * @type {string}
     * @memberof GrantCriteria
     */
    'deleted_at': string;
    /**
     * Helps to identify the dummy Grant Criteria needed only for giving Grant Point once.
     * @type {boolean}
     * @memberof GrantCriteria
     */
    'is_dummy'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof GrantCriteria
     */
    'groups': Array<any>;
}
/**
 * 
 * @export
 * @interface GrantCriteriaDetail
 */
export interface GrantCriteriaDetail {
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaDetail
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaDetail
     */
    'points': number;
    /**
     * 
     * @type {KindEnum}
     * @memberof GrantCriteriaDetail
     */
    'kind'?: KindEnum;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'updated_at': string;
    /**
     * Random unique id (easy to remember) given by admin to a grant criteria.
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'grant_criteria_id'?: string | null;
    /**
     * Used to store the icon id for grant criteria.
     * @type {number}
     * @memberof GrantCriteriaDetail
     */
    'grant_criteria_icon_id'?: number | null;
    /**
     * Order given by admin user will reflect for general user
     * @type {number}
     * @memberof GrantCriteriaDetail
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaDetail
     */
    'no_of_times_used': number;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'last_used': string;
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaDetail
     */
    'accumulated_grant_points': number;
    /**
     * 
     * @type {boolean}
     * @memberof GrantCriteriaDetail
     */
    'is_used': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GrantCriteriaDetail
     */
    'is_fully_used': boolean;
    /**
     * Soft deletion date and time.
     * @type {string}
     * @memberof GrantCriteriaDetail
     */
    'deleted_at'?: string | null;
    /**
     * Helps to identify the dummy Grant Criteria needed only for giving Grant Point once.
     * @type {boolean}
     * @memberof GrantCriteriaDetail
     */
    'is_dummy'?: boolean;
    /**
     * 
     * @type {Array<RicGroup>}
     * @memberof GrantCriteriaDetail
     */
    'groups': Array<RicGroup>;
}
/**
 * 
 * @export
 * @interface GrantCriteriaList200Response
 */
export interface GrantCriteriaList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof GrantCriteriaList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof GrantCriteriaList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof GrantCriteriaList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<GrantCriteria>}
     * @memberof GrantCriteriaList200Response
     */
    'results'?: Array<GrantCriteria>;
}
/**
 * 
 * @export
 * @interface GrantCriteriaPatch
 */
export interface GrantCriteriaPatch {
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaPatch
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaPatch
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaPatch
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaPatch
     */
    'points': number;
    /**
     * 
     * @type {KindEnum}
     * @memberof GrantCriteriaPatch
     */
    'kind'?: KindEnum;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantCriteriaPatch
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantCriteriaPatch
     */
    'updated_at': string;
    /**
     * Random unique id (easy to remember) given by admin to a grant criteria.
     * @type {string}
     * @memberof GrantCriteriaPatch
     */
    'grant_criteria_id'?: string | null;
    /**
     * Used to store the icon id for grant criteria.
     * @type {number}
     * @memberof GrantCriteriaPatch
     */
    'grant_criteria_icon_id'?: number | null;
    /**
     * Order given by admin user will reflect for general user
     * @type {number}
     * @memberof GrantCriteriaPatch
     */
    'order'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GrantCriteriaPatch
     */
    'is_used': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GrantCriteriaPatch
     */
    'is_fully_used': boolean;
    /**
     * Soft deletion date and time.
     * @type {string}
     * @memberof GrantCriteriaPatch
     */
    'deleted_at': string;
    /**
     * Helps to identify the dummy Grant Criteria needed only for giving Grant Point once.
     * @type {boolean}
     * @memberof GrantCriteriaPatch
     */
    'is_dummy'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof GrantCriteriaPatch
     */
    'groups': Array<any>;
}
/**
 * 
 * @export
 * @interface GrantCriteriaRequest
 */
export interface GrantCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantCriteriaRequest
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrantCriteriaRequest
     */
    'points': number;
    /**
     * 
     * @type {KindEnum}
     * @memberof GrantCriteriaRequest
     */
    'kind'?: KindEnum;
    /**
     * Random unique id (easy to remember) given by admin to a grant criteria.
     * @type {string}
     * @memberof GrantCriteriaRequest
     */
    'grant_criteria_id'?: string | null;
    /**
     * Used to store the icon id for grant criteria.
     * @type {number}
     * @memberof GrantCriteriaRequest
     */
    'grant_criteria_icon_id'?: number | null;
    /**
     * Helps to identify the dummy Grant Criteria needed only for giving Grant Point once.
     * @type {boolean}
     * @memberof GrantCriteriaRequest
     */
    'is_dummy'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof GrantCriteriaRequest
     */
    'groups': Array<any>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GrantExclusivePointsInvoiceFlagEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type GrantExclusivePointsInvoiceFlagEnum = typeof GrantExclusivePointsInvoiceFlagEnum[keyof typeof GrantExclusivePointsInvoiceFlagEnum];


/**
 * 
 * @export
 * @interface GrantPoint
 */
export interface GrantPoint {
    /**
     * 
     * @type {number}
     * @memberof GrantPoint
     */
    'pk': number;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'authorize_date': string;
    /**
     * 
     * @type {GrantCriteria}
     * @memberof GrantPoint
     */
    'grant_criteria': GrantCriteria;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof GrantPoint
     */
    'from_user': RicCustomUser;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof GrantPoint
     */
    'to_user': RicCustomUser;
    /**
     * 
     * @type {GrantTypeEnum}
     * @memberof GrantPoint
     */
    'grant_type'?: GrantTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'grant_type_name': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'group_code_at_time': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'group_name_at_time': string;
    /**
     * 
     * @type {boolean}
     * @memberof GrantPoint
     */
    'is_used': boolean;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'delete_type': string;
    /**
     * Soft deletion date and time.
     * @type {string}
     * @memberof GrantPoint
     */
    'deleted_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'grant_exclusive_expiry': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'thanks_exclusive_expiry': string;
    /**
     * Used to store the alternate icon id for grant criteria.
     * @type {number}
     * @memberof GrantPoint
     */
    'icon_id'?: number | null;
    /**
     * Used to store the modified points while giving grant points.
     * @type {number}
     * @memberof GrantPoint
     */
    'points'?: number | null;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof GrantPoint
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'grant_deadline': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'expires_at': string;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof GrantPoint
     */
    'updated_by'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'gift_deadline'?: string | null;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof GrantPoint
     */
    'from_group': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof GrantPoint
     */
    'to_group': number;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'expire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'thanks_exclusive_deadline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GrantPoint
     */
    'grant_only_deadline'?: string | null;
}
/**
 * 
 * @export
 * @interface GrantPointCreateRequest
 */
export interface GrantPointCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof GrantPointCreateRequest
     */
    'grant_type': number;
    /**
     * 
     * @type {string}
     * @memberof GrantPointCreateRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof GrantPointCreateRequest
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof GrantPointCreateRequest
     */
    'grant_criteria'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GrantPointCreateRequest
     */
    'authorize_date': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GrantPointCreateRequest
     */
    'users': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof GrantPointCreateRequest
     */
    'points'?: number;
    /**
     * 
     * @type {number}
     * @memberof GrantPointCreateRequest
     */
    'icon_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GrantPointCreateRequest
     */
    'expiry_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GrantPointCreateRequest
     */
    'grant_deadline'?: string;
}
/**
 * 
 * @export
 * @interface GrantPointsList200Response
 */
export interface GrantPointsList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof GrantPointsList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof GrantPointsList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof GrantPointsList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<GrantPoint>}
     * @memberof GrantPointsList200Response
     */
    'results'?: Array<GrantPoint>;
}
/**
 * 
 * @export
 * @interface GrantPointsListAvailableMonthsList200Response
 */
export interface GrantPointsListAvailableMonthsList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof GrantPointsListAvailableMonthsList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof GrantPointsListAvailableMonthsList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof GrantPointsListAvailableMonthsList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<DateMonth>}
     * @memberof GrantPointsListAvailableMonthsList200Response
     */
    'results'?: Array<DateMonth>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const GrantTypeEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40
} as const;

export type GrantTypeEnum = typeof GrantTypeEnum[keyof typeof GrantTypeEnum];


/**
 * 
 * @export
 * @interface GroupUsers
 */
export interface GroupUsers {
    /**
     * 
     * @type {number}
     * @memberof GroupUsers
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GroupUsers
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupUsers
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GroupUsers
     */
    'hierarchy': string;
    /**
     * 
     * @type {number}
     * @memberof GroupUsers
     */
    'organization': number;
    /**
     * 
     * @type {number}
     * @memberof GroupUsers
     */
    'parent_group': number;
    /**
     * 
     * @type {number}
     * @memberof GroupUsers
     */
    'users_count': number;
    /**
     * 
     * @type {number}
     * @memberof GroupUsers
     */
    'sub_groups_count': number;
    /**
     * 
     * @type {string}
     * @memberof GroupUsers
     */
    'parent_group_name': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GroupUsers
     */
    'users': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface GroupUsersInfoList200Response
 */
export interface GroupUsersInfoList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof GroupUsersInfoList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof GroupUsersInfoList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof GroupUsersInfoList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<GroupUsers>}
     * @memberof GroupUsersInfoList200Response
     */
    'results'?: Array<GroupUsers>;
}
/**
 * 
 * @export
 * @interface InformationMessage
 */
export interface InformationMessage {
    /**
     * 
     * @type {number}
     * @memberof InformationMessage
     */
    'pk': number;
    /**
     * Whats new message title
     * @type {string}
     * @memberof InformationMessage
     */
    'title': string;
    /**
     * The message content. Note FE need to render this properly
     * @type {string}
     * @memberof InformationMessage
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof InformationMessage
     */
    'has_read': boolean;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof InformationMessage
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof InformationMessage
     */
    'updated_at': string;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof InformationMessage
     */
    'author': number;
    /**
     * The Katakana name of the author
     * @type {string}
     * @memberof InformationMessage
     */
    'author_name': string;
    /**
     * 
     * @type {PageDetail}
     * @memberof InformationMessage
     */
    'page_details': PageDetail;
    /**
     * The time the post should start to be shown
     * @type {string}
     * @memberof InformationMessage
     */
    'start_showing': string;
    /**
     * The time the post should stop to be shown
     * @type {string}
     * @memberof InformationMessage
     */
    'stop_showing'?: string | null;
    /**
     * group ID at the time of registration
     * @type {number}
     * @memberof InformationMessage
     */
    'created_by_group_id'?: number | null;
}
/**
 * 
 * @export
 * @interface InformationMessageAdmin
 */
export interface InformationMessageAdmin {
    /**
     * 
     * @type {number}
     * @memberof InformationMessageAdmin
     */
    'pk': number;
    /**
     * Whats new message title
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'title': string;
    /**
     * The message content. Note FE need to render this properly
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof InformationMessageAdmin
     */
    'has_read': boolean;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'updated_at': string;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof InformationMessageAdmin
     */
    'author': number;
    /**
     * The Katakana name of the author
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'author_name': string;
    /**
     * 
     * @type {PageDetail}
     * @memberof InformationMessageAdmin
     */
    'page_details': PageDetail;
    /**
     * The time the post should start to be shown
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'start_showing': string;
    /**
     * 
     * @type {string}
     * @memberof InformationMessageAdmin
     */
    'msg_status': string;
    /**
     * 
     * @type {number}
     * @memberof InformationMessageAdmin
     */
    'view_count': number;
    /**
     * group ID at the time of registration
     * @type {number}
     * @memberof InformationMessageAdmin
     */
    'created_by_group_id'?: number | null;
}
/**
 * 
 * @export
 * @interface InformationMessageAdminCreateRequest
 */
export interface InformationMessageAdminCreateRequest {
    /**
     * Whats new message title
     * @type {string}
     * @memberof InformationMessageAdminCreateRequest
     */
    'title': string;
    /**
     * The message content. Note FE need to render this properly
     * @type {string}
     * @memberof InformationMessageAdminCreateRequest
     */
    'message': string;
    /**
     * The time the post should start to be shown
     * @type {string}
     * @memberof InformationMessageAdminCreateRequest
     */
    'start_showing': string;
    /**
     * group ID at the time of registration
     * @type {number}
     * @memberof InformationMessageAdminCreateRequest
     */
    'created_by_group_id'?: number | null;
}
/**
 * 
 * @export
 * @interface InformationMessageTracker
 */
export interface InformationMessageTracker {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof InformationMessageTracker
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof InformationMessageTracker
     */
    'message': number;
    /**
     * 
     * @type {boolean}
     * @memberof InformationMessageTracker
     */
    'has_read'?: boolean;
}
/**
 * 
 * @export
 * @interface InformationMessageTrackerRequest
 */
export interface InformationMessageTrackerRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof InformationMessageTrackerRequest
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof InformationMessageTrackerRequest
     */
    'message': number;
    /**
     * 
     * @type {boolean}
     * @memberof InformationMessageTrackerRequest
     */
    'has_read'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceOutputFlagEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type InvoiceOutputFlagEnum = typeof InvoiceOutputFlagEnum[keyof typeof InvoiceOutputFlagEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const KindEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40
} as const;

export type KindEnum = typeof KindEnum[keyof typeof KindEnum];


/**
 * 
 * @export
 * @interface MarkSystemNotificationsReadList200Response
 */
export interface MarkSystemNotificationsReadList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof MarkSystemNotificationsReadList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof MarkSystemNotificationsReadList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof MarkSystemNotificationsReadList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<InformationMessageTracker>}
     * @memberof MarkSystemNotificationsReadList200Response
     */
    'results'?: Array<InformationMessageTracker>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationTypeEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80
} as const;

export type NotificationTypeEnum = typeof NotificationTypeEnum[keyof typeof NotificationTypeEnum];


/**
 * 
 * @export
 * @interface OrgAdminSettings
 */
export interface OrgAdminSettings {
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'id': number;
    /**
     * Organization ID from the AUTH system
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'organization': number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'number_of_users_to_register'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'user_usage_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'site_id'?: string;
    /**
     * number of Months
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'point_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Display Email address in Footer or Not.
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettings
     */
    'display_email_address'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'email_address'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'display_telephone_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'telephone_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'display_department_name'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'department_name'?: string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'enquiry_of_product'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'source_representation_of_delivery_mails'?: number;
    /**
     * Please fill in the notice to the user with 1,000 characters or less.             If you do not need any special notes, please be sure to leave them blank.             * In principle, the wording cannot be replaced.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'special_notes'?: string;
    /**
     * It is a function that can give points that can only be \"granted\" to some              administrator privileges (GroupAdmin, Maneger). 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'grant_exclusive_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'grant_expiry_number_of_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'grant_expiry_time_period'?: number;
    /**
     * The points that the user has This function allows you to give a gift to another user.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Select the pattern of the item for which you want to set gift points.Type a message
     * @type {ThanksPointPatternEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_point_pattern'?: ThanksPointPatternEnum;
    /**
     * Points to choose from(If not set, considered as free type) ex: 1000 for single or [100, 200] for multiple.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'points_to_send'?: string | null;
    /**
     * Maximum point that can be given.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'max_points'?: number | null;
    /**
     * Minimum points that can be given.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'min_points'?: number | null;
    /**
     * Please select the range of points to be awarded.
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettings
     */
    'point_giving_range'?: PointGiftingRangeEnum;
    /**
     * This function allows you to exchange messages (chat)              between the user who gave the points and the user who receive the points.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thread_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * In response to the point donation application from the user             This is a function for the administrator to confirm the content of the gift              and then approve or deny it.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_point_approval_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     *  It is a function that can give users points that can only be \"gifted\"                  (points cannot be exchanged).
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_exclusive_points_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * It is a setting whether to allow the receiving user to re-donate the          points donated using the Sunkus exclusive points to other users.         * If you select \"No re-donation\", the points donated using the Sunkus exclusive          points can only be used for \"Point exchange\".
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettings
     */
    'allow_points_regifting'?: PointGiftingRangeEnum;
    /**
     * When a thank-you point arrives at the user This is the email you will              be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_point_arrived_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * For user, point donation application This is an email notifying you of              the approval / rejection results.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'approval_result_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * The number of points donation applications waiting for approval to the              administrator This is the email you will be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'approval_pending_count_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'thanks_expiry_number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'self_pay_enabled'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'point_course_category'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'taxation_category'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'payment_method'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'payment_period'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'payment_period_in_months'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'payment_due_date'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'others_payment_due_date'?: string | null;
    /**
     * 
     * @type {ServiceUsageFeeEnum}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee'?: ServiceUsageFeeEnum | null;
    /**
     * If you select free above, it will be fixed at 0 yen.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee_for_other'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'point_receipt_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'point_balance_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'point_expiry_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'apply_confirmation_mail_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'mail_magazine_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'password_reset_request_function'?: BpfInvoiceOutputFlagEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'updated_by'?: number | null;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'updated_at': string;
    /**
     * Please select.
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'latest_transaction'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'grant_point_delete_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * Note this is not an URL, it\'s a file path only. JTech don\'t wantto change it and BOJ agreeed.
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'membership_term_url'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof OrgAdminSettings
     */
    'footer_membership_url': any;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettings
     */
    'membership_agreement'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'point_revocation_notification'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'gift_notification_mail_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * it is necessary to use Sunkus dedicated point function
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'sunkus_dedicated_point_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'approval_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'need_to_use_thread_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettings
     */
    'point_gifting_range'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'sunkus_point_deadline'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'fixed_point'?: number | null;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'dead_line_for_gathering'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'dedicated_points_deadline_entry_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'dedicated_points_deadline_entry_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'dedicated_points_deadline_entry_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'dedicated_points_deadline_entry_1'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'initial_registration_fee'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'pinning'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee_price_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee_price_5001_to_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee_price_1001_to_5000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee_rate_101_to_1000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'service_usage_fee_rate_1_to_100'?: number | null;
    /**
     * 
     * @type {ServiceUsagePatternEnum}
     * @memberof OrgAdminSettings
     */
    'service_usage_pattern'?: ServiceUsagePatternEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'balance_acquisition_api_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'grant_api_usage'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'file_linkage_cost'?: number | null;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'file_linkage_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select
     * @type {PointJpyRateEnum}
     * @memberof OrgAdminSettings
     */
    'point_jpy_rate'?: PointJpyRateEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'tax_difference'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'thanks_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'thanks_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'grant_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'normal_expiry_term_period'?: string | null;
    /**
     * If sso function in use then enter the sso usability cost.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'sso_use_cost'?: number | null;
    /**
     * If grant api function in use then enter the grant usability cost.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'grant_api_cost'?: number | null;
    /**
     * If balance api function in use then enter the balance usability cost.
     * @type {number}
     * @memberof OrgAdminSettings
     */
    'balance_api_cost'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'sso_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettings
     */
    'company_code': string;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'bpf_invoice_output_flag'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {InvoiceOutputFlagEnum}
     * @memberof OrgAdminSettings
     */
    'invoice_output_flag'?: InvoiceOutputFlagEnum;
    /**
     * flag for monthly batch grant date
     * @type {boolean}
     * @memberof OrgAdminSettings
     */
    'monthly_batch_grant_flag'?: boolean;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettings
     */
    'grant_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
}
/**
 * 
 * @export
 * @interface OrgAdminSettingsRequest
 */
export interface OrgAdminSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'number_of_users_to_register'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'user_usage_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'site_id'?: string;
    /**
     * number of Months
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Display Email address in Footer or Not.
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'display_email_address'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'email_address'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'display_telephone_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'telephone_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'display_department_name'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'department_name'?: string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'enquiry_of_product'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'source_representation_of_delivery_mails'?: number;
    /**
     * Please fill in the notice to the user with 1,000 characters or less.             If you do not need any special notes, please be sure to leave them blank.             * In principle, the wording cannot be replaced.
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'special_notes'?: string;
    /**
     * It is a function that can give points that can only be \"granted\" to some              administrator privileges (GroupAdmin, Maneger). 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_exclusive_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_expiry_number_of_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_expiry_time_period'?: number;
    /**
     * The points that the user has This function allows you to give a gift to another user.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Select the pattern of the item for which you want to set gift points.Type a message
     * @type {ThanksPointPatternEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_point_pattern'?: ThanksPointPatternEnum;
    /**
     * Points to choose from(If not set, considered as free type) ex: 1000 for single or [100, 200] for multiple.
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'points_to_send'?: string | null;
    /**
     * Maximum point that can be given.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'max_points'?: number | null;
    /**
     * Minimum points that can be given.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'min_points'?: number | null;
    /**
     * Please select the range of points to be awarded.
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_giving_range'?: PointGiftingRangeEnum;
    /**
     * This function allows you to exchange messages (chat)              between the user who gave the points and the user who receive the points.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thread_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * In response to the point donation application from the user             This is a function for the administrator to confirm the content of the gift              and then approve or deny it.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_point_approval_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     *  It is a function that can give users points that can only be \"gifted\"                  (points cannot be exchanged).
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_exclusive_points_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * It is a setting whether to allow the receiving user to re-donate the          points donated using the Sunkus exclusive points to other users.         * If you select \"No re-donation\", the points donated using the Sunkus exclusive          points can only be used for \"Point exchange\".
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'allow_points_regifting'?: PointGiftingRangeEnum;
    /**
     * When a thank-you point arrives at the user This is the email you will              be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_point_arrived_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * For user, point donation application This is an email notifying you of              the approval / rejection results.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'approval_result_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * The number of points donation applications waiting for approval to the              administrator This is the email you will be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'approval_pending_count_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_expiry_number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'self_pay_enabled'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'point_course_category'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'taxation_category'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'payment_method'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'payment_period'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'payment_period_in_months'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'payment_due_date'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'others_payment_due_date'?: string | null;
    /**
     * 
     * @type {ServiceUsageFeeEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee'?: ServiceUsageFeeEnum | null;
    /**
     * If you select free above, it will be fixed at 0 yen.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee_for_other'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_receipt_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_balance_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_expiry_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'apply_confirmation_mail_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'mail_magazine_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'password_reset_request_function'?: BpfInvoiceOutputFlagEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'updated_by'?: number | null;
    /**
     * Please select.
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'latest_transaction'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_point_delete_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * Note this is not an URL, it\'s a file path only. JTech don\'t wantto change it and BOJ agreeed.
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'membership_term_url'?: string | null;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'membership_agreement'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_revocation_notification'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'gift_notification_mail_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * it is necessary to use Sunkus dedicated point function
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'approval_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'need_to_use_thread_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_gifting_range'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'sunkus_point_deadline'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'fixed_point'?: number | null;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'dead_line_for_gathering'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_1'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'initial_registration_fee'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'pinning'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee_price_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee_price_5001_to_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee_price_1001_to_5000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee_rate_101_to_1000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_fee_rate_1_to_100'?: number | null;
    /**
     * 
     * @type {ServiceUsagePatternEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'service_usage_pattern'?: ServiceUsagePatternEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'balance_acquisition_api_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_api_usage'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'file_linkage_cost'?: number | null;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'file_linkage_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select
     * @type {PointJpyRateEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'point_jpy_rate'?: PointJpyRateEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'tax_difference'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'thanks_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'normal_expiry_term_period'?: string | null;
    /**
     * If sso function in use then enter the sso usability cost.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'sso_use_cost'?: number | null;
    /**
     * If grant api function in use then enter the grant usability cost.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_api_cost'?: number | null;
    /**
     * If balance api function in use then enter the balance usability cost.
     * @type {number}
     * @memberof OrgAdminSettingsRequest
     */
    'balance_api_cost'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'sso_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof OrgAdminSettingsRequest
     */
    'company_code': string;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'bpf_invoice_output_flag'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {InvoiceOutputFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'invoice_output_flag'?: InvoiceOutputFlagEnum;
    /**
     * flag for monthly batch grant date
     * @type {boolean}
     * @memberof OrgAdminSettingsRequest
     */
    'monthly_batch_grant_flag'?: boolean;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrgAdminSettingsRequest
     */
    'grant_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
}
/**
 * 
 * @export
 * @interface OrganizationAdminSettings
 */
export interface OrganizationAdminSettings {
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'id': number;
    /**
     * Organization ID from the AUTH system
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'organization': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'number_of_users_to_register': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'user_usage_start_date': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'site_id': string;
    /**
     * number of Months
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Display Email address in Footer or Not.
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettings
     */
    'display_email_address'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'email_address': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'display_telephone_number': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'telephone_number': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'display_department_name': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'department_name': string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'enquiry_of_product'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'source_representation_of_delivery_mails': number;
    /**
     * Please fill in the notice to the user with 1,000 characters or less.             If you do not need any special notes, please be sure to leave them blank.             * In principle, the wording cannot be replaced.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'special_notes'?: string;
    /**
     * It is a function that can give points that can only be \"granted\" to some              administrator privileges (GroupAdmin, Maneger). 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'grant_exclusive_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'grant_expiry_number_of_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'grant_expiry_time_period': number;
    /**
     * The points that the user has This function allows you to give a gift to another user.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Select the pattern of the item for which you want to set gift points.Type a message
     * @type {ThanksPointPatternEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_point_pattern'?: ThanksPointPatternEnum;
    /**
     * Points to choose from(If not set, considered as free type) ex: 1000 for single or [100, 200] for multiple.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'points_to_send'?: string | null;
    /**
     * Maximum point that can be given.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'max_points'?: number | null;
    /**
     * Minimum points that can be given.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'min_points'?: number | null;
    /**
     * Please select the range of points to be awarded.
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_giving_range'?: PointGiftingRangeEnum;
    /**
     * This function allows you to exchange messages (chat)              between the user who gave the points and the user who receive the points.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thread_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * In response to the point donation application from the user             This is a function for the administrator to confirm the content of the gift              and then approve or deny it.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_point_approval_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     *  It is a function that can give users points that can only be \"gifted\"                  (points cannot be exchanged).
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_exclusive_points_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * It is a setting whether to allow the receiving user to re-donate the          points donated using the Sunkus exclusive points to other users.         * If you select \"No re-donation\", the points donated using the Sunkus exclusive          points can only be used for \"Point exchange\".
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettings
     */
    'allow_points_regifting'?: PointGiftingRangeEnum;
    /**
     * When a thank-you point arrives at the user This is the email you will              be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_point_arrived_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * For user, point donation application This is an email notifying you of              the approval / rejection results.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'approval_result_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * The number of points donation applications waiting for approval to the              administrator This is the email you will be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'approval_pending_count_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'thanks_expiry_number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'self_pay_enabled': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'point_course_category': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'taxation_category': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'payment_method': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'payment_period': number;
    /**
     * Items to be entered when Other is selected above.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'payment_period_in_months'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'payment_due_date': number;
    /**
     * Items to be entered when Other is selected above.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'others_payment_due_date'?: string | null;
    /**
     * 
     * @type {ServiceUsageFeeEnum}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee'?: ServiceUsageFeeEnum | null;
    /**
     * If you select free above, it will be fixed at 0 yen.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee_for_other'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_receipt_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_balance_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_expiry_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'apply_confirmation_mail_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'mail_magazine_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'password_reset_request_function'?: BpfInvoiceOutputFlagEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'updated_by'?: number | null;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'created_at': string;
    /**
     * The last update time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'updated_at': string;
    /**
     * Please select.
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'latest_transaction'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'grant_point_delete_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * Note this is not an URL, it\'s a file path only. JTech don\'t wantto change it and BOJ agreeed.
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'membership_term_url'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof OrganizationAdminSettings
     */
    'footer_membership_url': any;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettings
     */
    'membership_agreement'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_revocation_notification'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'gift_notification_mail_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * it is necessary to use Sunkus dedicated point function
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'sunkus_dedicated_point_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'approval_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'need_to_use_thread_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_gifting_range'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'sunkus_point_deadline'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'sunkus_dedicated_point_gift_deadline_1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'fixed_point'?: number | null;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'dead_line_for_gathering'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'dedicated_points_deadline_entry_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'dedicated_points_deadline_entry_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'dedicated_points_deadline_entry_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'dedicated_points_deadline_entry_1'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'initial_registration_fee': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'pinning'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee_price_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee_price_5001_to_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee_price_1001_to_5000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee_rate_101_to_1000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_fee_rate_1_to_100'?: number | null;
    /**
     * 
     * @type {ServiceUsagePatternEnum}
     * @memberof OrganizationAdminSettings
     */
    'service_usage_pattern'?: ServiceUsagePatternEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'balance_acquisition_api_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'grant_api_usage'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'file_linkage_cost'?: number | null;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'file_linkage_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select
     * @type {PointJpyRateEnum}
     * @memberof OrganizationAdminSettings
     */
    'point_jpy_rate'?: PointJpyRateEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'tax_difference': number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'thanks_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'thanks_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'grant_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'normal_expiry_term_period'?: string | null;
    /**
     * If sso function in use then enter the sso usability cost.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'sso_use_cost'?: number | null;
    /**
     * If grant api function in use then enter the grant usability cost.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'grant_api_cost'?: number | null;
    /**
     * If balance api function in use then enter the balance usability cost.
     * @type {number}
     * @memberof OrganizationAdminSettings
     */
    'balance_api_cost'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'sso_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettings
     */
    'company_code': string;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'bpf_invoice_output_flag'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {InvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'invoice_output_flag'?: InvoiceOutputFlagEnum;
    /**
     * flag for monthly batch grant date
     * @type {boolean}
     * @memberof OrganizationAdminSettings
     */
    'monthly_batch_grant_flag'?: boolean;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettings
     */
    'grant_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
}
/**
 * 
 * @export
 * @interface OrganizationAdminSettingsList200Response
 */
export interface OrganizationAdminSettingsList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof OrganizationAdminSettingsList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof OrganizationAdminSettingsList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof OrganizationAdminSettingsList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<OrganizationAdminSettings>}
     * @memberof OrganizationAdminSettingsList200Response
     */
    'results'?: Array<OrganizationAdminSettings>;
}
/**
 * 
 * @export
 * @interface OrganizationAdminSettingsRequest
 */
export interface OrganizationAdminSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'number_of_users_to_register': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'user_usage_start_date': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'site_id': string;
    /**
     * number of Months
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Display Email address in Footer or Not.
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'display_email_address'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'email_address': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'display_telephone_number': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'telephone_number': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'display_department_name': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'department_name': string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'enquiry_of_product'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'source_representation_of_delivery_mails': number;
    /**
     * Please fill in the notice to the user with 1,000 characters or less.             If you do not need any special notes, please be sure to leave them blank.             * In principle, the wording cannot be replaced.
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'special_notes'?: string;
    /**
     * It is a function that can give points that can only be \"granted\" to some              administrator privileges (GroupAdmin, Maneger). 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_exclusive_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_expiry_number_of_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_expiry_time_period': number;
    /**
     * The points that the user has This function allows you to give a gift to another user.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Select the pattern of the item for which you want to set gift points.Type a message
     * @type {ThanksPointPatternEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_point_pattern'?: ThanksPointPatternEnum;
    /**
     * Points to choose from(If not set, considered as free type) ex: 1000 for single or [100, 200] for multiple.
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'points_to_send'?: string | null;
    /**
     * Maximum point that can be given.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'max_points'?: number | null;
    /**
     * Minimum points that can be given.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'min_points'?: number | null;
    /**
     * Please select the range of points to be awarded.
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_giving_range'?: PointGiftingRangeEnum;
    /**
     * This function allows you to exchange messages (chat)              between the user who gave the points and the user who receive the points.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thread_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * In response to the point donation application from the user             This is a function for the administrator to confirm the content of the gift              and then approve or deny it.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_point_approval_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     *  It is a function that can give users points that can only be \"gifted\"                  (points cannot be exchanged).
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_exclusive_points_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * It is a setting whether to allow the receiving user to re-donate the          points donated using the Sunkus exclusive points to other users.         * If you select \"No re-donation\", the points donated using the Sunkus exclusive          points can only be used for \"Point exchange\".
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'allow_points_regifting'?: PointGiftingRangeEnum;
    /**
     * When a thank-you point arrives at the user This is the email you will              be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_point_arrived_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * For user, point donation application This is an email notifying you of              the approval / rejection results.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'approval_result_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * The number of points donation applications waiting for approval to the              administrator This is the email you will be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'approval_pending_count_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_expiry_number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'self_pay_enabled': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_course_category': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'taxation_category': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'payment_method': number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'payment_period': number;
    /**
     * Items to be entered when Other is selected above.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'payment_period_in_months'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'payment_due_date': number;
    /**
     * Items to be entered when Other is selected above.
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'others_payment_due_date'?: string | null;
    /**
     * 
     * @type {ServiceUsageFeeEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee'?: ServiceUsageFeeEnum | null;
    /**
     * If you select free above, it will be fixed at 0 yen.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee_for_other'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_receipt_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_balance_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_expiry_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'apply_confirmation_mail_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'mail_magazine_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'password_reset_request_function'?: BpfInvoiceOutputFlagEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'updated_by'?: number | null;
    /**
     * Please select.
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'latest_transaction'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_point_delete_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * Note this is not an URL, it\'s a file path only. JTech don\'t wantto change it and BOJ agreeed.
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'membership_term_url'?: string | null;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'membership_agreement'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_revocation_notification'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'gift_notification_mail_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * it is necessary to use Sunkus dedicated point function
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'approval_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'need_to_use_thread_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_gifting_range'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sunkus_point_deadline'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'fixed_point'?: number | null;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'dead_line_for_gathering'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_1'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'initial_registration_fee': string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'pinning'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee_price_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee_price_5001_to_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee_price_1001_to_5000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee_rate_101_to_1000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_fee_rate_1_to_100'?: number | null;
    /**
     * 
     * @type {ServiceUsagePatternEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'service_usage_pattern'?: ServiceUsagePatternEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'balance_acquisition_api_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_api_usage'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'file_linkage_cost'?: number | null;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'file_linkage_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select
     * @type {PointJpyRateEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'point_jpy_rate'?: PointJpyRateEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'tax_difference': number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'thanks_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'normal_expiry_term_period'?: string | null;
    /**
     * If sso function in use then enter the sso usability cost.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sso_use_cost'?: number | null;
    /**
     * If grant api function in use then enter the grant usability cost.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_api_cost'?: number | null;
    /**
     * If balance api function in use then enter the balance usability cost.
     * @type {number}
     * @memberof OrganizationAdminSettingsRequest
     */
    'balance_api_cost'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'sso_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminSettingsRequest
     */
    'company_code': string;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'bpf_invoice_output_flag'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {InvoiceOutputFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'invoice_output_flag'?: InvoiceOutputFlagEnum;
    /**
     * flag for monthly batch grant date
     * @type {boolean}
     * @memberof OrganizationAdminSettingsRequest
     */
    'monthly_batch_grant_flag'?: boolean;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof OrganizationAdminSettingsRequest
     */
    'grant_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
}
/**
 * 
 * @export
 * @interface OrganizationFooter
 */
export interface OrganizationFooter {
    /**
     * Organization ID from the AUTH system
     * @type {number}
     * @memberof OrganizationFooter
     */
    'organization': number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationFooter
     */
    'site_id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationFooter
     */
    'contact_department_name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationFooter
     */
    'contact_email_address': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationFooter
     */
    'contact_phone_number': string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof OrganizationFooter
     */
    'enquiry_of_product'?: string;
}
/**
 * 
 * @export
 * @interface OrganizationPageCustomization
 */
export interface OrganizationPageCustomization {
    /**
     * Organization ID from the AUTH system
     * @type {number}
     * @memberof OrganizationPageCustomization
     */
    'organization': number;
    /**
     * this will be used in the HTML title of every page
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'page_title': string;
    /**
     * logo on top left of header, best 320x48 png file. The response should be a full URL
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'page_logo'?: string;
    /**
     * favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'favicon'?: string;
    /**
     * change the color of some element. use hex or color name that\'s supported by HTML
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'page_color': string;
    /**
     * \'pt\', \'point\', or other name of the point
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'point_name': string;
    /**
     * logo used in front of point count. Best 120x120 png file. The response should be a full URL
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'point_logo'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationPageCustomization
     */
    'default_thanks_message': string;
}
/**
 * 
 * @export
 * @interface OrganizationPageCustomizationList200Response
 */
export interface OrganizationPageCustomizationList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof OrganizationPageCustomizationList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof OrganizationPageCustomizationList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof OrganizationPageCustomizationList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<OrganizationPageCustomization>}
     * @memberof OrganizationPageCustomizationList200Response
     */
    'results'?: Array<OrganizationPageCustomization>;
}
/**
 * 
 * @export
 * @interface PGActivation
 */
export interface PGActivation {
    /**
     * 
     * @type {string}
     * @memberof PGActivation
     */
    'pg_redirect_url': string;
}
/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * Message title
     * @type {string}
     * @memberof Page
     */
    'title': string;
    /**
     * The Primary Key of the message
     * @type {string}
     * @memberof Page
     */
    'url': string;
}
/**
 * More details about the current message
 * @export
 * @interface PageDetail
 */
export interface PageDetail {
    /**
     * 
     * @type {PageDetailPrevious}
     * @memberof PageDetail
     */
    'previous': PageDetailPrevious;
    /**
     * 
     * @type {PageDetailNext}
     * @memberof PageDetail
     */
    'next': PageDetailNext;
}
/**
 * Brief info about the next message available message in the organization
 * @export
 * @interface PageDetailNext
 */
export interface PageDetailNext {
    /**
     * Message title
     * @type {string}
     * @memberof PageDetailNext
     */
    'title': string;
    /**
     * The Primary Key of the message
     * @type {string}
     * @memberof PageDetailNext
     */
    'url': string;
}
/**
 * Brief info about the previous available message in the organization
 * @export
 * @interface PageDetailPrevious
 */
export interface PageDetailPrevious {
    /**
     * Message title
     * @type {string}
     * @memberof PageDetailPrevious
     */
    'title': string;
    /**
     * The Primary Key of the message
     * @type {string}
     * @memberof PageDetailPrevious
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface PatchedBulkUpdateThanksGivingRequest
 */
export interface PatchedBulkUpdateThanksGivingRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedBulkUpdateThanksGivingRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedBulkUpdateThanksGivingRequest
     */
    'approver_comment'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedBulkUpdateThanksGivingRequest
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PatchedGrantCriteriaMoveByOneRequest
 */
export interface PatchedGrantCriteriaMoveByOneRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedGrantCriteriaMoveByOneRequest
     */
    'id'?: number;
    /**
     * 
     * @type {DirectionEnum}
     * @memberof PatchedGrantCriteriaMoveByOneRequest
     */
    'direction'?: DirectionEnum;
    /**
     * 
     * @type {SortingEnum}
     * @memberof PatchedGrantCriteriaMoveByOneRequest
     */
    'sorting'?: SortingEnum;
}
/**
 * 
 * @export
 * @interface PatchedGrantCriteriaPatchRequest
 */
export interface PatchedGrantCriteriaPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'points'?: number;
    /**
     * 
     * @type {KindEnum}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'kind'?: KindEnum;
    /**
     * Random unique id (easy to remember) given by admin to a grant criteria.
     * @type {string}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'grant_criteria_id'?: string | null;
    /**
     * Used to store the icon id for grant criteria.
     * @type {number}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'grant_criteria_icon_id'?: number | null;
    /**
     * Order given by admin user will reflect for general user
     * @type {number}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'order'?: number;
    /**
     * Helps to identify the dummy Grant Criteria needed only for giving Grant Point once.
     * @type {boolean}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'is_dummy'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof PatchedGrantCriteriaPatchRequest
     */
    'groups'?: Array<any>;
}
/**
 * 
 * @export
 * @interface PatchedGrantPointRequest
 */
export interface PatchedGrantPointRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'authorize_date'?: string;
    /**
     * 
     * @type {GrantTypeEnum}
     * @memberof PatchedGrantPointRequest
     */
    'grant_type'?: GrantTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'group_code_at_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'group_name_at_time'?: string;
    /**
     * Soft deletion date and time.
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'deleted_at'?: string | null;
    /**
     * Used to store the alternate icon id for grant criteria.
     * @type {number}
     * @memberof PatchedGrantPointRequest
     */
    'icon_id'?: number | null;
    /**
     * Used to store the modified points while giving grant points.
     * @type {number}
     * @memberof PatchedGrantPointRequest
     */
    'points'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedGrantPointRequest
     */
    'updated_by'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'gift_deadline'?: string | null;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof PatchedGrantPointRequest
     */
    'from_group'?: number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof PatchedGrantPointRequest
     */
    'to_group'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'expire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'thanks_exclusive_deadline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedGrantPointRequest
     */
    'grant_only_deadline'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedInformationMessageAdminUpdateRequest
 */
export interface PatchedInformationMessageAdminUpdateRequest {
    /**
     * Whats new message title
     * @type {string}
     * @memberof PatchedInformationMessageAdminUpdateRequest
     */
    'title'?: string;
    /**
     * The message content. Note FE need to render this properly
     * @type {string}
     * @memberof PatchedInformationMessageAdminUpdateRequest
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface PatchedOrgAdminSettingsRequest
 */
export interface PatchedOrgAdminSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'number_of_users_to_register'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'user_usage_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'site_id'?: string;
    /**
     * number of Months
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Display Email address in Footer or Not.
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'display_email_address'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'email_address'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'display_telephone_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'telephone_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'display_department_name'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'department_name'?: string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'enquiry_of_product'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'source_representation_of_delivery_mails'?: number;
    /**
     * Please fill in the notice to the user with 1,000 characters or less.             If you do not need any special notes, please be sure to leave them blank.             * In principle, the wording cannot be replaced.
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'special_notes'?: string;
    /**
     * It is a function that can give points that can only be \"granted\" to some              administrator privileges (GroupAdmin, Maneger). 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_exclusive_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_expiry_number_of_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_expiry_time_period'?: number;
    /**
     * The points that the user has This function allows you to give a gift to another user.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Select the pattern of the item for which you want to set gift points.Type a message
     * @type {ThanksPointPatternEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_point_pattern'?: ThanksPointPatternEnum;
    /**
     * Points to choose from(If not set, considered as free type) ex: 1000 for single or [100, 200] for multiple.
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'points_to_send'?: string | null;
    /**
     * Maximum point that can be given.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'max_points'?: number | null;
    /**
     * Minimum points that can be given.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'min_points'?: number | null;
    /**
     * Please select the range of points to be awarded.
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_giving_range'?: PointGiftingRangeEnum;
    /**
     * This function allows you to exchange messages (chat)              between the user who gave the points and the user who receive the points.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thread_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * In response to the point donation application from the user             This is a function for the administrator to confirm the content of the gift              and then approve or deny it.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_point_approval_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     *  It is a function that can give users points that can only be \"gifted\"                  (points cannot be exchanged).
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_exclusive_points_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * It is a setting whether to allow the receiving user to re-donate the          points donated using the Sunkus exclusive points to other users.         * If you select \"No re-donation\", the points donated using the Sunkus exclusive          points can only be used for \"Point exchange\".
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'allow_points_regifting'?: PointGiftingRangeEnum;
    /**
     * When a thank-you point arrives at the user This is the email you will              be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_point_arrived_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * For user, point donation application This is an email notifying you of              the approval / rejection results.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'approval_result_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * The number of points donation applications waiting for approval to the              administrator This is the email you will be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'approval_pending_count_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_expiry_number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'self_pay_enabled'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_course_category'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'taxation_category'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'payment_method'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'payment_period'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'payment_period_in_months'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'payment_due_date'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'others_payment_due_date'?: string | null;
    /**
     * 
     * @type {ServiceUsageFeeEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee'?: ServiceUsageFeeEnum | null;
    /**
     * If you select free above, it will be fixed at 0 yen.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee_for_other'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_receipt_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_balance_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_expiry_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'apply_confirmation_mail_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'mail_magazine_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'password_reset_request_function'?: BpfInvoiceOutputFlagEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'updated_by'?: number | null;
    /**
     * Please select.
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'latest_transaction'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_point_delete_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * Note this is not an URL, it\'s a file path only. JTech don\'t wantto change it and BOJ agreeed.
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'membership_term_url'?: string | null;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'membership_agreement'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_revocation_notification'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'gift_notification_mail_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * it is necessary to use Sunkus dedicated point function
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'approval_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'need_to_use_thread_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_gifting_range'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sunkus_point_deadline'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'fixed_point'?: number | null;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'dead_line_for_gathering'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_1'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'initial_registration_fee'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'pinning'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee_price_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee_price_5001_to_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee_price_1001_to_5000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee_rate_101_to_1000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_fee_rate_1_to_100'?: number | null;
    /**
     * 
     * @type {ServiceUsagePatternEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'service_usage_pattern'?: ServiceUsagePatternEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'balance_acquisition_api_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_api_usage'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'file_linkage_cost'?: number | null;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'file_linkage_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select
     * @type {PointJpyRateEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'point_jpy_rate'?: PointJpyRateEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'tax_difference'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'thanks_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'normal_expiry_term_period'?: string | null;
    /**
     * If sso function in use then enter the sso usability cost.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sso_use_cost'?: number | null;
    /**
     * If grant api function in use then enter the grant usability cost.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_api_cost'?: number | null;
    /**
     * If balance api function in use then enter the balance usability cost.
     * @type {number}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'balance_api_cost'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'sso_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'company_code'?: string;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'bpf_invoice_output_flag'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {InvoiceOutputFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'invoice_output_flag'?: InvoiceOutputFlagEnum;
    /**
     * flag for monthly batch grant date
     * @type {boolean}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'monthly_batch_grant_flag'?: boolean;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrgAdminSettingsRequest
     */
    'grant_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
}
/**
 * 
 * @export
 * @interface PatchedOrganizationAdminSettingsRequest
 */
export interface PatchedOrganizationAdminSettingsRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'number_of_users_to_register'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'user_usage_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'site_id'?: string;
    /**
     * number of Months
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Display Email address in Footer or Not.
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'display_email_address'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'email_address'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'display_telephone_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'telephone_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'display_department_name'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'department_name'?: string;
    /**
     * Company\'s Enquiry of Product Link.
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'enquiry_of_product'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'source_representation_of_delivery_mails'?: number;
    /**
     * Please fill in the notice to the user with 1,000 characters or less.             If you do not need any special notes, please be sure to leave them blank.             * In principle, the wording cannot be replaced.
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'special_notes'?: string;
    /**
     * It is a function that can give points that can only be \"granted\" to some              administrator privileges (GroupAdmin, Maneger). 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_exclusive_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_expiry_number_of_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_expiry_time_period'?: number;
    /**
     * The points that the user has This function allows you to give a gift to another user.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_point_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Select the pattern of the item for which you want to set gift points.Type a message
     * @type {ThanksPointPatternEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_point_pattern'?: ThanksPointPatternEnum;
    /**
     * Points to choose from(If not set, considered as free type) ex: 1000 for single or [100, 200] for multiple.
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'points_to_send'?: string | null;
    /**
     * Maximum point that can be given.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'max_points'?: number | null;
    /**
     * Minimum points that can be given.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'min_points'?: number | null;
    /**
     * Please select the range of points to be awarded.
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_giving_range'?: PointGiftingRangeEnum;
    /**
     * This function allows you to exchange messages (chat)              between the user who gave the points and the user who receive the points.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thread_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * In response to the point donation application from the user             This is a function for the administrator to confirm the content of the gift              and then approve or deny it.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_point_approval_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     *  It is a function that can give users points that can only be \"gifted\"                  (points cannot be exchanged).
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_exclusive_points_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * It is a setting whether to allow the receiving user to re-donate the          points donated using the Sunkus exclusive points to other users.         * If you select \"No re-donation\", the points donated using the Sunkus exclusive          points can only be used for \"Point exchange\".
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'allow_points_regifting'?: PointGiftingRangeEnum;
    /**
     * When a thank-you point arrives at the user This is the email you will              be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_point_arrived_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * For user, point donation application This is an email notifying you of              the approval / rejection results.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'approval_result_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * The number of points donation applications waiting for approval to the              administrator This is the email you will be notified of.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'approval_pending_count_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * number of Months
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_expiry_number_of_months'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_expiry_time_period'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'self_pay_enabled'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_course_category'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'taxation_category'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'payment_method'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'payment_period'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'payment_period_in_months'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'payment_due_date'?: number;
    /**
     * Items to be entered when Other is selected above.
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'others_payment_due_date'?: string | null;
    /**
     * 
     * @type {ServiceUsageFeeEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee'?: ServiceUsageFeeEnum | null;
    /**
     * If you select free above, it will be fixed at 0 yen.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee_for_other'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_receipt_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_balance_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_expiry_notification_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'apply_confirmation_mail_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'mail_magazine_enabled'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'password_reset_request_function'?: BpfInvoiceOutputFlagEnum;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'created_by'?: number | null;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'updated_by'?: number | null;
    /**
     * Please select.
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'latest_transaction'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_point_delete_notification_mail'?: BpfInvoiceOutputFlagEnum;
    /**
     * Note this is not an URL, it\'s a file path only. JTech don\'t wantto change it and BOJ agreeed.
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'membership_term_url'?: string | null;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'membership_agreement'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_revocation_notification'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'gift_notification_mail_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * it is necessary to use Sunkus dedicated point function
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'approval_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'need_to_use_thread_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {PointGiftingRangeEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_gifting_range'?: PointGiftingRangeEnum;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sunkus_point_deadline'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sunkus_dedicated_point_gift_deadline_1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'fixed_point'?: number | null;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'dead_line_for_gathering'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'dedicated_points_deadline_entry_1'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'initial_registration_fee'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'pinning'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee_price_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee_price_5001_to_10000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee_price_1001_to_5000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee_rate_101_to_1000'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_fee_rate_1_to_100'?: number | null;
    /**
     * 
     * @type {ServiceUsagePatternEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'service_usage_pattern'?: ServiceUsagePatternEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'balance_acquisition_api_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_api_usage'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'file_linkage_cost'?: number | null;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'file_linkage_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * Please select
     * @type {PointJpyRateEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'point_jpy_rate'?: PointJpyRateEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'tax_difference'?: number;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'thanks_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_expiry_term_period'?: string | null;
    /**
     * Enter MM-DD format e.g: 05-21
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'normal_expiry_term_period'?: string | null;
    /**
     * If sso function in use then enter the sso usability cost.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sso_use_cost'?: number | null;
    /**
     * If grant api function in use then enter the grant usability cost.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_api_cost'?: number | null;
    /**
     * If balance api function in use then enter the balance usability cost.
     * @type {number}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'balance_api_cost'?: number | null;
    /**
     * Please select whether to use or not.
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'sso_function_usability'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'company_code'?: string;
    /**
     * 
     * @type {BpfInvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'bpf_invoice_output_flag'?: BpfInvoiceOutputFlagEnum;
    /**
     * 
     * @type {InvoiceOutputFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'invoice_output_flag'?: InvoiceOutputFlagEnum;
    /**
     * flag for monthly batch grant date
     * @type {boolean}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'monthly_batch_grant_flag'?: boolean;
    /**
     * 
     * @type {GrantExclusivePointsInvoiceFlagEnum}
     * @memberof PatchedOrganizationAdminSettingsRequest
     */
    'grant_exclusive_points_invoice_flag'?: GrantExclusivePointsInvoiceFlagEnum;
}
/**
 * 
 * @export
 * @interface PatchedPersonalAddressRequest
 */
export interface PatchedPersonalAddressRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedPersonalAddressRequest
     */
    'user'?: number;
    /**
     * Name for personal address
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'zip_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'prefecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'municipality'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPersonalAddressRequest
     */
    'address_line_2'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedPointNotificationRequest
 */
export interface PatchedPointNotificationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPointNotificationRequest
     */
    'has_read'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedRedemptionRequest
 */
export interface PatchedRedemptionRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedRedemptionRequest
     */
    'user'?: number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof PatchedRedemptionRequest
     */
    'group'?: number;
    /**
     * total use point
     * @type {number}
     * @memberof PatchedRedemptionRequest
     */
    'total_use_point'?: number;
    /**
     * total use amount in yen
     * @type {number}
     * @memberof PatchedRedemptionRequest
     */
    'total_use_price'?: number;
    /**
     * tax on total use amount
     * @type {number}
     * @memberof PatchedRedemptionRequest
     */
    'total_tax'?: number;
    /**
     * total use amount with tax
     * @type {number}
     * @memberof PatchedRedemptionRequest
     */
    'total_use_price_in_tax'?: number;
}
/**
 * 
 * @export
 * @interface PatchedRedemptionShippingAddressRequest
 */
export interface PatchedRedemptionShippingAddressRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'user'?: number;
    /**
     * Name for redemption shipping address
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'name'?: string;
    /**
     * Email for redemption shipping address
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'zip_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'prefecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'municipality'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'address_line_1'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedRedemptionShippingAddressRequest
     */
    'address_line_2'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedShoppingCartItemRequest
 */
export interface PatchedShoppingCartItemRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedShoppingCartItemRequest
     */
    'user'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedShoppingCartItemRequest
     */
    'sku_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedShoppingCartItemRequest
     */
    'quantity'?: number;
    /**
     * extra option type with value
     * @type {string}
     * @memberof PatchedShoppingCartItemRequest
     */
    'option_type_extra'?: string | null;
    /**
     * Benepo customer number
     * @type {string}
     * @memberof PatchedShoppingCartItemRequest
     */
    'customer_no'?: string;
    /**
     * Benepo torino no
     * @type {string}
     * @memberof PatchedShoppingCartItemRequest
     */
    'torino_no'?: string;
}
/**
 * 
 * @export
 * @interface PatchedThanksGivingAdminPatchRequest
 */
export interface PatchedThanksGivingAdminPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchedThanksGivingAdminPatchRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedThanksGivingAdminPatchRequest
     */
    'approver_comment'?: string;
}
/**
 * 
 * @export
 * @interface PatchedThanksGivingMessageReadRequest
 */
export interface PatchedThanksGivingMessageReadRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PatchedThanksGivingMessageReadRequest
     */
    'has_read'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedUserNotificationSettingsRequest
 */
export interface PatchedUserNotificationSettingsRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedUserNotificationSettingsRequest
     */
    'user'?: number;
    /**
     * Point receipt notification via email
     * @type {boolean}
     * @memberof PatchedUserNotificationSettingsRequest
     */
    'point_receipt'?: boolean;
    /**
     * Point balance notification via email
     * @type {boolean}
     * @memberof PatchedUserNotificationSettingsRequest
     */
    'point_balance'?: boolean;
    /**
     * Point expiration date notification via email
     * @type {boolean}
     * @memberof PatchedUserNotificationSettingsRequest
     */
    'point_expiration_date'?: boolean;
    /**
     * Thanks point approval or rejection notification via email
     * @type {boolean}
     * @memberof PatchedUserNotificationSettingsRequest
     */
    'thanks_point_result'?: boolean;
    /**
     * E-magazine via email
     * @type {boolean}
     * @memberof PatchedUserNotificationSettingsRequest
     */
    'magazine'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedVoucherAddressRequest
 */
export interface PatchedVoucherAddressRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedVoucherAddressRequest
     */
    'user'?: number;
    /**
     * Email for voucher
     * @type {string}
     * @memberof PatchedVoucherAddressRequest
     */
    'email'?: string;
    /**
     * both pre-purchased coupon code and gift code from e-gift
     * @type {string}
     * @memberof PatchedVoucherAddressRequest
     */
    'voucher_code'?: string | null;
}
/**
 * 
 * @export
 * @interface PersonalAddress
 */
export interface PersonalAddress {
    /**
     * 
     * @type {number}
     * @memberof PersonalAddress
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PersonalAddress
     */
    'user': number;
    /**
     * Name for personal address
     * @type {string}
     * @memberof PersonalAddress
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddress
     */
    'zip_code': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddress
     */
    'prefecture': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddress
     */
    'municipality': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddress
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddress
     */
    'address_line_1': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddress
     */
    'address_line_2'?: string | null;
}
/**
 * 
 * @export
 * @interface PersonalAddressList200Response
 */
export interface PersonalAddressList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PersonalAddressList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PersonalAddressList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PersonalAddressList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PersonalAddress>}
     * @memberof PersonalAddressList200Response
     */
    'results'?: Array<PersonalAddress>;
}
/**
 * 
 * @export
 * @interface PersonalAddressRequest
 */
export interface PersonalAddressRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PersonalAddressRequest
     */
    'user': number;
    /**
     * Name for personal address
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'zip_code': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'prefecture': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'municipality': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'address_line_1': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAddressRequest
     */
    'address_line_2'?: string | null;
}
/**
 * 
 * @export
 * @interface PersonalPointHistory
 */
export interface PersonalPointHistory {
    /**
     * 
     * @type {number}
     * @memberof PersonalPointHistory
     */
    'pk': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PersonalPointHistory
     */
    'user': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof PersonalPointHistory
     */
    'group': number;
    /**
     * 
     * @type {number}
     * @memberof PersonalPointHistory
     */
    'points'?: number;
    /**
     * 
     * @type {Transaction}
     * @memberof PersonalPointHistory
     */
    'transaction': Transaction;
}
/**
 * 
 * @export
 * @interface PointExpiryHistory
 */
export interface PointExpiryHistory {
    /**
     * 
     * @type {number}
     * @memberof PointExpiryHistory
     */
    'pk': number;
    /**
     * 
     * @type {string}
     * @memberof PointExpiryHistory
     */
    'expiry_date': string;
    /**
     * 
     * @type {number}
     * @memberof PointExpiryHistory
     */
    'points': number;
    /**
     * for getting points only
     * @type {number}
     * @memberof PointExpiryHistory
     */
    'remaining_points'?: number | null;
    /**
     * 
     * @type {PointTypeEnum}
     * @memberof PointExpiryHistory
     */
    'point_type'?: PointTypeEnum;
    /**
     * Transaction type
     * @type {number}
     * @memberof PointExpiryHistory
     */
    'transaction_type': number;
    /**
     * Transaction type name
     * @type {string}
     * @memberof PointExpiryHistory
     */
    'transaction_type_name': string;
    /**
     * Transaction details object
     * @type {{ [key: string]: any; }}
     * @memberof PointExpiryHistory
     */
    'transaction_details': { [key: string]: any; };
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof PointExpiryHistory
     */
    'group': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PointGiftingRangeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type PointGiftingRangeEnum = typeof PointGiftingRangeEnum[keyof typeof PointGiftingRangeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const PointJpyRateEnum = {
    NUMBER_1: 1,
    NUMBER_5: 5,
    NUMBER_10: 10,
    NUMBER_50: 50,
    NUMBER_100: 100,
    NUMBER_2000: 2000
} as const;

export type PointJpyRateEnum = typeof PointJpyRateEnum[keyof typeof PointJpyRateEnum];


/**
 * 
 * @export
 * @interface PointNotification
 */
export interface PointNotification {
    /**
     * 
     * @type {number}
     * @memberof PointNotification
     */
    'pk': number;
    /**
     * 
     * @type {number}
     * @memberof PointNotification
     */
    'points': number;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof PointNotification
     */
    'to_user': RicCustomUser;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof PointNotification
     */
    'from_user': RicCustomUser;
    /**
     * 
     * @type {NotificationTypeEnum}
     * @memberof PointNotification
     */
    'notification_type': NotificationTypeEnum;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof PointNotification
     */
    'created_at': string;
    /**
     * A notification content is provided for describing the action.
     * @type {string}
     * @memberof PointNotification
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof PointNotification
     */
    'has_read'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PointNotification
     */
    'notification_type_display': string;
    /**
     * 
     * @type {Transaction}
     * @memberof PointNotification
     */
    'transaction': Transaction;
    /**
     * 
     * @type {string}
     * @memberof PointNotification
     */
    'grant_criteria_name': string;
}
/**
 * 
 * @export
 * @interface PointNotificationList200Response
 */
export interface PointNotificationList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PointNotificationList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PointNotificationList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PointNotificationList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PointNotification>}
     * @memberof PointNotificationList200Response
     */
    'results'?: Array<PointNotification>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PointTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7
} as const;

export type PointTypeEnum = typeof PointTypeEnum[keyof typeof PointTypeEnum];


/**
 * 
 * @export
 * @interface PointUsageList202Response
 */
export interface PointUsageList202Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PointUsageList202Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PointUsageList202Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PointUsageList202Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Task>}
     * @memberof PointUsageList202Response
     */
    'results'?: Array<Task>;
}
/**
 * 
 * @export
 * @interface PointsHistoryList200Response
 */
export interface PointsHistoryList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof PointsHistoryList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof PointsHistoryList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof PointsHistoryList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PersonalPointHistory>}
     * @memberof PointsHistoryList200Response
     */
    'results'?: Array<PersonalPointHistory>;
}
/**
 * 
 * @export
 * @interface RandomUserAvatar
 */
export interface RandomUserAvatar {
    /**
     * 
     * @type {number}
     * @memberof RandomUserAvatar
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RandomUserAvatar
     */
    'avatar': string;
}
/**
 * 
 * @export
 * @interface Redemption
 */
export interface Redemption {
    /**
     * 
     * @type {number}
     * @memberof Redemption
     */
    'pk': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof Redemption
     */
    'user': number;
    /**
     * 
     * @type {RedemptionShippingAddress}
     * @memberof Redemption
     */
    'shipping_address': RedemptionShippingAddress;
    /**
     * 
     * @type {RedemptionVoucherAddress}
     * @memberof Redemption
     */
    'voucher_address': RedemptionVoucherAddress;
    /**
     * Detail of the redemption, like SKU and quantity
     * @type {Array<RedemptionDetails>}
     * @memberof Redemption
     */
    'redemption_details': Array<RedemptionDetails>;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof Redemption
     */
    'group': number;
    /**
     * total use point
     * @type {number}
     * @memberof Redemption
     */
    'total_use_point': number;
    /**
     * total use amount in yen
     * @type {number}
     * @memberof Redemption
     */
    'total_use_price': number;
    /**
     * tax on total use amount
     * @type {number}
     * @memberof Redemption
     */
    'total_tax': number;
    /**
     * total use amount with tax
     * @type {number}
     * @memberof Redemption
     */
    'total_use_price_in_tax': number;
    /**
     * 
     * @type {RedemptionCreditCardDetails}
     * @memberof Redemption
     */
    'credit_card_details': RedemptionCreditCardDetails;
}
/**
 * credit card details for this redemption
 * @export
 * @interface RedemptionCreditCardDetails
 */
export interface RedemptionCreditCardDetails {
    /**
     * 
     * @type {number}
     * @memberof RedemptionCreditCardDetails
     */
    'id': number;
    /**
     * credit card point required
     * @type {number}
     * @memberof RedemptionCreditCardDetails
     */
    'credit_use_point': number;
    /**
     * credit card amount in yen
     * @type {number}
     * @memberof RedemptionCreditCardDetails
     */
    'credit_use_price': number;
    /**
     * tax on credit card amount
     * @type {number}
     * @memberof RedemptionCreditCardDetails
     */
    'credit_tax': number;
    /**
     * total credit card amount with tax
     * @type {number}
     * @memberof RedemptionCreditCardDetails
     */
    'credit_use_price_in_tax': number;
}
/**
 * 
 * @export
 * @interface RedemptionDetails
 */
export interface RedemptionDetails {
    /**
     * 
     * @type {number}
     * @memberof RedemptionDetails
     */
    'pk': number;
    /**
     * SKU_ID in RSS DB
     * @type {number}
     * @memberof RedemptionDetails
     */
    'sku': number;
    /**
     * 
     * @type {number}
     * @memberof RedemptionDetails
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface RedemptionDetailsRequest
 */
export interface RedemptionDetailsRequest {
    /**
     * SKU_ID in RSS DB
     * @type {number}
     * @memberof RedemptionDetailsRequest
     */
    'sku': number;
    /**
     * 
     * @type {number}
     * @memberof RedemptionDetailsRequest
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface RedemptionList200Response
 */
export interface RedemptionList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof RedemptionList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof RedemptionList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof RedemptionList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Redemption>}
     * @memberof RedemptionList200Response
     */
    'results'?: Array<Redemption>;
}
/**
 * 
 * @export
 * @interface RedemptionRequest
 */
export interface RedemptionRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof RedemptionRequest
     */
    'user': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof RedemptionRequest
     */
    'group': number;
    /**
     * total use point
     * @type {number}
     * @memberof RedemptionRequest
     */
    'total_use_point': number;
    /**
     * total use amount in yen
     * @type {number}
     * @memberof RedemptionRequest
     */
    'total_use_price': number;
    /**
     * tax on total use amount
     * @type {number}
     * @memberof RedemptionRequest
     */
    'total_tax': number;
    /**
     * total use amount with tax
     * @type {number}
     * @memberof RedemptionRequest
     */
    'total_use_price_in_tax': number;
}
/**
 * 
 * @export
 * @interface RedemptionRequestRequest
 */
export interface RedemptionRequestRequest {
    /**
     * 
     * @type {RedemptionTypeEnum}
     * @memberof RedemptionRequestRequest
     */
    'redemption_type': RedemptionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof RedemptionRequestRequest
     */
    'shipping_address'?: number;
    /**
     * 
     * @type {number}
     * @memberof RedemptionRequestRequest
     */
    'voucher_address'?: number;
}
/**
 * 
 * @export
 * @interface RedemptionResponse
 */
export interface RedemptionResponse {
    /**
     * 
     * @type {RedemptionStatusEnum}
     * @memberof RedemptionResponse
     */
    'redemption_status': RedemptionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof RedemptionResponse
     */
    'redemption': number;
    /**
     * 
     * @type {number}
     * @memberof RedemptionResponse
     */
    'transaction': number;
    /**
     * 
     * @type {string}
     * @memberof RedemptionResponse
     */
    'task_id'?: string;
}
/**
 * shipping address for this redemption
 * @export
 * @interface RedemptionShippingAddress
 */
export interface RedemptionShippingAddress {
    /**
     * 
     * @type {number}
     * @memberof RedemptionShippingAddress
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof RedemptionShippingAddress
     */
    'user': number;
    /**
     * Name for redemption shipping address
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'name': string;
    /**
     * Email for redemption shipping address
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'zip_code': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'prefecture': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'municipality': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'address_line_1': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddress
     */
    'address_line_2'?: string | null;
}
/**
 * 
 * @export
 * @interface RedemptionShippingAddressList200Response
 */
export interface RedemptionShippingAddressList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof RedemptionShippingAddressList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof RedemptionShippingAddressList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof RedemptionShippingAddressList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<RedemptionShippingAddress>}
     * @memberof RedemptionShippingAddressList200Response
     */
    'results'?: Array<RedemptionShippingAddress>;
}
/**
 * 
 * @export
 * @interface RedemptionShippingAddressRequest
 */
export interface RedemptionShippingAddressRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof RedemptionShippingAddressRequest
     */
    'user': number;
    /**
     * Name for redemption shipping address
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'name': string;
    /**
     * Email for redemption shipping address
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'zip_code': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'prefecture': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'municipality': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'address_line_1': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionShippingAddressRequest
     */
    'address_line_2'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RedemptionStatusEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;

export type RedemptionStatusEnum = typeof RedemptionStatusEnum[keyof typeof RedemptionStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const RedemptionTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type RedemptionTypeEnum = typeof RedemptionTypeEnum[keyof typeof RedemptionTypeEnum];


/**
 * voucher address for this redemption
 * @export
 * @interface RedemptionVoucherAddress
 */
export interface RedemptionVoucherAddress {
    /**
     * 
     * @type {number}
     * @memberof RedemptionVoucherAddress
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof RedemptionVoucherAddress
     */
    'user': number;
    /**
     * Email for voucher
     * @type {string}
     * @memberof RedemptionVoucherAddress
     */
    'email': string;
    /**
     * both pre-purchased coupon code and gift code from e-gift
     * @type {string}
     * @memberof RedemptionVoucherAddress
     */
    'voucher_code'?: string | null;
}
/**
 * 
 * @export
 * @interface RicCustomUser
 */
export interface RicCustomUser {
    /**
     * 
     * @type {number}
     * @memberof RicCustomUser
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RicCustomUser
     */
    'user_name': string;
    /**
     * 
     * @type {string}
     * @memberof RicCustomUser
     */
    'user_image': string;
    /**
     * 
     * @type {string}
     * @memberof RicCustomUser
     */
    'group_name': string;
    /**
     * 
     * @type {number}
     * @memberof RicCustomUser
     */
    'group_id': number;
    /**
     * 
     * @type {string}
     * @memberof RicCustomUser
     */
    'role_name': string;
    /**
     * 
     * @type {string}
     * @memberof RicCustomUser
     */
    'role_type': string;
    /**
     * 
     * @type {number}
     * @memberof RicCustomUser
     */
    'role_id': number;
    /**
     * 
     * @type {string}
     * @memberof RicCustomUser
     */
    'group_code': string;
}
/**
 * 
 * @export
 * @interface RicGroup
 */
export interface RicGroup {
    /**
     * 
     * @type {number}
     * @memberof RicGroup
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RicGroup
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RicGroup
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RicGroup
     */
    'hierarchy': string;
    /**
     * 
     * @type {number}
     * @memberof RicGroup
     */
    'organization': number;
    /**
     * 
     * @type {number}
     * @memberof RicGroup
     */
    'parent_group': number;
    /**
     * 
     * @type {number}
     * @memberof RicGroup
     */
    'users_count': number;
    /**
     * 
     * @type {number}
     * @memberof RicGroup
     */
    'sub_groups_count': number;
    /**
     * 
     * @type {string}
     * @memberof RicGroup
     */
    'parent_group_name': string;
}
/**
 * AWS S3 PreSigned URL
 * @export
 * @interface S3UploadURLResponse
 */
export interface S3UploadURLResponse {
    /**
     * 
     * @type {string}
     * @memberof S3UploadURLResponse
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface SKUData
 */
export interface SKUData {
    /**
     * 
     * @type {string}
     * @memberof SKUData
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SKUData
     */
    'premium': number;
    /**
     * 
     * @type {string}
     * @memberof SKUData
     */
    'menu_no': string;
    /**
     * 
     * @type {number}
     * @memberof SKUData
     */
    'point_required': number;
    /**
     * 
     * @type {boolean}
     * @memberof SKUData
     */
    'is_quantity_control': boolean;
    /**
     * 
     * @type {number}
     * @memberof SKUData
     */
    'available_quantity': number;
    /**
     * 
     * @type {string}
     * @memberof SKUData
     */
    'options': string;
    /**
     * 
     * @type {boolean}
     * @memberof SKUData
     */
    'is_new': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SKUData
     */
    'is_featured': boolean;
    /**
     * 
     * @type {string}
     * @memberof SKUData
     */
    'image_url': string;
    /**
     * 
     * @type {number}
     * @memberof SKUData
     */
    'redemption_type': number;
}
/**
 * 
 * @export
 * @interface SearchThanksGivingByUserList200Response
 */
export interface SearchThanksGivingByUserList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof SearchThanksGivingByUserList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof SearchThanksGivingByUserList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof SearchThanksGivingByUserList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ThanksGivingSearchByUser>}
     * @memberof SearchThanksGivingByUserList200Response
     */
    'results'?: Array<ThanksGivingSearchByUser>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceUsageFeeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type ServiceUsageFeeEnum = typeof ServiceUsageFeeEnum[keyof typeof ServiceUsageFeeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const ServiceUsagePatternEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ServiceUsagePatternEnum = typeof ServiceUsagePatternEnum[keyof typeof ServiceUsagePatternEnum];


/**
 * 
 * @export
 * @interface ShoppingCartItem
 */
export interface ShoppingCartItem {
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItem
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof ShoppingCartItem
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItem
     */
    'sku_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItem
     */
    'quantity': number;
    /**
     * extra option type with value
     * @type {string}
     * @memberof ShoppingCartItem
     */
    'option_type_extra'?: string | null;
    /**
     * Benepo customer number
     * @type {string}
     * @memberof ShoppingCartItem
     */
    'customer_no'?: string;
    /**
     * Benepo torino no
     * @type {string}
     * @memberof ShoppingCartItem
     */
    'torino_no'?: string;
}
/**
 * 
 * @export
 * @interface ShoppingCartItemList
 */
export interface ShoppingCartItemList {
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItemList
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof ShoppingCartItemList
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItemList
     */
    'sku_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItemList
     */
    'quantity': number;
    /**
     * extra option type with value
     * @type {string}
     * @memberof ShoppingCartItemList
     */
    'option_type_extra'?: string | null;
    /**
     * 
     * @type {SKUData}
     * @memberof ShoppingCartItemList
     */
    'sku_data': SKUData;
}
/**
 * 
 * @export
 * @interface ShoppingCartItemList200Response
 */
export interface ShoppingCartItemList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof ShoppingCartItemList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof ShoppingCartItemList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof ShoppingCartItemList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ShoppingCartItemList>}
     * @memberof ShoppingCartItemList200Response
     */
    'results'?: Array<ShoppingCartItemList>;
}
/**
 * 
 * @export
 * @interface ShoppingCartItemRequest
 */
export interface ShoppingCartItemRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof ShoppingCartItemRequest
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItemRequest
     */
    'sku_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartItemRequest
     */
    'quantity': number;
    /**
     * extra option type with value
     * @type {string}
     * @memberof ShoppingCartItemRequest
     */
    'option_type_extra'?: string | null;
    /**
     * Benepo customer number
     * @type {string}
     * @memberof ShoppingCartItemRequest
     */
    'customer_no'?: string;
    /**
     * Benepo torino no
     * @type {string}
     * @memberof ShoppingCartItemRequest
     */
    'torino_no'?: string;
}
/**
 * 
 * @export
 * @interface ShoppingCartPointSummary
 */
export interface ShoppingCartPointSummary {
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'total_shopping_cart_item': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'total_points': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'used_points': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'credit_card_points': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'credit_card_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'base_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'tax_amount': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'tax_rate': number;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartPointSummary
     */
    'remaining_points': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortingEnum = {
    Ascending: 'ascending',
    Descending: 'descending'
} as const;

export type SortingEnum = typeof SortingEnum[keyof typeof SortingEnum];


/**
 * 
 * @export
 * @interface SystemNotificationsList200Response
 */
export interface SystemNotificationsList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof SystemNotificationsList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof SystemNotificationsList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof SystemNotificationsList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<InformationMessage>}
     * @memberof SystemNotificationsList200Response
     */
    'results'?: Array<InformationMessage>;
}
/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    'task_id': string;
}
/**
 * 
 * @export
 * @interface ThanksGiving
 */
export interface ThanksGiving {
    /**
     * 
     * @type {number}
     * @memberof ThanksGiving
     */
    'pk': number;
    /**
     * A title is provided when thanks point are given.
     * @type {string}
     * @memberof ThanksGiving
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ThanksGiving
     */
    'status': string;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGiving
     */
    'from_user': RicCustomUser;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGiving
     */
    'to_user': RicCustomUser;
    /**
     * 
     * @type {number}
     * @memberof ThanksGiving
     */
    'points': number;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof ThanksGiving
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ThanksGiving
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof ThanksGiving
     */
    'has_read': boolean;
    /**
     * 
     * @type {string}
     * @memberof ThanksGiving
     */
    'message_type': string;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGiving
     */
    'approval': RicCustomUser;
    /**
     * 
     * @type {string}
     * @memberof ThanksGiving
     */
    'expires_at': string;
    /**
     * Field to store approval or rejection date time of thanks giving.
     * @type {string}
     * @memberof ThanksGiving
     */
    'approved_or_rejected_at'?: string | null;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGiving
     */
    'from_group': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGiving
     */
    'to_group': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGiving
     */
    'approver_group': number;
}
/**
 * 
 * @export
 * @interface ThanksGivingAdminGet
 */
export interface ThanksGivingAdminGet {
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingAdminGet
     */
    'pk': number;
    /**
     * A title is provided when thanks point are given.
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'status': string;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGivingAdminGet
     */
    'from_user': RicCustomUser;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGivingAdminGet
     */
    'to_user': RicCustomUser;
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingAdminGet
     */
    'points': number;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'message': string;
    /**
     * Comments made by approver while apprvoing or rejecting the thanks giving
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'approver_comment'?: string;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGivingAdminGet
     */
    'approval': RicCustomUser;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'created_date': string;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'expires_at': string;
    /**
     * Field to store approval or rejection date time of thanks giving.
     * @type {string}
     * @memberof ThanksGivingAdminGet
     */
    'approved_or_rejected_at'?: string | null;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGivingAdminGet
     */
    'to_group': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGivingAdminGet
     */
    'from_group': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGivingAdminGet
     */
    'approver_group': number;
}
/**
 * 
 * @export
 * @interface ThanksGivingMessageCreateRequest
 */
export interface ThanksGivingMessageCreateRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof ThanksGivingMessageCreateRequest
     */
    'to_user': number;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingMessageCreateRequest
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingMessageCreateRequest
     */
    'parent'?: number | null;
}
/**
 * 
 * @export
 * @interface ThanksGivingMessageList
 */
export interface ThanksGivingMessageList {
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingMessageList
     */
    'pk': number;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGivingMessageList
     */
    'from_user': RicCustomUser;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGivingMessageList
     */
    'to_user': RicCustomUser;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingMessageList
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingMessageList
     */
    'parent'?: number | null;
    /**
     * The creation time, always in Asia/Tokyo timezone.
     * @type {string}
     * @memberof ThanksGivingMessageList
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingMessageList
     */
    'thanks_giving': number;
    /**
     * 
     * @type {boolean}
     * @memberof ThanksGivingMessageList
     */
    'sender_is_logged_in_user': boolean;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGivingMessageList
     */
    'to_group': number;
    /**
     * Group ID from the Authentication system
     * @type {number}
     * @memberof ThanksGivingMessageList
     */
    'from_group': number;
    /**
     * 
     * @type {string}
     * @memberof ThanksGivingMessageList
     */
    'thanks_giving_title': string;
}
/**
 * 
 * @export
 * @interface ThanksGivingMessageList200Response
 */
export interface ThanksGivingMessageList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof ThanksGivingMessageList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof ThanksGivingMessageList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof ThanksGivingMessageList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ThanksGivingMessageList>}
     * @memberof ThanksGivingMessageList200Response
     */
    'results'?: Array<ThanksGivingMessageList>;
}
/**
 * 
 * @export
 * @interface ThanksGivingMessageRead
 */
export interface ThanksGivingMessageRead {
    /**
     * 
     * @type {boolean}
     * @memberof ThanksGivingMessageRead
     */
    'has_read'?: boolean;
}
/**
 * 
 * @export
 * @interface ThanksGivingSearchByUser
 */
export interface ThanksGivingSearchByUser {
    /**
     * 
     * @type {number}
     * @memberof ThanksGivingSearchByUser
     */
    'thanks_giving_count': number;
    /**
     * 
     * @type {RicCustomUser}
     * @memberof ThanksGivingSearchByUser
     */
    'user': RicCustomUser;
}
/**
 * 
 * @export
 * @interface ThanksPointList200Response
 */
export interface ThanksPointList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof ThanksPointList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof ThanksPointList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof ThanksPointList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ThanksGiving>}
     * @memberof ThanksPointList200Response
     */
    'results'?: Array<ThanksGiving>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ThanksPointPatternEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type ThanksPointPatternEnum = typeof ThanksPointPatternEnum[keyof typeof ThanksPointPatternEnum];


/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'pk': number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'points'?: number;
    /**
     * 
     * @type {TransactionTypeEnum}
     * @memberof Transaction
     */
    'transaction_type': TransactionTypeEnum;
    /**
     * Transaction type name
     * @type {string}
     * @memberof Transaction
     */
    'transaction_type_name': string;
    /**
     * Transaction details object
     * @type {{ [key: string]: any; }}
     * @memberof Transaction
     */
    'transaction_details': { [key: string]: any; };
    /**
     * The expiry date of the points. If it involves multiple sources, return the earliest one
     * @type {string}
     * @memberof Transaction
     */
    'earliest_expiry_time': string;
}
/**
 * 
 * @export
 * @interface TransactionList200Response
 */
export interface TransactionList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof TransactionList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof TransactionList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof TransactionList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof TransactionList200Response
     */
    'results'?: Array<Transaction>;
}
/**
 * 
 * @export
 * @interface TransactionRequest
 */
export interface TransactionRequest {
    /**
     * 
     * @type {number}
     * @memberof TransactionRequest
     */
    'points'?: number;
    /**
     * 
     * @type {TransactionTypeEnum}
     * @memberof TransactionRequest
     */
    'transaction_type'?: TransactionTypeEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TransactionTypeEnum = {
    NUMBER_10: 10,
    NUMBER_20: 20,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_50: 50,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_80: 80
} as const;

export type TransactionTypeEnum = typeof TransactionTypeEnum[keyof typeof TransactionTypeEnum];


/**
 * 
 * @export
 * @interface UserAdminDashboardGroupSummary
 */
export interface UserAdminDashboardGroupSummary {
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'normal_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'total_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'thanks_exclusive_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'grant_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'redeemed_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'expired_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'monthly_expired_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'recieved_thanks_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'gifted_thanks_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardGroupSummary
     */
    'thanks_giving_pending_request': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserAdminDashboardGroupSummary
     */
    'user_info': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UserAdminDashboardSummary
 */
export interface UserAdminDashboardSummary {
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardSummary
     */
    'normal_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardSummary
     */
    'total_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardSummary
     */
    'thanks_exclusive_points': number;
    /**
     * 
     * @type {string}
     * @memberof UserAdminDashboardSummary
     */
    'last_login': string;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardSummary
     */
    'login_counter': number;
    /**
     * 
     * @type {number}
     * @memberof UserAdminDashboardSummary
     */
    'grant_points': number;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminDashboardSummary
     */
    'admin_user': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminDashboardSummary
     */
    'thanks_point_flag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminDashboardSummary
     */
    'grant_point_flag': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAdminDashboardSummary
     */
    'user_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminDashboardSummary
     */
    'user_image': string;
}
/**
 * 
 * @export
 * @interface UserCountSummary
 */
export interface UserCountSummary {
    /**
     * 
     * @type {number}
     * @memberof UserCountSummary
     */
    'total_shopping_cart_item': number;
    /**
     * 
     * @type {number}
     * @memberof UserCountSummary
     */
    'total_unread_thanks_message': number;
    /**
     * 
     * @type {number}
     * @memberof UserCountSummary
     */
    'total_unread_whats_new_message': number;
    /**
     * 
     * @type {number}
     * @memberof UserCountSummary
     */
    'total_unread_message': number;
}
/**
 * 
 * @export
 * @interface UserDashboardGranCriteriaRanking
 */
export interface UserDashboardGranCriteriaRanking {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardGranCriteriaRanking
     */
    'grant_criteria_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardGranCriteriaRanking
     */
    'grant_criteria_times': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UserDashboardPointChart
 */
export interface UserDashboardPointChart {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardPointChart
     */
    'gift_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardPointChart
     */
    'donated_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardPointChart
     */
    'balanced_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardPointChart
     */
    'wipe_out': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardPointChart
     */
    'use': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardPointChart
     */
    'grant': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UserDashboardRanking
 */
export interface UserDashboardRanking {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardRanking
     */
    'gift_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserDashboardRanking
     */
    'donated_points': { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof UserDashboardRanking
     */
    'total_gift_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardRanking
     */
    'total_gift_times': number;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardRanking
     */
    'total_donated_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardRanking
     */
    'total_donated_times': number;
}
/**
 * 
 * @export
 * @interface UserDashboardSummary
 */
export interface UserDashboardSummary {
    /**
     * 
     * @type {number}
     * @memberof UserDashboardSummary
     */
    'normal_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardSummary
     */
    'total_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardSummary
     */
    'thanks_exclusive_points': number;
    /**
     * 
     * @type {string}
     * @memberof UserDashboardSummary
     */
    'last_login': string;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardSummary
     */
    'login_counter': number;
    /**
     * 
     * @type {number}
     * @memberof UserDashboardSummary
     */
    'grant_points': number;
    /**
     * 
     * @type {boolean}
     * @memberof UserDashboardSummary
     */
    'admin_user': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDashboardSummary
     */
    'thanks_point_flag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDashboardSummary
     */
    'grant_point_flag': boolean;
}
/**
 * 
 * @export
 * @interface UserGroupDashboardRanking
 */
export interface UserGroupDashboardRanking {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserGroupDashboardRanking
     */
    'gift_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserGroupDashboardRanking
     */
    'donated_points': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UserGroupDashboardRanking
     */
    'earn_points': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface UserNotificationSettings
 */
export interface UserNotificationSettings {
    /**
     * 
     * @type {number}
     * @memberof UserNotificationSettings
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof UserNotificationSettings
     */
    'user': number;
    /**
     * Point receipt notification via email
     * @type {boolean}
     * @memberof UserNotificationSettings
     */
    'point_receipt'?: boolean;
    /**
     * Point balance notification via email
     * @type {boolean}
     * @memberof UserNotificationSettings
     */
    'point_balance'?: boolean;
    /**
     * Point expiration date notification via email
     * @type {boolean}
     * @memberof UserNotificationSettings
     */
    'point_expiration_date'?: boolean;
    /**
     * Thanks point approval or rejection notification via email
     * @type {boolean}
     * @memberof UserNotificationSettings
     */
    'thanks_point_result'?: boolean;
    /**
     * E-magazine via email
     * @type {boolean}
     * @memberof UserNotificationSettings
     */
    'magazine'?: boolean;
}
/**
 * 
 * @export
 * @interface UserNotificationSettingsList200Response
 */
export interface UserNotificationSettingsList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof UserNotificationSettingsList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof UserNotificationSettingsList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof UserNotificationSettingsList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UserNotificationSettings>}
     * @memberof UserNotificationSettingsList200Response
     */
    'results'?: Array<UserNotificationSettings>;
}
/**
 * 
 * @export
 * @interface UserNotificationSettingsRequest
 */
export interface UserNotificationSettingsRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof UserNotificationSettingsRequest
     */
    'user': number;
    /**
     * Point receipt notification via email
     * @type {boolean}
     * @memberof UserNotificationSettingsRequest
     */
    'point_receipt'?: boolean;
    /**
     * Point balance notification via email
     * @type {boolean}
     * @memberof UserNotificationSettingsRequest
     */
    'point_balance'?: boolean;
    /**
     * Point expiration date notification via email
     * @type {boolean}
     * @memberof UserNotificationSettingsRequest
     */
    'point_expiration_date'?: boolean;
    /**
     * Thanks point approval or rejection notification via email
     * @type {boolean}
     * @memberof UserNotificationSettingsRequest
     */
    'thanks_point_result'?: boolean;
    /**
     * E-magazine via email
     * @type {boolean}
     * @memberof UserNotificationSettingsRequest
     */
    'magazine'?: boolean;
}
/**
 * 
 * @export
 * @interface UserPointDataList200Response
 */
export interface UserPointDataList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof UserPointDataList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof UserPointDataList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof UserPointDataList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CustomUser>}
     * @memberof UserPointDataList200Response
     */
    'results'?: Array<CustomUser>;
}
/**
 * 
 * @export
 * @interface UserProfileSummary
 */
export interface UserProfileSummary {
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'grant_only_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'total_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'thanks_exclusive_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'grant_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'points_expire_soon': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'points_expire_soon_count': number;
    /**
     * 
     * @type {string}
     * @memberof UserProfileSummary
     */
    'points_expire_soon_date': string;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'gifted_thanks_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'received_thanks_point': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'total_grant_points': number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileSummary
     */
    'total_received_thanks_point': number;
}
/**
 * 
 * @export
 * @interface VoucherAddress
 */
export interface VoucherAddress {
    /**
     * 
     * @type {number}
     * @memberof VoucherAddress
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof VoucherAddress
     */
    'user': number;
    /**
     * Email for voucher
     * @type {string}
     * @memberof VoucherAddress
     */
    'email': string;
    /**
     * both pre-purchased coupon code and gift code from e-gift
     * @type {string}
     * @memberof VoucherAddress
     */
    'voucher_code'?: string | null;
}
/**
 * 
 * @export
 * @interface VoucherAddressList200Response
 */
export interface VoucherAddressList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof VoucherAddressList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof VoucherAddressList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof VoucherAddressList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<VoucherAddress>}
     * @memberof VoucherAddressList200Response
     */
    'results'?: Array<VoucherAddress>;
}
/**
 * 
 * @export
 * @interface VoucherAddressRequest
 */
export interface VoucherAddressRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof VoucherAddressRequest
     */
    'user': number;
    /**
     * Email for voucher
     * @type {string}
     * @memberof VoucherAddressRequest
     */
    'email': string;
    /**
     * both pre-purchased coupon code and gift code from e-gift
     * @type {string}
     * @memberof VoucherAddressRequest
     */
    'voucher_code'?: string | null;
}
/**
 * 
 * @export
 * @interface WhatsNewAdminList200Response
 */
export interface WhatsNewAdminList200Response {
    /**
     * Total number of the result
     * @type {number}
     * @memberof WhatsNewAdminList200Response
     */
    'count'?: number;
    /**
     * Link to the next page of the result. `Null` if this is the last page.
     * @type {string}
     * @memberof WhatsNewAdminList200Response
     */
    'next'?: string | null;
    /**
     * Link to the previous page of the result. `Null` if this is the first page.
     * @type {string}
     * @memberof WhatsNewAdminList200Response
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<InformationMessageAdmin>}
     * @memberof WhatsNewAdminList200Response
     */
    'results'?: Array<InformationMessageAdmin>;
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * An API endpoint to update multiple thanks giving objects at one go.
         * @param {PatchedBulkUpdateThanksGivingRequest} [patchedBulkUpdateThanksGivingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBulkUpdateThanksGivingPartialUpdate: async (patchedBulkUpdateThanksGivingRequest?: PatchedBulkUpdateThanksGivingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/bulk_update_thanks_giving/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedBulkUpdateThanksGivingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} groupId group_id
         * @param {string} [createdMonth] limit to the given month. Could be combined with created_year
         * @param {string} [createdYear] limit to the given year. Could be combined with created_month
         * @param {string} [endDate] Filter by end date
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupDesignation] Designation of user group, Options :- (recipient / source / both)
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [pointsRange] points_range (example - 200,500)
         * @param {string} [startDate] Filter by start date
         * @param {string} [status] Filter by status, possible values(pending ,approved, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {string} [userDesignation] Designation of user, Options :- (recipient / source / both)
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingExportReportRetrieve: async (groupId: number, createdMonth?: string, createdYear?: string, endDate?: string, expired?: string, fromUser?: string, groupDesignation?: string, groupSearch?: string, pointsRange?: string, startDate?: string, status?: string, toUser?: string, userDesignation?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('adminThanksGivingExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/admin/thanks_giving/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupDesignation !== undefined) {
                localVarQueryParameter['group_designation'] = groupDesignation;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (pointsRange !== undefined) {
                localVarQueryParameter['points_range'] = pointsRange;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }

            if (userDesignation !== undefined) {
                localVarQueryParameter['user_designation'] = userDesignation;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingList: async (createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, page?: number, pageSize?: number, pointsRange?: string, search?: string, status?: string, toUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/thanks_giving/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pointsRange !== undefined) {
                localVarQueryParameter['points_range'] = pointsRange;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} id A unique integer value identifying this thanks giving.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {PatchedThanksGivingAdminPatchRequest} [patchedThanksGivingAdminPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingPartialUpdate: async (id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, patchedThanksGivingAdminPatchRequest?: PatchedThanksGivingAdminPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminThanksGivingPartialUpdate', 'id', id)
            const localVarPath = `/api/admin/thanks_giving/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (pointsRange !== undefined) {
                localVarQueryParameter['points_range'] = pointsRange;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedThanksGivingAdminPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} id A unique integer value identifying this thanks giving.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingRetrieve: async (id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminThanksGivingRetrieve', 'id', id)
            const localVarPath = `/api/admin/thanks_giving/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (pointsRange !== undefined) {
                localVarQueryParameter['points_range'] = pointsRange;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * An API endpoint to update multiple thanks giving objects at one go.
         * @param {PatchedBulkUpdateThanksGivingRequest} [patchedBulkUpdateThanksGivingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBulkUpdateThanksGivingPartialUpdate(patchedBulkUpdateThanksGivingRequest?: PatchedBulkUpdateThanksGivingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingAdminGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBulkUpdateThanksGivingPartialUpdate(patchedBulkUpdateThanksGivingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} groupId group_id
         * @param {string} [createdMonth] limit to the given month. Could be combined with created_year
         * @param {string} [createdYear] limit to the given year. Could be combined with created_month
         * @param {string} [endDate] Filter by end date
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupDesignation] Designation of user group, Options :- (recipient / source / both)
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [pointsRange] points_range (example - 200,500)
         * @param {string} [startDate] Filter by start date
         * @param {string} [status] Filter by status, possible values(pending ,approved, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {string} [userDesignation] Designation of user, Options :- (recipient / source / both)
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminThanksGivingExportReportRetrieve(groupId: number, createdMonth?: string, createdYear?: string, endDate?: string, expired?: string, fromUser?: string, groupDesignation?: string, groupSearch?: string, pointsRange?: string, startDate?: string, status?: string, toUser?: string, userDesignation?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminThanksGivingExportReportRetrieve(groupId, createdMonth, createdYear, endDate, expired, fromUser, groupDesignation, groupSearch, pointsRange, startDate, status, toUser, userDesignation, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminThanksGivingList(createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, page?: number, pageSize?: number, pointsRange?: string, search?: string, status?: string, toUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminThanksGivingList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminThanksGivingList(createdMonth, createdYear, expired, fromUser, groupId, page, pageSize, pointsRange, search, status, toUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} id A unique integer value identifying this thanks giving.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {PatchedThanksGivingAdminPatchRequest} [patchedThanksGivingAdminPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminThanksGivingPartialUpdate(id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, patchedThanksGivingAdminPatchRequest?: PatchedThanksGivingAdminPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingAdminGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminThanksGivingPartialUpdate(id, createdMonth, createdYear, expired, fromUser, groupId, pointsRange, search, status, toUser, patchedThanksGivingAdminPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} id A unique integer value identifying this thanks giving.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminThanksGivingRetrieve(id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingAdminGet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminThanksGivingRetrieve(id, createdMonth, createdYear, expired, fromUser, groupId, pointsRange, search, status, toUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * An API endpoint to update multiple thanks giving objects at one go.
         * @param {PatchedBulkUpdateThanksGivingRequest} [patchedBulkUpdateThanksGivingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBulkUpdateThanksGivingPartialUpdate(patchedBulkUpdateThanksGivingRequest?: PatchedBulkUpdateThanksGivingRequest, options?: any): AxiosPromise<ThanksGivingAdminGet> {
            return localVarFp.adminBulkUpdateThanksGivingPartialUpdate(patchedBulkUpdateThanksGivingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} groupId group_id
         * @param {string} [createdMonth] limit to the given month. Could be combined with created_year
         * @param {string} [createdYear] limit to the given year. Could be combined with created_month
         * @param {string} [endDate] Filter by end date
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupDesignation] Designation of user group, Options :- (recipient / source / both)
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [pointsRange] points_range (example - 200,500)
         * @param {string} [startDate] Filter by start date
         * @param {string} [status] Filter by status, possible values(pending ,approved, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {string} [userDesignation] Designation of user, Options :- (recipient / source / both)
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingExportReportRetrieve(groupId: number, createdMonth?: string, createdYear?: string, endDate?: string, expired?: string, fromUser?: string, groupDesignation?: string, groupSearch?: string, pointsRange?: string, startDate?: string, status?: string, toUser?: string, userDesignation?: string, userSearch?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.adminThanksGivingExportReportRetrieve(groupId, createdMonth, createdYear, endDate, expired, fromUser, groupDesignation, groupSearch, pointsRange, startDate, status, toUser, userDesignation, userSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingList(createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, page?: number, pageSize?: number, pointsRange?: string, search?: string, status?: string, toUser?: string, options?: any): AxiosPromise<AdminThanksGivingList200Response> {
            return localVarFp.adminThanksGivingList(createdMonth, createdYear, expired, fromUser, groupId, page, pageSize, pointsRange, search, status, toUser, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} id A unique integer value identifying this thanks giving.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {PatchedThanksGivingAdminPatchRequest} [patchedThanksGivingAdminPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingPartialUpdate(id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, patchedThanksGivingAdminPatchRequest?: PatchedThanksGivingAdminPatchRequest, options?: any): AxiosPromise<ThanksGivingAdminGet> {
            return localVarFp.adminThanksGivingPartialUpdate(id, createdMonth, createdYear, expired, fromUser, groupId, pointsRange, search, status, toUser, patchedThanksGivingAdminPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
         * @param {number} id A unique integer value identifying this thanks giving.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [expired] Filter expired points
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [pointsRange] points_range
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminThanksGivingRetrieve(id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, options?: any): AxiosPromise<ThanksGivingAdminGet> {
            return localVarFp.adminThanksGivingRetrieve(id, createdMonth, createdYear, expired, fromUser, groupId, pointsRange, search, status, toUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * An API endpoint to update multiple thanks giving objects at one go.
     * @param {PatchedBulkUpdateThanksGivingRequest} [patchedBulkUpdateThanksGivingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBulkUpdateThanksGivingPartialUpdate(patchedBulkUpdateThanksGivingRequest?: PatchedBulkUpdateThanksGivingRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBulkUpdateThanksGivingPartialUpdate(patchedBulkUpdateThanksGivingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
     * @param {number} groupId group_id
     * @param {string} [createdMonth] limit to the given month. Could be combined with created_year
     * @param {string} [createdYear] limit to the given year. Could be combined with created_month
     * @param {string} [endDate] Filter by end date
     * @param {string} [expired] Filter expired points
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupDesignation] Designation of user group, Options :- (recipient / source / both)
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {string} [pointsRange] points_range (example - 200,500)
     * @param {string} [startDate] Filter by start date
     * @param {string} [status] Filter by status, possible values(pending ,approved, rejected)
     * @param {string} [toUser] Filter by receiving user
     * @param {string} [userDesignation] Designation of user, Options :- (recipient / source / both)
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminThanksGivingExportReportRetrieve(groupId: number, createdMonth?: string, createdYear?: string, endDate?: string, expired?: string, fromUser?: string, groupDesignation?: string, groupSearch?: string, pointsRange?: string, startDate?: string, status?: string, toUser?: string, userDesignation?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminThanksGivingExportReportRetrieve(groupId, createdMonth, createdYear, endDate, expired, fromUser, groupDesignation, groupSearch, pointsRange, startDate, status, toUser, userDesignation, userSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [expired] Filter expired points
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [pointsRange] points_range
     * @param {string} [search] A search term.
     * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
     * @param {string} [toUser] Filter by receiving user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminThanksGivingList(createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, page?: number, pageSize?: number, pointsRange?: string, search?: string, status?: string, toUser?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminThanksGivingList(createdMonth, createdYear, expired, fromUser, groupId, page, pageSize, pointsRange, search, status, toUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
     * @param {number} id A unique integer value identifying this thanks giving.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [expired] Filter expired points
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {string} [pointsRange] points_range
     * @param {string} [search] A search term.
     * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
     * @param {string} [toUser] Filter by receiving user
     * @param {PatchedThanksGivingAdminPatchRequest} [patchedThanksGivingAdminPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminThanksGivingPartialUpdate(id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, patchedThanksGivingAdminPatchRequest?: PatchedThanksGivingAdminPatchRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminThanksGivingPartialUpdate(id, createdMonth, createdYear, expired, fromUser, groupId, pointsRange, search, status, toUser, patchedThanksGivingAdminPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to read and update Thanks Giving.  The List API will return a list of thanks points exchanged between two users of current users\' organization, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, status parameter.   - to filter by multiple status at same time we can call API like `?status=pending,rejected`   - can also be filtered by points in range using points_range  by passing 2 comma separated values   eg: `/?points_range=200,500` both values will be included  The Detail API will return the details of the Thanksgiving with the given ID. The PATCH request can be used to update the status of Thanksgiving to approved or rejected
     * @param {number} id A unique integer value identifying this thanks giving.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [expired] Filter expired points
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {string} [pointsRange] points_range
     * @param {string} [search] A search term.
     * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
     * @param {string} [toUser] Filter by receiving user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminThanksGivingRetrieve(id: number, createdMonth?: string, createdYear?: string, expired?: string, fromUser?: string, groupId?: string, pointsRange?: string, search?: string, status?: string, toUser?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminThanksGivingRetrieve(id, createdMonth, createdYear, expired, fromUser, groupId, pointsRange, search, status, toUser, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminDashboardGroupUsersInfoApi - axios parameter creator
 * @export
 */
export const AdminDashboardGroupUsersInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in admin user to get the details of all the groups from which he belong to.  With the group information admin user will also get basic information of child groups and the user who present in the groups
         * @param {number} [groupId] Filter by group_id, to fetch the data for a specific group from                            which admin user belongs to
         * @param {string} [ordering] Which field to use when ordering the results
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [parentGroup] Filter by parent group id.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDashboardGroupUsersInfoRetrieve: async (groupId?: number, ordering?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin_dashboard_group_users_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (parentGroup !== undefined) {
                localVarQueryParameter['parent_group'] = parentGroup;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDashboardGroupUsersInfoApi - functional programming interface
 * @export
 */
export const AdminDashboardGroupUsersInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDashboardGroupUsersInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to get the details of all the groups from which he belong to.  With the group information admin user will also get basic information of child groups and the user who present in the groups
         * @param {number} [groupId] Filter by group_id, to fetch the data for a specific group from                            which admin user belongs to
         * @param {string} [ordering] Which field to use when ordering the results
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [parentGroup] Filter by parent group id.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDashboardGroupUsersInfoRetrieve(groupId?: number, ordering?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardGroupUsers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDashboardGroupUsersInfoRetrieve(groupId, ordering, page, pageSize, parentGroup, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminDashboardGroupUsersInfoApi - factory interface
 * @export
 */
export const AdminDashboardGroupUsersInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDashboardGroupUsersInfoApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to get the details of all the groups from which he belong to.  With the group information admin user will also get basic information of child groups and the user who present in the groups
         * @param {number} [groupId] Filter by group_id, to fetch the data for a specific group from                            which admin user belongs to
         * @param {string} [ordering] Which field to use when ordering the results
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [parentGroup] Filter by parent group id.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDashboardGroupUsersInfoRetrieve(groupId?: number, ordering?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options?: any): AxiosPromise<AdminDashboardGroupUsers> {
            return localVarFp.adminDashboardGroupUsersInfoRetrieve(groupId, ordering, page, pageSize, parentGroup, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDashboardGroupUsersInfoApi - object-oriented interface
 * @export
 * @class AdminDashboardGroupUsersInfoApi
 * @extends {BaseAPI}
 */
export class AdminDashboardGroupUsersInfoApi extends BaseAPI {
    /**
     * API endpoint that allows logged in admin user to get the details of all the groups from which he belong to.  With the group information admin user will also get basic information of child groups and the user who present in the groups
     * @param {number} [groupId] Filter by group_id, to fetch the data for a specific group from                            which admin user belongs to
     * @param {string} [ordering] Which field to use when ordering the results
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [parentGroup] Filter by parent group id.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDashboardGroupUsersInfoApi
     */
    public adminDashboardGroupUsersInfoRetrieve(groupId?: number, ordering?: string, page?: number, pageSize?: number, parentGroup?: string, search?: string, options?: AxiosRequestConfig) {
        return AdminDashboardGroupUsersInfoApiFp(this.configuration).adminDashboardGroupUsersInfoRetrieve(groupId, ordering, page, pageSize, parentGroup, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminUserDashboardRankingApi - axios parameter creator
 * @export
 */
export const AdminUserDashboardRankingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserDashboardRankingRetrieve: async (endDate: string, groupId: number, startDate: string, userId: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('adminUserDashboardRankingRetrieve', 'endDate', endDate)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('adminUserDashboardRankingRetrieve', 'groupId', groupId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminUserDashboardRankingRetrieve', 'startDate', startDate)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUserDashboardRankingRetrieve', 'userId', userId)
            const localVarPath = `/api/admin_user_dashboard_ranking/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserDashboardRankingApi - functional programming interface
 * @export
 */
export const AdminUserDashboardRankingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserDashboardRankingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserDashboardRankingRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardRanking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserDashboardRankingRetrieve(endDate, groupId, startDate, userId, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUserDashboardRankingApi - factory interface
 * @export
 */
export const AdminUserDashboardRankingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserDashboardRankingApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserDashboardRankingRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: any): AxiosPromise<UserDashboardRanking> {
            return localVarFp.adminUserDashboardRankingRetrieve(endDate, groupId, startDate, userId, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserDashboardRankingApi - object-oriented interface
 * @export
 * @class AdminUserDashboardRankingApi
 * @extends {BaseAPI}
 */
export class AdminUserDashboardRankingApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
     * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
     * @param {number} userId Filter by user id, if logged in user is a admin user
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserDashboardRankingApi
     */
    public adminUserDashboardRankingRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: AxiosRequestConfig) {
        return AdminUserDashboardRankingApiFp(this.configuration).adminUserDashboardRankingRetrieve(endDate, groupId, startDate, userId, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminUserGrantCriteriaRankingApi - axios parameter creator
 * @export
 */
export const AdminUserGrantCriteriaRankingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserGrantCriteriaRankingRetrieve: async (endDate: string, groupId: number, startDate: string, userId: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('adminUserGrantCriteriaRankingRetrieve', 'endDate', endDate)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('adminUserGrantCriteriaRankingRetrieve', 'groupId', groupId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminUserGrantCriteriaRankingRetrieve', 'startDate', startDate)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUserGrantCriteriaRankingRetrieve', 'userId', userId)
            const localVarPath = `/api/admin-user-grant-criteria-ranking/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserGrantCriteriaRankingApi - functional programming interface
 * @export
 */
export const AdminUserGrantCriteriaRankingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserGrantCriteriaRankingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserGrantCriteriaRankingRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardGranCriteriaRanking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserGrantCriteriaRankingRetrieve(endDate, groupId, startDate, userId, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUserGrantCriteriaRankingApi - factory interface
 * @export
 */
export const AdminUserGrantCriteriaRankingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserGrantCriteriaRankingApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserGrantCriteriaRankingRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: any): AxiosPromise<UserDashboardGranCriteriaRanking> {
            return localVarFp.adminUserGrantCriteriaRankingRetrieve(endDate, groupId, startDate, userId, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserGrantCriteriaRankingApi - object-oriented interface
 * @export
 * @class AdminUserGrantCriteriaRankingApi
 * @extends {BaseAPI}
 */
export class AdminUserGrantCriteriaRankingApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
     * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
     * @param {number} userId Filter by user id, if logged in user is a admin user
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserGrantCriteriaRankingApi
     */
    public adminUserGrantCriteriaRankingRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: AxiosRequestConfig) {
        return AdminUserGrantCriteriaRankingApiFp(this.configuration).adminUserGrantCriteriaRankingRetrieve(endDate, groupId, startDate, userId, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminUserPointStatusApi - axios parameter creator
 * @export
 */
export const AdminUserPointStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
         * @param {string} endDate Filter by end date
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Filter by start date
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserPointStatusRetrieve: async (endDate: string, groupId: number, startDate: string, userId: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('adminUserPointStatusRetrieve', 'endDate', endDate)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('adminUserPointStatusRetrieve', 'groupId', groupId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminUserPointStatusRetrieve', 'startDate', startDate)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUserPointStatusRetrieve', 'userId', userId)
            const localVarPath = `/api/admin_user_point_status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserPointStatusApi - functional programming interface
 * @export
 */
export const AdminUserPointStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserPointStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
         * @param {string} endDate Filter by end date
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Filter by start date
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserPointStatusRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardPointChart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserPointStatusRetrieve(endDate, groupId, startDate, userId, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUserPointStatusApi - factory interface
 * @export
 */
export const AdminUserPointStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserPointStatusApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
         * @param {string} endDate Filter by end date
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Filter by start date
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserPointStatusRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: any): AxiosPromise<UserDashboardPointChart> {
            return localVarFp.adminUserPointStatusRetrieve(endDate, groupId, startDate, userId, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserPointStatusApi - object-oriented interface
 * @export
 * @class AdminUserPointStatusApi
 * @extends {BaseAPI}
 */
export class AdminUserPointStatusApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
     * @param {string} endDate Filter by end date
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} startDate Filter by start date
     * @param {number} userId Filter by user id, if logged in user is a admin user
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserPointStatusApi
     */
    public adminUserPointStatusRetrieve(endDate: string, groupId: number, startDate: string, userId: number, search?: string, options?: AxiosRequestConfig) {
        return AdminUserPointStatusApiFp(this.configuration).adminUserPointStatusRetrieve(endDate, groupId, startDate, userId, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExpiringPointsDataApi - axios parameter creator
 * @export
 */
export const ExpiringPointsDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [pointType] Filter by point type, available choices are normal, thanks_only and grant_only
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsDataExportReportRetrieve: async (groupId: number, endDate?: string, groupSearch?: string, pointType?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('expiringPointsDataExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/expiring_points_data/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (pointType !== undefined) {
                localVarQueryParameter['point_type'] = pointType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }

            if (usersNotCoveredByTheSystem !== undefined) {
                localVarQueryParameter['users_not_covered_by_the_system'] = usersNotCoveredByTheSystem;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsDataList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/expiring_points_data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsDataRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expiringPointsDataRetrieve', 'id', id)
            const localVarPath = `/api/expiring_points_data/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpiringPointsDataApi - functional programming interface
 * @export
 */
export const ExpiringPointsDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpiringPointsDataApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [pointType] Filter by point type, available choices are normal, thanks_only and grant_only
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiringPointsDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, pointType?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiringPointsDataExportReportRetrieve(groupId, endDate, groupSearch, pointType, startDate, userSearch, usersNotCoveredByTheSystem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiringPointsDataList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpiringPointsDataList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiringPointsDataList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiringPointsDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpiringPointsHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiringPointsDataRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExpiringPointsDataApi - factory interface
 * @export
 */
export const ExpiringPointsDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpiringPointsDataApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [pointType] Filter by point type, available choices are normal, thanks_only and grant_only
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, pointType?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.expiringPointsDataExportReportRetrieve(groupId, endDate, groupSearch, pointType, startDate, userSearch, usersNotCoveredByTheSystem, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsDataList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<ExpiringPointsDataList200Response> {
            return localVarFp.expiringPointsDataList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsDataRetrieve(id: number, search?: string, options?: any): AxiosPromise<ExpiringPointsHistory> {
            return localVarFp.expiringPointsDataRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExpiringPointsDataApi - object-oriented interface
 * @export
 * @class ExpiringPointsDataApi
 * @extends {BaseAPI}
 */
export class ExpiringPointsDataApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {string} [pointType] Filter by point type, available choices are normal, thanks_only and grant_only
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpiringPointsDataApi
     */
    public expiringPointsDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, pointType?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options?: AxiosRequestConfig) {
        return ExpiringPointsDataApiFp(this.configuration).expiringPointsDataExportReportRetrieve(groupId, endDate, groupSearch, pointType, startDate, userSearch, usersNotCoveredByTheSystem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpiringPointsDataApi
     */
    public expiringPointsDataList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return ExpiringPointsDataApiFp(this.configuration).expiringPointsDataList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download expiring points.  The API will get the current user, find all the expiring point histories that are: - Visible to the organization that the current user belong to
     * @param {number} id A unique integer value identifying this personal point history.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpiringPointsDataApi
     */
    public expiringPointsDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return ExpiringPointsDataApiFp(this.configuration).expiringPointsDataRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ExpiringPointsHistoryApi - axios parameter creator
 * @export
 */
export const ExpiringPointsHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
         * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsHistoryList: async (expiryPointType: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expiryPointType' is not null or undefined
            assertParamExists('expiringPointsHistoryList', 'expiryPointType', expiryPointType)
            const localVarPath = `/api/expiring_points_history/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expiryPointType !== undefined) {
                localVarQueryParameter['expiry_point_type'] = expiryPointType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
         * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsHistoryRetrieve: async (expiryPointType: string, id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'expiryPointType' is not null or undefined
            assertParamExists('expiringPointsHistoryRetrieve', 'expiryPointType', expiryPointType)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('expiringPointsHistoryRetrieve', 'id', id)
            const localVarPath = `/api/expiring_points_history/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expiryPointType !== undefined) {
                localVarQueryParameter['expiry_point_type'] = expiryPointType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExpiringPointsHistoryApi - functional programming interface
 * @export
 */
export const ExpiringPointsHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExpiringPointsHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
         * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiringPointsHistoryList(expiryPointType: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpiringPointsHistoryList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiringPointsHistoryList(expiryPointType, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
         * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiringPointsHistoryRetrieve(expiryPointType: string, id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointExpiryHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiringPointsHistoryRetrieve(expiryPointType, id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExpiringPointsHistoryApi - factory interface
 * @export
 */
export const ExpiringPointsHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExpiringPointsHistoryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
         * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsHistoryList(expiryPointType: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<ExpiringPointsHistoryList200Response> {
            return localVarFp.expiringPointsHistoryList(expiryPointType, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
         * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiringPointsHistoryRetrieve(expiryPointType: string, id: number, search?: string, options?: any): AxiosPromise<PointExpiryHistory> {
            return localVarFp.expiringPointsHistoryRetrieve(expiryPointType, id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExpiringPointsHistoryApi - object-oriented interface
 * @export
 * @class ExpiringPointsHistoryApi
 * @extends {BaseAPI}
 */
export class ExpiringPointsHistoryApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
     * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpiringPointsHistoryApi
     */
    public expiringPointsHistoryList(expiryPointType: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return ExpiringPointsHistoryApiFp(this.configuration).expiringPointsHistoryList(expiryPointType, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to read expiring/expired list based on `expiry_point_type` parameter.  The API will get the current user, find all the expiring/expired point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API for expiring used as follows:   - pass the string value `expiring`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The List API for expired used as follows:   - pass the string value `expired`  via the `expiry_point_type` parameter.   eg: `/?expiry_point_type=expiring`  The Detail API will return the details of the point history with the given ID.
     * @param {string} expiryPointType Filter by point type, available choices are expired or expiring
     * @param {number} id A unique integer value identifying this personal point history.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpiringPointsHistoryApi
     */
    public expiringPointsHistoryRetrieve(expiryPointType: string, id: number, search?: string, options?: AxiosRequestConfig) {
        return ExpiringPointsHistoryApiFp(this.configuration).expiringPointsHistoryRetrieve(expiryPointType, id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FailCsvUploadReportsApi - axios parameter creator
 * @export
 */
export const FailCsvUploadReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API end point for getting list of failure CSV upload
         * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failCsvUploadReportsList: async (featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/fail_csv_upload_reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (featureType !== undefined) {
                localVarQueryParameter['feature_type'] = featureType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API end point for getting list of failure CSV upload
         * @param {number} id A unique integer value identifying this csv upload.
         * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failCsvUploadReportsRetrieve: async (id: number, featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('failCsvUploadReportsRetrieve', 'id', id)
            const localVarPath = `/api/fail_csv_upload_reports/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (featureType !== undefined) {
                localVarQueryParameter['feature_type'] = featureType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FailCsvUploadReportsApi - functional programming interface
 * @export
 */
export const FailCsvUploadReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FailCsvUploadReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * API end point for getting list of failure CSV upload
         * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async failCsvUploadReportsList(featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FailCsvUploadReportsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.failCsvUploadReportsList(featureType, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API end point for getting list of failure CSV upload
         * @param {number} id A unique integer value identifying this csv upload.
         * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async failCsvUploadReportsRetrieve(id: number, featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FailCSVFileDownload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.failCsvUploadReportsRetrieve(id, featureType, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FailCsvUploadReportsApi - factory interface
 * @export
 */
export const FailCsvUploadReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FailCsvUploadReportsApiFp(configuration)
    return {
        /**
         * API end point for getting list of failure CSV upload
         * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failCsvUploadReportsList(featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<FailCsvUploadReportsList200Response> {
            return localVarFp.failCsvUploadReportsList(featureType, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API end point for getting list of failure CSV upload
         * @param {number} id A unique integer value identifying this csv upload.
         * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failCsvUploadReportsRetrieve(id: number, featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', search?: string, options?: any): AxiosPromise<FailCSVFileDownload> {
            return localVarFp.failCsvUploadReportsRetrieve(id, featureType, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FailCsvUploadReportsApi - object-oriented interface
 * @export
 * @class FailCsvUploadReportsApi
 * @extends {BaseAPI}
 */
export class FailCsvUploadReportsApi extends BaseAPI {
    /**
     * API end point for getting list of failure CSV upload
     * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailCsvUploadReportsApi
     */
    public failCsvUploadReportsList(featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return FailCsvUploadReportsApiFp(this.configuration).failCsvUploadReportsList(featureType, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API end point for getting list of failure CSV upload
     * @param {number} id A unique integer value identifying this csv upload.
     * @param {'10' | '20' | '30' | '40' | '50' | '60' | '70' | '80'} [featureType] feature_type
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FailCsvUploadReportsApi
     */
    public failCsvUploadReportsRetrieve(id: number, featureType?: '10' | '20' | '30' | '40' | '50' | '60' | '70' | '80', search?: string, options?: AxiosRequestConfig) {
        return FailCsvUploadReportsApiFp(this.configuration).failCsvUploadReportsRetrieve(id, featureType, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FooterApi - axios parameter creator
 * @export
 */
export const FooterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to Fetch footer data based on organisation.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        footerList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/footer/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to Fetch footer data based on organisation.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        footerRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('footerRetrieve', 'id', id)
            const localVarPath = `/api/footer/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FooterApi - functional programming interface
 * @export
 */
export const FooterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FooterApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to Fetch footer data based on organisation.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async footerList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FooterList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.footerList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to Fetch footer data based on organisation.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async footerRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationFooter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.footerRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FooterApi - factory interface
 * @export
 */
export const FooterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FooterApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to Fetch footer data based on organisation.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        footerList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<FooterList200Response> {
            return localVarFp.footerList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to Fetch footer data based on organisation.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        footerRetrieve(id: number, search?: string, options?: any): AxiosPromise<OrganizationFooter> {
            return localVarFp.footerRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FooterApi - object-oriented interface
 * @export
 * @class FooterApi
 * @extends {BaseAPI}
 */
export class FooterApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to Fetch footer data based on organisation.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterApi
     */
    public footerList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return FooterApiFp(this.configuration).footerList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to Fetch footer data based on organisation.
     * @param {number} id A unique integer value identifying this organization admin setting.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FooterApi
     */
    public footerRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return FooterApiFp(this.configuration).footerRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantCriteriaApi - axios parameter creator
 * @export
 */
export const GrantCriteriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {GrantCriteriaRequest} grantCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCreate: async (grantCriteriaRequest: GrantCriteriaRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantCriteriaRequest' is not null or undefined
            assertParamExists('grantCriteriaCreate', 'grantCriteriaRequest', grantCriteriaRequest)
            const localVarPath = `/api/grant_criteria/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantCriteriaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaDestroy: async (id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantCriteriaDestroy', 'id', id)
            const localVarPath = `/api/grant_criteria/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grantType !== undefined) {
                localVarQueryParameter['grant_type'] = grantType;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [grantStandardSearch] search by Granting standard name or granting standard master ID( example :- grant_criteria_id_4 OR Test Grant criteria 1)
         * @param {string} [kind] Filter by kind, possible values(normal_point ,thanks_exclusive_point, grant_exclusive_point)
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaExportReportRetrieve: async (groupId: number, endDate?: string, grantStandardSearch?: string, kind?: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('grantCriteriaExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/grant_criteria/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (grantStandardSearch !== undefined) {
                localVarQueryParameter['grant_standard_search'] = grantStandardSearch;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaList: async (grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grant_criteria/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grantType !== undefined) {
                localVarQueryParameter['grant_type'] = grantType;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {PatchedGrantCriteriaPatchRequest} [patchedGrantCriteriaPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaPartialUpdate: async (id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, patchedGrantCriteriaPatchRequest?: PatchedGrantCriteriaPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantCriteriaPartialUpdate', 'id', id)
            const localVarPath = `/api/grant_criteria/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grantType !== undefined) {
                localVarQueryParameter['grant_type'] = grantType;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGrantCriteriaPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaRetrieve: async (id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantCriteriaRetrieve', 'id', id)
            const localVarPath = `/api/grant_criteria/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grantType !== undefined) {
                localVarQueryParameter['grant_type'] = grantType;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantCriteriaApi - functional programming interface
 * @export
 */
export const GrantCriteriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantCriteriaApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {GrantCriteriaRequest} grantCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaCreate(grantCriteriaRequest: GrantCriteriaRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantCriteria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaCreate(grantCriteriaRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaDestroy(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaDestroy(id, grantType, groupId, ordering, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [grantStandardSearch] search by Granting standard name or granting standard master ID( example :- grant_criteria_id_4 OR Test Grant criteria 1)
         * @param {string} [kind] Filter by kind, possible values(normal_point ,thanks_exclusive_point, grant_exclusive_point)
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaExportReportRetrieve(groupId: number, endDate?: string, grantStandardSearch?: string, kind?: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaExportReportRetrieve(groupId, endDate, grantStandardSearch, kind, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaList(grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantCriteriaList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaList(grantType, groupId, ordering, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {PatchedGrantCriteriaPatchRequest} [patchedGrantCriteriaPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaPartialUpdate(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, patchedGrantCriteriaPatchRequest?: PatchedGrantCriteriaPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantCriteriaPatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaPartialUpdate(id, grantType, groupId, ordering, search, patchedGrantCriteriaPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaRetrieve(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantCriteriaDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaRetrieve(id, grantType, groupId, ordering, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantCriteriaApi - factory interface
 * @export
 */
export const GrantCriteriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantCriteriaApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {GrantCriteriaRequest} grantCriteriaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCreate(grantCriteriaRequest: GrantCriteriaRequest, options?: any): AxiosPromise<GrantCriteria> {
            return localVarFp.grantCriteriaCreate(grantCriteriaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaDestroy(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantCriteriaDestroy(id, grantType, groupId, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [grantStandardSearch] search by Granting standard name or granting standard master ID( example :- grant_criteria_id_4 OR Test Grant criteria 1)
         * @param {string} [kind] Filter by kind, possible values(normal_point ,thanks_exclusive_point, grant_exclusive_point)
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaExportReportRetrieve(groupId: number, endDate?: string, grantStandardSearch?: string, kind?: string, startDate?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.grantCriteriaExportReportRetrieve(groupId, endDate, grantStandardSearch, kind, startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaList(grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<GrantCriteriaList200Response> {
            return localVarFp.grantCriteriaList(grantType, groupId, ordering, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {PatchedGrantCriteriaPatchRequest} [patchedGrantCriteriaPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaPartialUpdate(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, patchedGrantCriteriaPatchRequest?: PatchedGrantCriteriaPatchRequest, options?: any): AxiosPromise<GrantCriteriaPatch> {
            return localVarFp.grantCriteriaPartialUpdate(id, grantType, groupId, ordering, search, patchedGrantCriteriaPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
         * @param {number} id A unique integer value identifying this grant criteria.
         * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
         * @param {string} [groupId] Filter by group id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaRetrieve(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options?: any): AxiosPromise<GrantCriteriaDetail> {
            return localVarFp.grantCriteriaRetrieve(id, grantType, groupId, ordering, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantCriteriaApi - object-oriented interface
 * @export
 * @class GrantCriteriaApi
 * @extends {BaseAPI}
 */
export class GrantCriteriaApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
     * @param {GrantCriteriaRequest} grantCriteriaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaApi
     */
    public grantCriteriaCreate(grantCriteriaRequest: GrantCriteriaRequest, options?: AxiosRequestConfig) {
        return GrantCriteriaApiFp(this.configuration).grantCriteriaCreate(grantCriteriaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
     * @param {number} id A unique integer value identifying this grant criteria.
     * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
     * @param {string} [groupId] Filter by group id
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaApi
     */
    public grantCriteriaDestroy(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options?: AxiosRequestConfig) {
        return GrantCriteriaApiFp(this.configuration).grantCriteriaDestroy(id, grantType, groupId, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [grantStandardSearch] search by Granting standard name or granting standard master ID( example :- grant_criteria_id_4 OR Test Grant criteria 1)
     * @param {string} [kind] Filter by kind, possible values(normal_point ,thanks_exclusive_point, grant_exclusive_point)
     * @param {string} [startDate] Filter by start date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaApi
     */
    public grantCriteriaExportReportRetrieve(groupId: number, endDate?: string, grantStandardSearch?: string, kind?: string, startDate?: string, options?: AxiosRequestConfig) {
        return GrantCriteriaApiFp(this.configuration).grantCriteriaExportReportRetrieve(groupId, endDate, grantStandardSearch, kind, startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
     * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
     * @param {string} [groupId] Filter by group id
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaApi
     */
    public grantCriteriaList(grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return GrantCriteriaApiFp(this.configuration).grantCriteriaList(grantType, groupId, ordering, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
     * @param {number} id A unique integer value identifying this grant criteria.
     * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
     * @param {string} [groupId] Filter by group id
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {PatchedGrantCriteriaPatchRequest} [patchedGrantCriteriaPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaApi
     */
    public grantCriteriaPartialUpdate(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, patchedGrantCriteriaPatchRequest?: PatchedGrantCriteriaPatchRequest, options?: AxiosRequestConfig) {
        return GrantCriteriaApiFp(this.configuration).grantCriteriaPartialUpdate(id, grantType, groupId, ordering, search, patchedGrantCriteriaPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read grant criteria list and create a grant criteria.  The API will get the current user, find all the messages that are:   - Visible to the organization that the current user belong to  The List API will return a list of grant criterias, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by name, text, grant_criteria_id  via the `search` parameter.   - sorted by `points` `id` and `name`  The Detail API will return the details of the grant_criteria with the given ID. The create API will require the logged in user to be an admin user.
     * @param {number} id A unique integer value identifying this grant criteria.
     * @param {'10' | '20' | '30' | '40'} [grantType] Filter by Grant Criteria type
     * @param {string} [groupId] Filter by group id
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaApi
     */
    public grantCriteriaRetrieve(id: number, grantType?: '10' | '20' | '30' | '40', groupId?: string, ordering?: string, search?: string, options?: AxiosRequestConfig) {
        return GrantCriteriaApiFp(this.configuration).grantCriteriaRetrieve(id, grantType, groupId, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantCriteriaCsvUploadApi - axios parameter creator
 * @export
 */
export const GrantCriteriaCsvUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} groupId group_id
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCsvUploadCreate: async (groupId: number, fileUploaded: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('grantCriteriaCsvUploadCreate', 'groupId', groupId)
            // verify required parameter 'fileUploaded' is not null or undefined
            assertParamExists('grantCriteriaCsvUploadCreate', 'fileUploaded', fileUploaded)
            const localVarPath = `/api/grant_criteria_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }


            if (fileUploaded !== undefined) { 
                localVarFormParams.append('file_uploaded', fileUploaded as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to Create records in the database.     
         * @param {number} groupId group_id
         * @param {number} id id
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCsvUploadDatabaseOperationRetrieve: async (groupId: number, id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('grantCriteriaCsvUploadDatabaseOperationRetrieve', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantCriteriaCsvUploadDatabaseOperationRetrieve', 'id', id)
            const localVarPath = `/api/grant_criteria_csv_upload/database_operation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantCriteriaCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/grant_criteria_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantCriteriaCsvUploadApi - functional programming interface
 * @export
 */
export const GrantCriteriaCsvUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantCriteriaCsvUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} groupId group_id
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaCsvUploadCreate(groupId: number, fileUploaded: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaCsvUploadCreate(groupId, fileUploaded, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to Create records in the database.     
         * @param {number} groupId group_id
         * @param {number} id id
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaCsvUploadDatabaseOperationRetrieve(groupId: number, id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaCsvUploadDatabaseOperationRetrieve(groupId, id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantCriteriaCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantCriteriaCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantCriteriaCsvUploadApi - factory interface
 * @export
 */
export const GrantCriteriaCsvUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantCriteriaCsvUploadApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} groupId group_id
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCsvUploadCreate(groupId: number, fileUploaded: File, options?: any): AxiosPromise<Task> {
            return localVarFp.grantCriteriaCsvUploadCreate(groupId, fileUploaded, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to Create records in the database.     
         * @param {number} groupId group_id
         * @param {number} id id
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCsvUploadDatabaseOperationRetrieve(groupId: number, id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantCriteriaCsvUploadDatabaseOperationRetrieve(groupId, id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantCriteriaCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantCriteriaCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantCriteriaCsvUploadApi - object-oriented interface
 * @export
 * @class GrantCriteriaCsvUploadApi
 * @extends {BaseAPI}
 */
export class GrantCriteriaCsvUploadApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
     * @param {number} groupId group_id
     * @param {File} fileUploaded 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaCsvUploadApi
     */
    public grantCriteriaCsvUploadCreate(groupId: number, fileUploaded: File, options?: AxiosRequestConfig) {
        return GrantCriteriaCsvUploadApiFp(this.configuration).grantCriteriaCsvUploadCreate(groupId, fileUploaded, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to Create records in the database.     
     * @param {number} groupId group_id
     * @param {number} id id
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaCsvUploadApi
     */
    public grantCriteriaCsvUploadDatabaseOperationRetrieve(groupId: number, id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantCriteriaCsvUploadApiFp(this.configuration).grantCriteriaCsvUploadDatabaseOperationRetrieve(groupId, id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to download and upload the Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantCriteriaCsvUploadApi
     */
    public grantCriteriaCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantCriteriaCsvUploadApiFp(this.configuration).grantCriteriaCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantOnlyPointsApi - axios parameter creator
 * @export
 */
export const GrantOnlyPointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantOnlyPointsCsvUploadCreate: async (csvFile: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csvFile' is not null or undefined
            assertParamExists('grantOnlyPointsCsvUploadCreate', 'csvFile', csvFile)
            const localVarPath = `/api/grant-only-points/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (csvFile !== undefined) { 
                localVarFormParams.append('csv_file', csvFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantOnlyPointsCsvUploadLoadDataRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantOnlyPointsCsvUploadLoadDataRetrieve', 'id', id)
            const localVarPath = `/api/grant-only-points/csv-upload-load-data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantOnlyPointsCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantOnlyPointsCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/grant-only-points/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantOnlyPointsApi - functional programming interface
 * @export
 */
export const GrantOnlyPointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantOnlyPointsApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantOnlyPointsCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CSVUploadTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantOnlyPointsCsvUploadCreate(csvFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantOnlyPointsCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantOnlyPointsCsvUploadLoadDataRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantOnlyPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantOnlyPointsCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantOnlyPointsApi - factory interface
 * @export
 */
export const GrantOnlyPointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantOnlyPointsApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantOnlyPointsCsvUploadCreate(csvFile: File, options?: any): AxiosPromise<CSVUploadTask> {
            return localVarFp.grantOnlyPointsCsvUploadCreate(csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantOnlyPointsCsvUploadLoadDataRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantOnlyPointsCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantOnlyPointsCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantOnlyPointsCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantOnlyPointsApi - object-oriented interface
 * @export
 * @class GrantOnlyPointsApi
 * @extends {BaseAPI}
 */
export class GrantOnlyPointsApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
     * @param {File} csvFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantOnlyPointsApi
     */
    public grantOnlyPointsCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig) {
        return GrantOnlyPointsApiFp(this.configuration).grantOnlyPointsCsvUploadCreate(csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id To process the uploaded file pass the row id of the file
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantOnlyPointsApi
     */
    public grantOnlyPointsCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantOnlyPointsApiFp(this.configuration).grantOnlyPointsCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Grant Only Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Only Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Only Point CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantOnlyPointsApi
     */
    public grantOnlyPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantOnlyPointsApiFp(this.configuration).grantOnlyPointsCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantPointsApi - axios parameter creator
 * @export
 */
export const GrantPointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {GrantPointCreateRequest} grantPointCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCreate: async (grantPointCreateRequest: GrantPointCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grantPointCreateRequest' is not null or undefined
            assertParamExists('grantPointsCreate', 'grantPointCreateRequest', grantPointCreateRequest)
            const localVarPath = `/api/grant_points/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grantPointCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCsvUploadCreate: async (csvFile: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csvFile' is not null or undefined
            assertParamExists('grantPointsCsvUploadCreate', 'csvFile', csvFile)
            const localVarPath = `/api/grant-points/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (csvFile !== undefined) { 
                localVarFormParams.append('csv_file', csvFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCsvUploadLoadDataRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsCsvUploadLoadDataRetrieve', 'id', id)
            const localVarPath = `/api/grant-points/csv-upload-load-data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/grant-points/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDestroy: async (id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsDestroy', 'id', id)
            const localVarPath = `/api/grant_points/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} groupId group_id
         * @param {string} [destinationGroupSearch] search destination group code or group name ( example :- code OR group name 1)
         * @param {string} [endDate] Filter by end date
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [grantCriteriaSearch] search by grant criteria id or group name ( example :- grant_criteria_id_4 OR Test Grant criteria 1)
         * @param {string} [grantType] Filter by grant_type, possible values(normal_point, thanks_exclusive_point, grant_exclusive_point)
         * @param {string} [sourceGroupSearch] search source group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsExportReportRetrieve: async (groupId: number, destinationGroupSearch?: string, endDate?: string, fromUser?: string, grantCriteriaSearch?: string, grantType?: string, sourceGroupSearch?: string, startDate?: string, toUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('grantPointsExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/grant_points/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (destinationGroupSearch !== undefined) {
                localVarQueryParameter['destination_group_search'] = destinationGroupSearch;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (grantCriteriaSearch !== undefined) {
                localVarQueryParameter['grant_criteria_search'] = grantCriteriaSearch;
            }

            if (grantType !== undefined) {
                localVarQueryParameter['grant_type'] = grantType;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (sourceGroupSearch !== undefined) {
                localVarQueryParameter['source_group_search'] = sourceGroupSearch;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsList: async (createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, page?: number, pageSize?: number, search?: string, toUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grant_points/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the year and month of available Grant Points for current user.  The API will get the current user, find all the Grant Points that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - If `search` is given, only Grant Points with title containing the search word is considered  Then it finds the unique months, order them from newest to oldest, and return a list of them.
         * @param {number} [groupId] Filter by group id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsListAvailableMonthsList: async (groupId?: number, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/grant-points/list-available-months/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {PatchedGrantPointRequest} [patchedGrantPointRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsPartialUpdate: async (id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, patchedGrantPointRequest?: PatchedGrantPointRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsPartialUpdate', 'id', id)
            const localVarPath = `/api/grant_points/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGrantPointRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsRetrieve: async (id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsRetrieve', 'id', id)
            const localVarPath = `/api/grant_points/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (fromUser !== undefined) {
                localVarQueryParameter['from_user'] = fromUser;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['include_deleted'] = includeDeleted;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (toUser !== undefined) {
                localVarQueryParameter['to_user'] = toUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantPointsApi - functional programming interface
 * @export
 */
export const GrantPointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantPointsApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {GrantPointCreateRequest} grantPointCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsCreate(grantPointCreateRequest: GrantPointCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsCreate(grantPointCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CSVUploadTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsCsvUploadCreate(csvFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsCsvUploadLoadDataRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsDestroy(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsDestroy(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} groupId group_id
         * @param {string} [destinationGroupSearch] search destination group code or group name ( example :- code OR group name 1)
         * @param {string} [endDate] Filter by end date
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [grantCriteriaSearch] search by grant criteria id or group name ( example :- grant_criteria_id_4 OR Test Grant criteria 1)
         * @param {string} [grantType] Filter by grant_type, possible values(normal_point, thanks_exclusive_point, grant_exclusive_point)
         * @param {string} [sourceGroupSearch] search source group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsExportReportRetrieve(groupId: number, destinationGroupSearch?: string, endDate?: string, fromUser?: string, grantCriteriaSearch?: string, grantType?: string, sourceGroupSearch?: string, startDate?: string, toUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsExportReportRetrieve(groupId, destinationGroupSearch, endDate, fromUser, grantCriteriaSearch, grantType, sourceGroupSearch, startDate, toUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsList(createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, page?: number, pageSize?: number, search?: string, toUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantPointsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsList(createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, page, pageSize, search, toUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List the year and month of available Grant Points for current user.  The API will get the current user, find all the Grant Points that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - If `search` is given, only Grant Points with title containing the search word is considered  Then it finds the unique months, order them from newest to oldest, and return a list of them.
         * @param {number} [groupId] Filter by group id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsListAvailableMonthsList(groupId?: number, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantPointsListAvailableMonthsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsListAvailableMonthsList(groupId, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {PatchedGrantPointRequest} [patchedGrantPointRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsPartialUpdate(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, patchedGrantPointRequest?: PatchedGrantPointRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantPoint>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsPartialUpdate(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, patchedGrantPointRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsRetrieve(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantPoint>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsRetrieve(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantPointsApi - factory interface
 * @export
 */
export const GrantPointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantPointsApiFp(configuration)
    return {
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {GrantPointCreateRequest} grantPointCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCreate(grantPointCreateRequest: GrantPointCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.grantPointsCreate(grantPointCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCsvUploadCreate(csvFile: File, options?: any): AxiosPromise<CSVUploadTask> {
            return localVarFp.grantPointsCsvUploadCreate(csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCsvUploadLoadDataRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantPointsCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantPointsCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDestroy(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantPointsDestroy(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} groupId group_id
         * @param {string} [destinationGroupSearch] search destination group code or group name ( example :- code OR group name 1)
         * @param {string} [endDate] Filter by end date
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [grantCriteriaSearch] search by grant criteria id or group name ( example :- grant_criteria_id_4 OR Test Grant criteria 1)
         * @param {string} [grantType] Filter by grant_type, possible values(normal_point, thanks_exclusive_point, grant_exclusive_point)
         * @param {string} [sourceGroupSearch] search source group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsExportReportRetrieve(groupId: number, destinationGroupSearch?: string, endDate?: string, fromUser?: string, grantCriteriaSearch?: string, grantType?: string, sourceGroupSearch?: string, startDate?: string, toUser?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.grantPointsExportReportRetrieve(groupId, destinationGroupSearch, endDate, fromUser, grantCriteriaSearch, grantType, sourceGroupSearch, startDate, toUser, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsList(createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, page?: number, pageSize?: number, search?: string, toUser?: string, options?: any): AxiosPromise<GrantPointsList200Response> {
            return localVarFp.grantPointsList(createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, page, pageSize, search, toUser, options).then((request) => request(axios, basePath));
        },
        /**
         * List the year and month of available Grant Points for current user.  The API will get the current user, find all the Grant Points that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - If `search` is given, only Grant Points with title containing the search word is considered  Then it finds the unique months, order them from newest to oldest, and return a list of them.
         * @param {number} [groupId] Filter by group id
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsListAvailableMonthsList(groupId?: number, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<GrantPointsListAvailableMonthsList200Response> {
            return localVarFp.grantPointsListAvailableMonthsList(groupId, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {PatchedGrantPointRequest} [patchedGrantPointRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsPartialUpdate(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, patchedGrantPointRequest?: PatchedGrantPointRequest, options?: any): AxiosPromise<GrantPoint> {
            return localVarFp.grantPointsPartialUpdate(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, patchedGrantPointRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
         * @param {number} id A unique integer value identifying this grant point.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [fromUser] Filter by sender user
         * @param {string} [groupId] Filter by group id
         * @param {string} [includeDeleted] Include deleted items or not
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {string} [toUser] Filter by receiving user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsRetrieve(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options?: any): AxiosPromise<GrantPoint> {
            return localVarFp.grantPointsRetrieve(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantPointsApi - object-oriented interface
 * @export
 * @class GrantPointsApi
 * @extends {BaseAPI}
 */
export class GrantPointsApi extends BaseAPI {
    /**
     * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
     * @param {GrantPointCreateRequest} grantPointCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsCreate(grantPointCreateRequest: GrantPointCreateRequest, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsCreate(grantPointCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
     * @param {File} csvFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsCsvUploadCreate(csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id To process the uploaded file pass the row id of the file
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Grant Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
     * @param {number} id A unique integer value identifying this grant point.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {string} [includeDeleted] Include deleted items or not
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {string} [toUser] Filter by receiving user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsDestroy(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsDestroy(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
     * @param {number} groupId group_id
     * @param {string} [destinationGroupSearch] search destination group code or group name ( example :- code OR group name 1)
     * @param {string} [endDate] Filter by end date
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [grantCriteriaSearch] search by grant criteria id or group name ( example :- grant_criteria_id_4 OR Test Grant criteria 1)
     * @param {string} [grantType] Filter by grant_type, possible values(normal_point, thanks_exclusive_point, grant_exclusive_point)
     * @param {string} [sourceGroupSearch] search source group code or group name ( example :- code OR group name 1)
     * @param {string} [startDate] Filter by start date
     * @param {string} [toUser] Filter by receiving user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsExportReportRetrieve(groupId: number, destinationGroupSearch?: string, endDate?: string, fromUser?: string, grantCriteriaSearch?: string, grantType?: string, sourceGroupSearch?: string, startDate?: string, toUser?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsExportReportRetrieve(groupId, destinationGroupSearch, endDate, fromUser, grantCriteriaSearch, grantType, sourceGroupSearch, startDate, toUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {string} [includeDeleted] Include deleted items or not
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [toUser] Filter by receiving user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsList(createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, page?: number, pageSize?: number, search?: string, toUser?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsList(createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, page, pageSize, search, toUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the year and month of available Grant Points for current user.  The API will get the current user, find all the Grant Points that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - If `search` is given, only Grant Points with title containing the search word is considered  Then it finds the unique months, order them from newest to oldest, and return a list of them.
     * @param {number} [groupId] Filter by group id
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsListAvailableMonthsList(groupId?: number, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsListAvailableMonthsList(groupId, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
     * @param {number} id A unique integer value identifying this grant point.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {string} [includeDeleted] Include deleted items or not
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {string} [toUser] Filter by receiving user
     * @param {PatchedGrantPointRequest} [patchedGrantPointRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsPartialUpdate(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, patchedGrantPointRequest?: PatchedGrantPointRequest, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsPartialUpdate(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, patchedGrantPointRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for reading and writing grant point history  The List API will return a list of grant points exchanged between two users, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - filtered by created_month, created_year, from_user, to_user, include_deleted.   - API also offers support for ordering by `id`, `to_user`, `from_user`, `grant_criteria`, `transaction__points`,   `authorize_date`, and `grant_criteria__grant_criteria_id`   - can be searched using `title`, `text`, `grant_criteria__id`, `grant_criteria__name`,   and `grant_criteria__grant_criteria_id`  The Detail API will return the details of the Grant point with the given ID.
     * @param {number} id A unique integer value identifying this grant point.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [fromUser] Filter by sender user
     * @param {string} [groupId] Filter by group id
     * @param {string} [includeDeleted] Include deleted items or not
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {string} [toUser] Filter by receiving user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsApi
     */
    public grantPointsRetrieve(id: number, createdMonth?: string, createdYear?: string, fromUser?: string, groupId?: string, includeDeleted?: string, ordering?: string, search?: string, toUser?: string, options?: AxiosRequestConfig) {
        return GrantPointsApiFp(this.configuration).grantPointsRetrieve(id, createdMonth, createdYear, fromUser, groupId, includeDeleted, ordering, search, toUser, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GrantPointsDeletionApi - axios parameter creator
 * @export
 */
export const GrantPointsDeletionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDeletionCsvUploadCreate: async (csvFile: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csvFile' is not null or undefined
            assertParamExists('grantPointsDeletionCsvUploadCreate', 'csvFile', csvFile)
            const localVarPath = `/api/grant-points-deletion/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (csvFile !== undefined) { 
                localVarFormParams.append('csv_file', csvFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDeletionCsvUploadLoadDataRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsDeletionCsvUploadLoadDataRetrieve', 'id', id)
            const localVarPath = `/api/grant-points-deletion/csv-upload-load-data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDeletionCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('grantPointsDeletionCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/grant-points-deletion/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrantPointsDeletionApi - functional programming interface
 * @export
 */
export const GrantPointsDeletionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrantPointsDeletionApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsDeletionCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CSVUploadTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsDeletionCsvUploadCreate(csvFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsDeletionCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsDeletionCsvUploadLoadDataRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantPointsDeletionCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantPointsDeletionCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GrantPointsDeletionApi - factory interface
 * @export
 */
export const GrantPointsDeletionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrantPointsDeletionApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDeletionCsvUploadCreate(csvFile: File, options?: any): AxiosPromise<CSVUploadTask> {
            return localVarFp.grantPointsDeletionCsvUploadCreate(csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDeletionCsvUploadLoadDataRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantPointsDeletionCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantPointsDeletionCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.grantPointsDeletionCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrantPointsDeletionApi - object-oriented interface
 * @export
 * @class GrantPointsDeletionApi
 * @extends {BaseAPI}
 */
export class GrantPointsDeletionApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
     * @param {File} csvFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsDeletionApi
     */
    public grantPointsDeletionCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig) {
        return GrantPointsDeletionApiFp(this.configuration).grantPointsDeletionCsvUploadCreate(csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id To process the uploaded file pass the row id of the file
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsDeletionApi
     */
    public grantPointsDeletionCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantPointsDeletionApiFp(this.configuration).grantPointsDeletionCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Grant Point Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Point Deletion CSV Error file pass the actual id received while uploading the file. - To upload the Grant Point Deletion CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrantPointsDeletionApi
     */
    public grantPointsDeletionCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return GrantPointsDeletionApiFp(this.configuration).grantPointsDeletionCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupDataApi - axios parameter creator
 * @export
 */
export const GroupDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to Download Group Data.     - To Download CSV file pass organization_id
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDataRetrieve: async (groupId: number, endDate?: string, search?: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('groupDataRetrieve', 'groupId', groupId)
            const localVarPath = `/api/group_data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupDataApi - functional programming interface
 * @export
 */
export const GroupDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupDataApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download Group Data.     - To Download CSV file pass organization_id
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupDataRetrieve(groupId: number, endDate?: string, search?: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupDataRetrieve(groupId, endDate, search, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupDataApi - factory interface
 * @export
 */
export const GroupDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupDataApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download Group Data.     - To Download CSV file pass organization_id
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDataRetrieve(groupId: number, endDate?: string, search?: string, startDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.groupDataRetrieve(groupId, endDate, search, startDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupDataApi - object-oriented interface
 * @export
 * @class GroupDataApi
 * @extends {BaseAPI}
 */
export class GroupDataApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to Download Group Data.     - To Download CSV file pass organization_id
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupDataApi
     */
    public groupDataRetrieve(groupId: number, endDate?: string, search?: string, startDate?: string, options?: AxiosRequestConfig) {
        return GroupDataApiFp(this.configuration).groupDataRetrieve(groupId, endDate, search, startDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupPointDataApi - axios parameter creator
 * @export
 */
export const GroupPointDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to Download Group Point Data.     
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPointDataRetrieve: async (groupId: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('groupPointDataRetrieve', 'groupId', groupId)
            const localVarPath = `/api/group_point_data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupPointDataApi - functional programming interface
 * @export
 */
export const GroupPointDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupPointDataApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download Group Point Data.     
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupPointDataRetrieve(groupId: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupPointDataRetrieve(groupId, endDate, groupSearch, search, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupPointDataApi - factory interface
 * @export
 */
export const GroupPointDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupPointDataApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download Group Point Data.     
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupPointDataRetrieve(groupId: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, options?: any): AxiosPromise<CustomUser> {
            return localVarFp.groupPointDataRetrieve(groupId, endDate, groupSearch, search, startDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupPointDataApi - object-oriented interface
 * @export
 * @class GroupPointDataApi
 * @extends {BaseAPI}
 */
export class GroupPointDataApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to Download Group Point Data.     
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupPointDataApi
     */
    public groupPointDataRetrieve(groupId: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, options?: AxiosRequestConfig) {
        return GroupPointDataApiFp(this.configuration).groupPointDataRetrieve(groupId, endDate, groupSearch, search, startDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupUsersInfoApi - axios parameter creator
 * @export
 */
export const GroupUsersInfoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows getting list of users in a group. By default the API will return the users present in all the groups of logged in users organization. Either pass group id in `group_id` or pass grant criteria id in `grant_criteria` field, API will return group or groups detail including the users details of the users in that group  API also supports `group_ordering` field that enables sorting of results based on group fields - supported group fields for ordering are `name`, `code` and `id`. Add `-` for descending order  API also supports `user_ordering` field that enables sorting of users inside results based on user fields - supported user fields for ordering are `id` and `username`. Add `-` for descending order
         * @param {number} [grantCriteria] grant criteria id
         * @param {number} [groupId] group id
         * @param {string} [groupOrdering] group ordering field
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [userOrdering] user ordering field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupUsersInfoList: async (grantCriteria?: number, groupId?: number, groupOrdering?: string, page?: number, pageSize?: number, search?: string, userOrdering?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/group_users_info/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (grantCriteria !== undefined) {
                localVarQueryParameter['grant_criteria'] = grantCriteria;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupOrdering !== undefined) {
                localVarQueryParameter['group_ordering'] = groupOrdering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (userOrdering !== undefined) {
                localVarQueryParameter['user_ordering'] = userOrdering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupUsersInfoApi - functional programming interface
 * @export
 */
export const GroupUsersInfoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupUsersInfoApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows getting list of users in a group. By default the API will return the users present in all the groups of logged in users organization. Either pass group id in `group_id` or pass grant criteria id in `grant_criteria` field, API will return group or groups detail including the users details of the users in that group  API also supports `group_ordering` field that enables sorting of results based on group fields - supported group fields for ordering are `name`, `code` and `id`. Add `-` for descending order  API also supports `user_ordering` field that enables sorting of users inside results based on user fields - supported user fields for ordering are `id` and `username`. Add `-` for descending order
         * @param {number} [grantCriteria] grant criteria id
         * @param {number} [groupId] group id
         * @param {string} [groupOrdering] group ordering field
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [userOrdering] user ordering field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupUsersInfoList(grantCriteria?: number, groupId?: number, groupOrdering?: string, page?: number, pageSize?: number, search?: string, userOrdering?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupUsersInfoList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupUsersInfoList(grantCriteria, groupId, groupOrdering, page, pageSize, search, userOrdering, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupUsersInfoApi - factory interface
 * @export
 */
export const GroupUsersInfoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupUsersInfoApiFp(configuration)
    return {
        /**
         * API endpoint that allows getting list of users in a group. By default the API will return the users present in all the groups of logged in users organization. Either pass group id in `group_id` or pass grant criteria id in `grant_criteria` field, API will return group or groups detail including the users details of the users in that group  API also supports `group_ordering` field that enables sorting of results based on group fields - supported group fields for ordering are `name`, `code` and `id`. Add `-` for descending order  API also supports `user_ordering` field that enables sorting of users inside results based on user fields - supported user fields for ordering are `id` and `username`. Add `-` for descending order
         * @param {number} [grantCriteria] grant criteria id
         * @param {number} [groupId] group id
         * @param {string} [groupOrdering] group ordering field
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [userOrdering] user ordering field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupUsersInfoList(grantCriteria?: number, groupId?: number, groupOrdering?: string, page?: number, pageSize?: number, search?: string, userOrdering?: string, options?: any): AxiosPromise<GroupUsersInfoList200Response> {
            return localVarFp.groupUsersInfoList(grantCriteria, groupId, groupOrdering, page, pageSize, search, userOrdering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupUsersInfoApi - object-oriented interface
 * @export
 * @class GroupUsersInfoApi
 * @extends {BaseAPI}
 */
export class GroupUsersInfoApi extends BaseAPI {
    /**
     * API endpoint that allows getting list of users in a group. By default the API will return the users present in all the groups of logged in users organization. Either pass group id in `group_id` or pass grant criteria id in `grant_criteria` field, API will return group or groups detail including the users details of the users in that group  API also supports `group_ordering` field that enables sorting of results based on group fields - supported group fields for ordering are `name`, `code` and `id`. Add `-` for descending order  API also supports `user_ordering` field that enables sorting of users inside results based on user fields - supported user fields for ordering are `id` and `username`. Add `-` for descending order
     * @param {number} [grantCriteria] grant criteria id
     * @param {number} [groupId] group id
     * @param {string} [groupOrdering] group ordering field
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [userOrdering] user ordering field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupUsersInfoApi
     */
    public groupUsersInfoList(grantCriteria?: number, groupId?: number, groupOrdering?: string, page?: number, pageSize?: number, search?: string, userOrdering?: string, options?: AxiosRequestConfig) {
        return GroupUsersInfoApiFp(this.configuration).groupUsersInfoList(grantCriteria, groupId, groupOrdering, page, pageSize, search, userOrdering, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KenkoGrantCriteriaCsvUploadApi - axios parameter creator
 * @export
 */
export const KenkoGrantCriteriaCsvUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoGrantCriteriaCsvUploadCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/kenko_grant_criteria_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to Create records in the database.     
         * @param {number} groupId group_id
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve: async (groupId: number, id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve', 'id', id)
            const localVarPath = `/api/kenko_grant_criteria_csv_upload/database_operation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoGrantCriteriaCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('kenkoGrantCriteriaCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/kenko_grant_criteria_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KenkoGrantCriteriaCsvUploadApi - functional programming interface
 * @export
 */
export const KenkoGrantCriteriaCsvUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KenkoGrantCriteriaCsvUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoGrantCriteriaCsvUploadCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoGrantCriteriaCsvUploadCreate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to Create records in the database.     
         * @param {number} groupId group_id
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve(groupId: number, id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve(groupId, id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoGrantCriteriaCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoGrantCriteriaCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KenkoGrantCriteriaCsvUploadApi - factory interface
 * @export
 */
export const KenkoGrantCriteriaCsvUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KenkoGrantCriteriaCsvUploadApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoGrantCriteriaCsvUploadCreate(options?: any): AxiosPromise<void> {
            return localVarFp.kenkoGrantCriteriaCsvUploadCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to Create records in the database.     
         * @param {number} groupId group_id
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve(groupId: number, id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve(groupId, id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoGrantCriteriaCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.kenkoGrantCriteriaCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KenkoGrantCriteriaCsvUploadApi - object-oriented interface
 * @export
 * @class KenkoGrantCriteriaCsvUploadApi
 * @extends {BaseAPI}
 */
export class KenkoGrantCriteriaCsvUploadApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoGrantCriteriaCsvUploadApi
     */
    public kenkoGrantCriteriaCsvUploadCreate(options?: AxiosRequestConfig) {
        return KenkoGrantCriteriaCsvUploadApiFp(this.configuration).kenkoGrantCriteriaCsvUploadCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to Create records in the database.     
     * @param {number} groupId group_id
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoGrantCriteriaCsvUploadApi
     */
    public kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve(groupId: number, id: number, search?: string, options?: AxiosRequestConfig) {
        return KenkoGrantCriteriaCsvUploadApiFp(this.configuration).kenkoGrantCriteriaCsvUploadDatabaseOperationRetrieve(groupId, id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to download and upload the Kenko Grant Criteria Point related CSV file. - To Download Sample CSV file pass id = 0 - To Download Grant Criteria Point CSV Error file pass the actual id received while uploading the file. - To upload the Grant Criteria Point CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoGrantCriteriaCsvUploadApi
     */
    public kenkoGrantCriteriaCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return KenkoGrantCriteriaCsvUploadApiFp(this.configuration).kenkoGrantCriteriaCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KenkoPointsCsvUploadApi - axios parameter creator
 * @export
 */
export const KenkoPointsCsvUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsCsvUploadCreate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/kenko_points_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsCsvUploadDatabaseOperationRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('kenkoPointsCsvUploadDatabaseOperationRetrieve', 'id', id)
            const localVarPath = `/api/kenko_points_csv_upload/database_operation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('kenkoPointsCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/kenko_points_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KenkoPointsCsvUploadApi - functional programming interface
 * @export
 */
export const KenkoPointsCsvUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KenkoPointsCsvUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoPointsCsvUploadCreate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoPointsCsvUploadCreate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoPointsCsvUploadDatabaseOperationRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoPointsCsvUploadDatabaseOperationRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoPointsCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KenkoPointsCsvUploadApi - factory interface
 * @export
 */
export const KenkoPointsCsvUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KenkoPointsCsvUploadApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsCsvUploadCreate(options?: any): AxiosPromise<void> {
            return localVarFp.kenkoPointsCsvUploadCreate(options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsCsvUploadDatabaseOperationRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.kenkoPointsCsvUploadDatabaseOperationRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.kenkoPointsCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KenkoPointsCsvUploadApi - object-oriented interface
 * @export
 * @class KenkoPointsCsvUploadApi
 * @extends {BaseAPI}
 */
export class KenkoPointsCsvUploadApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoPointsCsvUploadApi
     */
    public kenkoPointsCsvUploadCreate(options?: AxiosRequestConfig) {
        return KenkoPointsCsvUploadApiFp(this.configuration).kenkoPointsCsvUploadCreate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to Create records in the database.
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoPointsCsvUploadApi
     */
    public kenkoPointsCsvUploadDatabaseOperationRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return KenkoPointsCsvUploadApiFp(this.configuration).kenkoPointsCsvUploadDatabaseOperationRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Kenko Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Points CSV Error file pass the actual id received while uploading the file. - To upload the kenko Points CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoPointsCsvUploadApi
     */
    public kenkoPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return KenkoPointsCsvUploadApiFp(this.configuration).kenkoPointsCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KenkoPointsDeletionApi - axios parameter creator
 * @export
 */
export const KenkoPointsDeletionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsDeletionCsvUploadLoadDataRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('kenkoPointsDeletionCsvUploadLoadDataRetrieve', 'id', id)
            const localVarPath = `/api/kenko-points-deletion/csv-upload-load-data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KenkoPointsDeletionApi - functional programming interface
 * @export
 */
export const KenkoPointsDeletionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KenkoPointsDeletionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenkoPointsDeletionCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenkoPointsDeletionCsvUploadLoadDataRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KenkoPointsDeletionApi - factory interface
 * @export
 */
export const KenkoPointsDeletionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KenkoPointsDeletionApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id To process the uploaded file pass the row id of the file
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenkoPointsDeletionCsvUploadLoadDataRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.kenkoPointsDeletionCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KenkoPointsDeletionApi - object-oriented interface
 * @export
 * @class KenkoPointsDeletionApi
 * @extends {BaseAPI}
 */
export class KenkoPointsDeletionApi extends BaseAPI {
    /**
     * 
     * @param {number} id To process the uploaded file pass the row id of the file
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenkoPointsDeletionApi
     */
    public kenkoPointsDeletionCsvUploadLoadDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return KenkoPointsDeletionApiFp(this.configuration).kenkoPointsDeletionCsvUploadLoadDataRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KenoPointsDeletionApi - axios parameter creator
 * @export
 */
export const KenoPointsDeletionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenoPointsDeletionCsvUploadCreate: async (csvFile: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csvFile' is not null or undefined
            assertParamExists('kenoPointsDeletionCsvUploadCreate', 'csvFile', csvFile)
            const localVarPath = `/api/keno-points-deletion/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (csvFile !== undefined) { 
                localVarFormParams.append('csv_file', csvFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenoPointsDeletionCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('kenoPointsDeletionCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/keno-points-deletion/csv-upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KenoPointsDeletionApi - functional programming interface
 * @export
 */
export const KenoPointsDeletionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KenoPointsDeletionApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenoPointsDeletionCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CSVUploadTask>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenoPointsDeletionCsvUploadCreate(csvFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kenoPointsDeletionCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kenoPointsDeletionCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KenoPointsDeletionApi - factory interface
 * @export
 */
export const KenoPointsDeletionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KenoPointsDeletionApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
         * @param {File} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenoPointsDeletionCsvUploadCreate(csvFile: File, options?: any): AxiosPromise<CSVUploadTask> {
            return localVarFp.kenoPointsDeletionCsvUploadCreate(csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kenoPointsDeletionCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.kenoPointsDeletionCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KenoPointsDeletionApi - object-oriented interface
 * @export
 * @class KenoPointsDeletionApi
 * @extends {BaseAPI}
 */
export class KenoPointsDeletionApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
     * @param {File} csvFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenoPointsDeletionApi
     */
    public kenoPointsDeletionCsvUploadCreate(csvFile: File, options?: AxiosRequestConfig) {
        return KenoPointsDeletionApiFp(this.configuration).kenoPointsDeletionCsvUploadCreate(csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Kenko Point     Deletion related CSV file. - To Download Sample CSV file pass id = 0 - To Download Kenko Point Deletion CSV Error file pass the actual id received while     uploading the file. - To upload the Kenko Point Deletion CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KenoPointsDeletionApi
     */
    public kenoPointsDeletionCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return KenoPointsDeletionApiFp(this.configuration).kenoPointsDeletionCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ListAvailableMonthsApi - axios parameter creator
 * @export
 */
export const ListAvailableMonthsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the year and month of available what\'s new for current user.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date is between `start_showing` and `stop_showing` date   - Visible to the organization that the current user belong to   - If `search` is given, only messages with title containing the search world is considered  Then it find the unique months, order them from newest to oldest, and return a list of them.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableMonthsList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/list-available-months/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListAvailableMonthsApi - functional programming interface
 * @export
 */
export const ListAvailableMonthsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListAvailableMonthsApiAxiosParamCreator(configuration)
    return {
        /**
         * List the year and month of available what\'s new for current user.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date is between `start_showing` and `stop_showing` date   - Visible to the organization that the current user belong to   - If `search` is given, only messages with title containing the search world is considered  Then it find the unique months, order them from newest to oldest, and return a list of them.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailableMonthsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantPointsListAvailableMonthsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailableMonthsList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ListAvailableMonthsApi - factory interface
 * @export
 */
export const ListAvailableMonthsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListAvailableMonthsApiFp(configuration)
    return {
        /**
         * List the year and month of available what\'s new for current user.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date is between `start_showing` and `stop_showing` date   - Visible to the organization that the current user belong to   - If `search` is given, only messages with title containing the search world is considered  Then it find the unique months, order them from newest to oldest, and return a list of them.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailableMonthsList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<GrantPointsListAvailableMonthsList200Response> {
            return localVarFp.listAvailableMonthsList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListAvailableMonthsApi - object-oriented interface
 * @export
 * @class ListAvailableMonthsApi
 * @extends {BaseAPI}
 */
export class ListAvailableMonthsApi extends BaseAPI {
    /**
     * List the year and month of available what\'s new for current user.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date is between `start_showing` and `stop_showing` date   - Visible to the organization that the current user belong to   - If `search` is given, only messages with title containing the search world is considered  Then it find the unique months, order them from newest to oldest, and return a list of them.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListAvailableMonthsApi
     */
    public listAvailableMonthsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return ListAvailableMonthsApiFp(this.configuration).listAvailableMonthsList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ListGrantTypesApi - axios parameter creator
 * @export
 */
export const ListGrantTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * View to list all grant criteria types in the system.  Sample response:     {         \"10\": \"no limit\",         \"20\": \"distribution only/ group budget\",         \"30\": \"thanks exclusive point\"     }
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrantTypesRetrieve: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/list-grant-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListGrantTypesApi - functional programming interface
 * @export
 */
export const ListGrantTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListGrantTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * View to list all grant criteria types in the system.  Sample response:     {         \"10\": \"no limit\",         \"20\": \"distribution only/ group budget\",         \"30\": \"thanks exclusive point\"     }
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGrantTypesRetrieve(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGrantTypesRetrieve(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ListGrantTypesApi - factory interface
 * @export
 */
export const ListGrantTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListGrantTypesApiFp(configuration)
    return {
        /**
         * View to list all grant criteria types in the system.  Sample response:     {         \"10\": \"no limit\",         \"20\": \"distribution only/ group budget\",         \"30\": \"thanks exclusive point\"     }
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrantTypesRetrieve(search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.listGrantTypesRetrieve(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListGrantTypesApi - object-oriented interface
 * @export
 * @class ListGrantTypesApi
 * @extends {BaseAPI}
 */
export class ListGrantTypesApi extends BaseAPI {
    /**
     * View to list all grant criteria types in the system.  Sample response:     {         \"10\": \"no limit\",         \"20\": \"distribution only/ group budget\",         \"30\": \"thanks exclusive point\"     }
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListGrantTypesApi
     */
    public listGrantTypesRetrieve(search?: string, options?: AxiosRequestConfig) {
        return ListGrantTypesApiFp(this.configuration).listGrantTypesRetrieve(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ListTransactionTypesApi - axios parameter creator
 * @export
 */
export const ListTransactionTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * View to list all transaction types in the system.  Sample response:     {         \"10\": \"apply\",         \"20\": \"grant to user\",         \"30\": \"grant group budget\",         \"40\": \"grant dedicated thanks giving points\",     }
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactionTypesRetrieve: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/list-transaction-types/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListTransactionTypesApi - functional programming interface
 * @export
 */
export const ListTransactionTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListTransactionTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * View to list all transaction types in the system.  Sample response:     {         \"10\": \"apply\",         \"20\": \"grant to user\",         \"30\": \"grant group budget\",         \"40\": \"grant dedicated thanks giving points\",     }
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransactionTypesRetrieve(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransactionTypesRetrieve(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ListTransactionTypesApi - factory interface
 * @export
 */
export const ListTransactionTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListTransactionTypesApiFp(configuration)
    return {
        /**
         * View to list all transaction types in the system.  Sample response:     {         \"10\": \"apply\",         \"20\": \"grant to user\",         \"30\": \"grant group budget\",         \"40\": \"grant dedicated thanks giving points\",     }
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactionTypesRetrieve(search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.listTransactionTypesRetrieve(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListTransactionTypesApi - object-oriented interface
 * @export
 * @class ListTransactionTypesApi
 * @extends {BaseAPI}
 */
export class ListTransactionTypesApi extends BaseAPI {
    /**
     * View to list all transaction types in the system.  Sample response:     {         \"10\": \"apply\",         \"20\": \"grant to user\",         \"30\": \"grant group budget\",         \"40\": \"grant dedicated thanks giving points\",     }
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListTransactionTypesApi
     */
    public listTransactionTypesRetrieve(search?: string, options?: AxiosRequestConfig) {
        return ListTransactionTypesApiFp(this.configuration).listTransactionTypesRetrieve(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MarkSystemNotificationsReadApi - axios parameter creator
 * @export
 */
export const MarkSystemNotificationsReadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {InformationMessageTrackerRequest} informationMessageTrackerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSystemNotificationsReadCreate: async (informationMessageTrackerRequest: InformationMessageTrackerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'informationMessageTrackerRequest' is not null or undefined
            assertParamExists('markSystemNotificationsReadCreate', 'informationMessageTrackerRequest', informationMessageTrackerRequest)
            const localVarPath = `/api/mark_system_notifications_read/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(informationMessageTrackerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSystemNotificationsReadList: async (createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mark_system_notifications_read/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSystemNotificationsReadRetrieve: async (id: number, createdMonth?: string, createdYear?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markSystemNotificationsReadRetrieve', 'id', id)
            const localVarPath = `/api/mark_system_notifications_read/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarkSystemNotificationsReadApi - functional programming interface
 * @export
 */
export const MarkSystemNotificationsReadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarkSystemNotificationsReadApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {InformationMessageTrackerRequest} informationMessageTrackerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSystemNotificationsReadCreate(informationMessageTrackerRequest: InformationMessageTrackerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessageTracker>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSystemNotificationsReadCreate(informationMessageTrackerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSystemNotificationsReadList(createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarkSystemNotificationsReadList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSystemNotificationsReadList(createdMonth, createdYear, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markSystemNotificationsReadRetrieve(id: number, createdMonth?: string, createdYear?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessageTracker>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markSystemNotificationsReadRetrieve(id, createdMonth, createdYear, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarkSystemNotificationsReadApi - factory interface
 * @export
 */
export const MarkSystemNotificationsReadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarkSystemNotificationsReadApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {InformationMessageTrackerRequest} informationMessageTrackerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSystemNotificationsReadCreate(informationMessageTrackerRequest: InformationMessageTrackerRequest, options?: any): AxiosPromise<InformationMessageTracker> {
            return localVarFp.markSystemNotificationsReadCreate(informationMessageTrackerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSystemNotificationsReadList(createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<MarkSystemNotificationsReadList200Response> {
            return localVarFp.markSystemNotificationsReadList(createdMonth, createdYear, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markSystemNotificationsReadRetrieve(id: number, createdMonth?: string, createdYear?: string, search?: string, options?: any): AxiosPromise<InformationMessageTracker> {
            return localVarFp.markSystemNotificationsReadRetrieve(id, createdMonth, createdYear, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarkSystemNotificationsReadApi - object-oriented interface
 * @export
 * @class MarkSystemNotificationsReadApi
 * @extends {BaseAPI}
 */
export class MarkSystemNotificationsReadApi extends BaseAPI {
    /**
     * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
     * @param {InformationMessageTrackerRequest} informationMessageTrackerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkSystemNotificationsReadApi
     */
    public markSystemNotificationsReadCreate(informationMessageTrackerRequest: InformationMessageTrackerRequest, options?: AxiosRequestConfig) {
        return MarkSystemNotificationsReadApiFp(this.configuration).markSystemNotificationsReadCreate(informationMessageTrackerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkSystemNotificationsReadApi
     */
    public markSystemNotificationsReadList(createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return MarkSystemNotificationsReadApiFp(this.configuration).markSystemNotificationsReadList(createdMonth, createdYear, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to Mark system notification as read.  The Post API will create the new record in InformationMessageTracker table. The parameter required for the API are: `message`
     * @param {number} id A unique integer value identifying this information message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarkSystemNotificationsReadApi
     */
    public markSystemNotificationsReadRetrieve(id: number, createdMonth?: string, createdYear?: string, search?: string, options?: AxiosRequestConfig) {
        return MarkSystemNotificationsReadApiFp(this.configuration).markSystemNotificationsReadRetrieve(id, createdMonth, createdYear, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MoveGrantCriteriaApi - axios parameter creator
 * @export
 */
export const MoveGrantCriteriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * An API endpoint to move grant criteria up or down by one. This API can accept upto 3 parameters in the request body  {     `id`: pk of grant criteria,     `direction`: \'up\' or \'down\' or \'top\' or \'bottom\',     `sorting`: \'ascending\' or \'descending\' }  where sorting is optional, if sorting is not passed by default it will be considered as \'ascending\'
         * @param {PatchedGrantCriteriaMoveByOneRequest} [patchedGrantCriteriaMoveByOneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveGrantCriteriaPartialUpdate: async (patchedGrantCriteriaMoveByOneRequest?: PatchedGrantCriteriaMoveByOneRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/move_grant_criteria/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedGrantCriteriaMoveByOneRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MoveGrantCriteriaApi - functional programming interface
 * @export
 */
export const MoveGrantCriteriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MoveGrantCriteriaApiAxiosParamCreator(configuration)
    return {
        /**
         * An API endpoint to move grant criteria up or down by one. This API can accept upto 3 parameters in the request body  {     `id`: pk of grant criteria,     `direction`: \'up\' or \'down\' or \'top\' or \'bottom\',     `sorting`: \'ascending\' or \'descending\' }  where sorting is optional, if sorting is not passed by default it will be considered as \'ascending\'
         * @param {PatchedGrantCriteriaMoveByOneRequest} [patchedGrantCriteriaMoveByOneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveGrantCriteriaPartialUpdate(patchedGrantCriteriaMoveByOneRequest?: PatchedGrantCriteriaMoveByOneRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantCriteria>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveGrantCriteriaPartialUpdate(patchedGrantCriteriaMoveByOneRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MoveGrantCriteriaApi - factory interface
 * @export
 */
export const MoveGrantCriteriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MoveGrantCriteriaApiFp(configuration)
    return {
        /**
         * An API endpoint to move grant criteria up or down by one. This API can accept upto 3 parameters in the request body  {     `id`: pk of grant criteria,     `direction`: \'up\' or \'down\' or \'top\' or \'bottom\',     `sorting`: \'ascending\' or \'descending\' }  where sorting is optional, if sorting is not passed by default it will be considered as \'ascending\'
         * @param {PatchedGrantCriteriaMoveByOneRequest} [patchedGrantCriteriaMoveByOneRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveGrantCriteriaPartialUpdate(patchedGrantCriteriaMoveByOneRequest?: PatchedGrantCriteriaMoveByOneRequest, options?: any): AxiosPromise<GrantCriteria> {
            return localVarFp.moveGrantCriteriaPartialUpdate(patchedGrantCriteriaMoveByOneRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MoveGrantCriteriaApi - object-oriented interface
 * @export
 * @class MoveGrantCriteriaApi
 * @extends {BaseAPI}
 */
export class MoveGrantCriteriaApi extends BaseAPI {
    /**
     * An API endpoint to move grant criteria up or down by one. This API can accept upto 3 parameters in the request body  {     `id`: pk of grant criteria,     `direction`: \'up\' or \'down\' or \'top\' or \'bottom\',     `sorting`: \'ascending\' or \'descending\' }  where sorting is optional, if sorting is not passed by default it will be considered as \'ascending\'
     * @param {PatchedGrantCriteriaMoveByOneRequest} [patchedGrantCriteriaMoveByOneRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoveGrantCriteriaApi
     */
    public moveGrantCriteriaPartialUpdate(patchedGrantCriteriaMoveByOneRequest?: PatchedGrantCriteriaMoveByOneRequest, options?: AxiosRequestConfig) {
        return MoveGrantCriteriaApiFp(this.configuration).moveGrantCriteriaPartialUpdate(patchedGrantCriteriaMoveByOneRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrgAdminSettingsApi - axios parameter creator
 * @export
 */
export const OrgAdminSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsCreate: async (orgAdminSettingsRequest: OrgAdminSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgAdminSettingsRequest' is not null or undefined
            assertParamExists('orgAdminSettingsCreate', 'orgAdminSettingsRequest', orgAdminSettingsRequest)
            const localVarPath = `/api/org_admin_settings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgAdminSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsList: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/org_admin_settings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {string} [search] A search term.
         * @param {PatchedOrgAdminSettingsRequest} [patchedOrgAdminSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsPartialUpdate: async (companyCode: string, search?: string, patchedOrgAdminSettingsRequest?: PatchedOrgAdminSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyCode' is not null or undefined
            assertParamExists('orgAdminSettingsPartialUpdate', 'companyCode', companyCode)
            const localVarPath = `/api/org_admin_settings/{company_code}/`
                .replace(`{${"company_code"}}`, encodeURIComponent(String(companyCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOrgAdminSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsRetrieve: async (companyCode: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyCode' is not null or undefined
            assertParamExists('orgAdminSettingsRetrieve', 'companyCode', companyCode)
            const localVarPath = `/api/org_admin_settings/{company_code}/`
                .replace(`{${"company_code"}}`, encodeURIComponent(String(companyCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsUpdate: async (companyCode: string, orgAdminSettingsRequest: OrgAdminSettingsRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyCode' is not null or undefined
            assertParamExists('orgAdminSettingsUpdate', 'companyCode', companyCode)
            // verify required parameter 'orgAdminSettingsRequest' is not null or undefined
            assertParamExists('orgAdminSettingsUpdate', 'orgAdminSettingsRequest', orgAdminSettingsRequest)
            const localVarPath = `/api/org_admin_settings/{company_code}/`
                .replace(`{${"company_code"}}`, encodeURIComponent(String(companyCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgAdminSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrgAdminSettingsApi - functional programming interface
 * @export
 */
export const OrgAdminSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrgAdminSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdminSettingsCreate(orgAdminSettingsRequest: OrgAdminSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgAdminSettingsCreate(orgAdminSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdminSettingsList(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrgAdminSettings>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgAdminSettingsList(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {string} [search] A search term.
         * @param {PatchedOrgAdminSettingsRequest} [patchedOrgAdminSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdminSettingsPartialUpdate(companyCode: string, search?: string, patchedOrgAdminSettingsRequest?: PatchedOrgAdminSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgAdminSettingsPartialUpdate(companyCode, search, patchedOrgAdminSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdminSettingsRetrieve(companyCode: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgAdminSettingsRetrieve(companyCode, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgAdminSettingsUpdate(companyCode: string, orgAdminSettingsRequest: OrgAdminSettingsRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgAdminSettingsUpdate(companyCode, orgAdminSettingsRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrgAdminSettingsApi - factory interface
 * @export
 */
export const OrgAdminSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrgAdminSettingsApiFp(configuration)
    return {
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsCreate(orgAdminSettingsRequest: OrgAdminSettingsRequest, options?: any): AxiosPromise<OrgAdminSettings> {
            return localVarFp.orgAdminSettingsCreate(orgAdminSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsList(search?: string, options?: any): AxiosPromise<Array<OrgAdminSettings>> {
            return localVarFp.orgAdminSettingsList(search, options).then((request) => request(axios, basePath));
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {string} [search] A search term.
         * @param {PatchedOrgAdminSettingsRequest} [patchedOrgAdminSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsPartialUpdate(companyCode: string, search?: string, patchedOrgAdminSettingsRequest?: PatchedOrgAdminSettingsRequest, options?: any): AxiosPromise<OrgAdminSettings> {
            return localVarFp.orgAdminSettingsPartialUpdate(companyCode, search, patchedOrgAdminSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsRetrieve(companyCode: string, search?: string, options?: any): AxiosPromise<OrgAdminSettings> {
            return localVarFp.orgAdminSettingsRetrieve(companyCode, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
         * @param {string} companyCode 
         * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgAdminSettingsUpdate(companyCode: string, orgAdminSettingsRequest: OrgAdminSettingsRequest, search?: string, options?: any): AxiosPromise<OrgAdminSettings> {
            return localVarFp.orgAdminSettingsUpdate(companyCode, orgAdminSettingsRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrgAdminSettingsApi - object-oriented interface
 * @export
 * @class OrgAdminSettingsApi
 * @extends {BaseAPI}
 */
export class OrgAdminSettingsApi extends BaseAPI {
    /**
     * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
     * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgAdminSettingsApi
     */
    public orgAdminSettingsCreate(orgAdminSettingsRequest: OrgAdminSettingsRequest, options?: AxiosRequestConfig) {
        return OrgAdminSettingsApiFp(this.configuration).orgAdminSettingsCreate(orgAdminSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgAdminSettingsApi
     */
    public orgAdminSettingsList(search?: string, options?: AxiosRequestConfig) {
        return OrgAdminSettingsApiFp(this.configuration).orgAdminSettingsList(search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
     * @param {string} companyCode 
     * @param {string} [search] A search term.
     * @param {PatchedOrgAdminSettingsRequest} [patchedOrgAdminSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgAdminSettingsApi
     */
    public orgAdminSettingsPartialUpdate(companyCode: string, search?: string, patchedOrgAdminSettingsRequest?: PatchedOrgAdminSettingsRequest, options?: AxiosRequestConfig) {
        return OrgAdminSettingsApiFp(this.configuration).orgAdminSettingsPartialUpdate(companyCode, search, patchedOrgAdminSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
     * @param {string} companyCode 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgAdminSettingsApi
     */
    public orgAdminSettingsRetrieve(companyCode: string, search?: string, options?: AxiosRequestConfig) {
        return OrgAdminSettingsApiFp(this.configuration).orgAdminSettingsRetrieve(companyCode, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API are handle to create the Organization setting  with company code can be used by third party like bpf where they have to pass api key     Validation-key : \"Api-key ttrst.ddddss67nbjbvbsjl\"         GET: first need to check with company_code for same Organization exists or not             API : /api/org_admin_settings/{company_code}/         POST: make the company_code unique             API : /api/org_admin_settings/         PATCH:             API : /api/org_admin_settings/{company_code}/             not allowed to change the company_code
     * @param {string} companyCode 
     * @param {OrgAdminSettingsRequest} orgAdminSettingsRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrgAdminSettingsApi
     */
    public orgAdminSettingsUpdate(companyCode: string, orgAdminSettingsRequest: OrgAdminSettingsRequest, search?: string, options?: AxiosRequestConfig) {
        return OrgAdminSettingsApiFp(this.configuration).orgAdminSettingsUpdate(companyCode, orgAdminSettingsRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationAdminSettingsApi - axios parameter creator
 * @export
 */
export const OrganizationAdminSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsCreate: async (organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationAdminSettingsRequest' is not null or undefined
            assertParamExists('organizationAdminSettingsCreate', 'organizationAdminSettingsRequest', organizationAdminSettingsRequest)
            const localVarPath = `/api/organization_admin_settings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationAdminSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization_admin_settings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {PatchedOrganizationAdminSettingsRequest} [patchedOrganizationAdminSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsPartialUpdate: async (id: number, search?: string, patchedOrganizationAdminSettingsRequest?: PatchedOrganizationAdminSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationAdminSettingsPartialUpdate', 'id', id)
            const localVarPath = `/api/organization_admin_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOrganizationAdminSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationAdminSettingsRetrieve', 'id', id)
            const localVarPath = `/api/organization_admin_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsUpdate: async (id: number, organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationAdminSettingsUpdate', 'id', id)
            // verify required parameter 'organizationAdminSettingsRequest' is not null or undefined
            assertParamExists('organizationAdminSettingsUpdate', 'organizationAdminSettingsRequest', organizationAdminSettingsRequest)
            const localVarPath = `/api/organization_admin_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationAdminSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationAdminSettingsApi - functional programming interface
 * @export
 */
export const OrganizationAdminSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationAdminSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAdminSettingsCreate(organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAdminSettingsCreate(organizationAdminSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAdminSettingsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAdminSettingsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAdminSettingsList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {PatchedOrganizationAdminSettingsRequest} [patchedOrganizationAdminSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAdminSettingsPartialUpdate(id: number, search?: string, patchedOrganizationAdminSettingsRequest?: PatchedOrganizationAdminSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAdminSettingsPartialUpdate(id, search, patchedOrganizationAdminSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAdminSettingsRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAdminSettingsRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationAdminSettingsUpdate(id: number, organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationAdminSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationAdminSettingsUpdate(id, organizationAdminSettingsRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationAdminSettingsApi - factory interface
 * @export
 */
export const OrganizationAdminSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationAdminSettingsApiFp(configuration)
    return {
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsCreate(organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, options?: any): AxiosPromise<OrganizationAdminSettings> {
            return localVarFp.organizationAdminSettingsCreate(organizationAdminSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<OrganizationAdminSettingsList200Response> {
            return localVarFp.organizationAdminSettingsList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {PatchedOrganizationAdminSettingsRequest} [patchedOrganizationAdminSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsPartialUpdate(id: number, search?: string, patchedOrganizationAdminSettingsRequest?: PatchedOrganizationAdminSettingsRequest, options?: any): AxiosPromise<OrganizationAdminSettings> {
            return localVarFp.organizationAdminSettingsPartialUpdate(id, search, patchedOrganizationAdminSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsRetrieve(id: number, search?: string, options?: any): AxiosPromise<OrganizationAdminSettings> {
            return localVarFp.organizationAdminSettingsRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to get all organization settings.
         * @param {number} id A unique integer value identifying this organization admin setting.
         * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationAdminSettingsUpdate(id: number, organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, search?: string, options?: any): AxiosPromise<OrganizationAdminSettings> {
            return localVarFp.organizationAdminSettingsUpdate(id, organizationAdminSettingsRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationAdminSettingsApi - object-oriented interface
 * @export
 * @class OrganizationAdminSettingsApi
 * @extends {BaseAPI}
 */
export class OrganizationAdminSettingsApi extends BaseAPI {
    /**
     * API ednpoint that allows user to get all organization settings.
     * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminSettingsApi
     */
    public organizationAdminSettingsCreate(organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, options?: AxiosRequestConfig) {
        return OrganizationAdminSettingsApiFp(this.configuration).organizationAdminSettingsCreate(organizationAdminSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to get all organization settings.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminSettingsApi
     */
    public organizationAdminSettingsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return OrganizationAdminSettingsApiFp(this.configuration).organizationAdminSettingsList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to get all organization settings.
     * @param {number} id A unique integer value identifying this organization admin setting.
     * @param {string} [search] A search term.
     * @param {PatchedOrganizationAdminSettingsRequest} [patchedOrganizationAdminSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminSettingsApi
     */
    public organizationAdminSettingsPartialUpdate(id: number, search?: string, patchedOrganizationAdminSettingsRequest?: PatchedOrganizationAdminSettingsRequest, options?: AxiosRequestConfig) {
        return OrganizationAdminSettingsApiFp(this.configuration).organizationAdminSettingsPartialUpdate(id, search, patchedOrganizationAdminSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to get all organization settings.
     * @param {number} id A unique integer value identifying this organization admin setting.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminSettingsApi
     */
    public organizationAdminSettingsRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return OrganizationAdminSettingsApiFp(this.configuration).organizationAdminSettingsRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to get all organization settings.
     * @param {number} id A unique integer value identifying this organization admin setting.
     * @param {OrganizationAdminSettingsRequest} organizationAdminSettingsRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationAdminSettingsApi
     */
    public organizationAdminSettingsUpdate(id: number, organizationAdminSettingsRequest: OrganizationAdminSettingsRequest, search?: string, options?: AxiosRequestConfig) {
        return OrganizationAdminSettingsApiFp(this.configuration).organizationAdminSettingsUpdate(id, organizationAdminSettingsRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationPageCustomizationApi - axios parameter creator
 * @export
 */
export const OrganizationPageCustomizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization Organization ID from the AUTH system
         * @param {string} pageTitle this will be used in the HTML title of every page
         * @param {string} pageColor change the color of some element. use hex or color name that\\\&#39;s supported by HTML
         * @param {string} pointName \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
         * @param {string} defaultThanksMessage 
         * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
         * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
         * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationCreate: async (organization: number, pageTitle: string, pageColor: string, pointName: string, defaultThanksMessage: string, pageLogo?: File, favicon?: File, pointLogo?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organization' is not null or undefined
            assertParamExists('organizationPageCustomizationCreate', 'organization', organization)
            // verify required parameter 'pageTitle' is not null or undefined
            assertParamExists('organizationPageCustomizationCreate', 'pageTitle', pageTitle)
            // verify required parameter 'pageColor' is not null or undefined
            assertParamExists('organizationPageCustomizationCreate', 'pageColor', pageColor)
            // verify required parameter 'pointName' is not null or undefined
            assertParamExists('organizationPageCustomizationCreate', 'pointName', pointName)
            // verify required parameter 'defaultThanksMessage' is not null or undefined
            assertParamExists('organizationPageCustomizationCreate', 'defaultThanksMessage', defaultThanksMessage)
            const localVarPath = `/api/organization_page_customization/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (organization !== undefined) { 
                localVarFormParams.append('organization', organization as any);
            }
    
            if (pageTitle !== undefined) { 
                localVarFormParams.append('page_title', pageTitle as any);
            }
    
            if (pageLogo !== undefined) { 
                localVarFormParams.append('page_logo', pageLogo as any);
            }
    
            if (favicon !== undefined) { 
                localVarFormParams.append('favicon', favicon as any);
            }
    
            if (pageColor !== undefined) { 
                localVarFormParams.append('page_color', pageColor as any);
            }
    
            if (pointName !== undefined) { 
                localVarFormParams.append('point_name', pointName as any);
            }
    
            if (pointLogo !== undefined) { 
                localVarFormParams.append('point_logo', pointLogo as any);
            }
    
            if (defaultThanksMessage !== undefined) { 
                localVarFormParams.append('default_thanks_message', defaultThanksMessage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organization_page_customization/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization 
         * @param {string} [search] A search term.
         * @param {string} [pageTitle] this will be used in the HTML title of every page
         * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
         * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
         * @param {string} [pageColor] change the color of some element. use hex or color name that\\\&#39;s supported by HTML
         * @param {string} [pointName] \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
         * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
         * @param {string} [defaultThanksMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationPartialUpdate: async (organization: number, search?: string, pageTitle?: string, pageLogo?: File, favicon?: File, pageColor?: string, pointName?: string, pointLogo?: File, defaultThanksMessage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organization' is not null or undefined
            assertParamExists('organizationPageCustomizationPartialUpdate', 'organization', organization)
            const localVarPath = `/api/organization_page_customization/{organization}/`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


            if (pageTitle !== undefined) { 
                localVarFormParams.append('page_title', pageTitle as any);
            }
    
            if (pageLogo !== undefined) { 
                localVarFormParams.append('page_logo', pageLogo as any);
            }
    
            if (favicon !== undefined) { 
                localVarFormParams.append('favicon', favicon as any);
            }
    
            if (pageColor !== undefined) { 
                localVarFormParams.append('page_color', pageColor as any);
            }
    
            if (pointName !== undefined) { 
                localVarFormParams.append('point_name', pointName as any);
            }
    
            if (pointLogo !== undefined) { 
                localVarFormParams.append('point_logo', pointLogo as any);
            }
    
            if (defaultThanksMessage !== undefined) { 
                localVarFormParams.append('default_thanks_message', defaultThanksMessage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationRetrieve: async (organization: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organization' is not null or undefined
            assertParamExists('organizationPageCustomizationRetrieve', 'organization', organization)
            const localVarPath = `/api/organization_page_customization/{organization}/`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationPageCustomizationApi - functional programming interface
 * @export
 */
export const OrganizationPageCustomizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationPageCustomizationApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization Organization ID from the AUTH system
         * @param {string} pageTitle this will be used in the HTML title of every page
         * @param {string} pageColor change the color of some element. use hex or color name that\\\&#39;s supported by HTML
         * @param {string} pointName \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
         * @param {string} defaultThanksMessage 
         * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
         * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
         * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPageCustomizationCreate(organization: number, pageTitle: string, pageColor: string, pointName: string, defaultThanksMessage: string, pageLogo?: File, favicon?: File, pointLogo?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPageCustomization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPageCustomizationCreate(organization, pageTitle, pageColor, pointName, defaultThanksMessage, pageLogo, favicon, pointLogo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPageCustomizationList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPageCustomizationList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPageCustomizationList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization 
         * @param {string} [search] A search term.
         * @param {string} [pageTitle] this will be used in the HTML title of every page
         * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
         * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
         * @param {string} [pageColor] change the color of some element. use hex or color name that\\\&#39;s supported by HTML
         * @param {string} [pointName] \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
         * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
         * @param {string} [defaultThanksMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPageCustomizationPartialUpdate(organization: number, search?: string, pageTitle?: string, pageLogo?: File, favicon?: File, pageColor?: string, pointName?: string, pointLogo?: File, defaultThanksMessage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPageCustomization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPageCustomizationPartialUpdate(organization, search, pageTitle, pageLogo, favicon, pageColor, pointName, pointLogo, defaultThanksMessage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPageCustomizationRetrieve(organization: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationPageCustomization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPageCustomizationRetrieve(organization, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationPageCustomizationApi - factory interface
 * @export
 */
export const OrganizationPageCustomizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationPageCustomizationApiFp(configuration)
    return {
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization Organization ID from the AUTH system
         * @param {string} pageTitle this will be used in the HTML title of every page
         * @param {string} pageColor change the color of some element. use hex or color name that\\\&#39;s supported by HTML
         * @param {string} pointName \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
         * @param {string} defaultThanksMessage 
         * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
         * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
         * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationCreate(organization: number, pageTitle: string, pageColor: string, pointName: string, defaultThanksMessage: string, pageLogo?: File, favicon?: File, pointLogo?: File, options?: any): AxiosPromise<OrganizationPageCustomization> {
            return localVarFp.organizationPageCustomizationCreate(organization, pageTitle, pageColor, pointName, defaultThanksMessage, pageLogo, favicon, pointLogo, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<OrganizationPageCustomizationList200Response> {
            return localVarFp.organizationPageCustomizationList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization 
         * @param {string} [search] A search term.
         * @param {string} [pageTitle] this will be used in the HTML title of every page
         * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
         * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
         * @param {string} [pageColor] change the color of some element. use hex or color name that\\\&#39;s supported by HTML
         * @param {string} [pointName] \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
         * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
         * @param {string} [defaultThanksMessage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationPartialUpdate(organization: number, search?: string, pageTitle?: string, pageLogo?: File, favicon?: File, pageColor?: string, pointName?: string, pointLogo?: File, defaultThanksMessage?: string, options?: any): AxiosPromise<OrganizationPageCustomization> {
            return localVarFp.organizationPageCustomizationPartialUpdate(organization, search, pageTitle, pageLogo, favicon, pageColor, pointName, pointLogo, defaultThanksMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
         * @param {number} organization 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPageCustomizationRetrieve(organization: number, search?: string, options?: any): AxiosPromise<OrganizationPageCustomization> {
            return localVarFp.organizationPageCustomizationRetrieve(organization, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationPageCustomizationApi - object-oriented interface
 * @export
 * @class OrganizationPageCustomizationApi
 * @extends {BaseAPI}
 */
export class OrganizationPageCustomizationApi extends BaseAPI {
    /**
     * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
     * @param {number} organization Organization ID from the AUTH system
     * @param {string} pageTitle this will be used in the HTML title of every page
     * @param {string} pageColor change the color of some element. use hex or color name that\\\&#39;s supported by HTML
     * @param {string} pointName \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
     * @param {string} defaultThanksMessage 
     * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
     * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
     * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPageCustomizationApi
     */
    public organizationPageCustomizationCreate(organization: number, pageTitle: string, pageColor: string, pointName: string, defaultThanksMessage: string, pageLogo?: File, favicon?: File, pointLogo?: File, options?: AxiosRequestConfig) {
        return OrganizationPageCustomizationApiFp(this.configuration).organizationPageCustomizationCreate(organization, pageTitle, pageColor, pointName, defaultThanksMessage, pageLogo, favicon, pointLogo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPageCustomizationApi
     */
    public organizationPageCustomizationList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return OrganizationPageCustomizationApiFp(this.configuration).organizationPageCustomizationList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
     * @param {number} organization 
     * @param {string} [search] A search term.
     * @param {string} [pageTitle] this will be used in the HTML title of every page
     * @param {File} [pageLogo] logo on top left of header, best 320x48 png file. The response should be a full URL
     * @param {File} [favicon] favicon icon used in the address bar or browser tab, best 16x16 png file. The response should be a full URL
     * @param {string} [pageColor] change the color of some element. use hex or color name that\\\&#39;s supported by HTML
     * @param {string} [pointName] \\\&#39;pt\\\&#39;, \\\&#39;point\\\&#39;, or other name of the point
     * @param {File} [pointLogo] logo used in front of point count. Best 120x120 png file. The response should be a full URL
     * @param {string} [defaultThanksMessage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPageCustomizationApi
     */
    public organizationPageCustomizationPartialUpdate(organization: number, search?: string, pageTitle?: string, pageLogo?: File, favicon?: File, pageColor?: string, pointName?: string, pointLogo?: File, defaultThanksMessage?: string, options?: AxiosRequestConfig) {
        return OrganizationPageCustomizationApiFp(this.configuration).organizationPageCustomizationPartialUpdate(organization, search, pageTitle, pageLogo, favicon, pageColor, pointName, pointLogo, defaultThanksMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows anonymous reading of organization page customization.  API endpoint that allows admin user to enter the Organization related information.  Create API will make the entry for the organization related information      like page_logo, page_title, page_color etc..  Partial Update API will update the existing information for the organization.
     * @param {number} organization 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPageCustomizationApi
     */
    public organizationPageCustomizationRetrieve(organization: number, search?: string, options?: AxiosRequestConfig) {
        return OrganizationPageCustomizationApiFp(this.configuration).organizationPageCustomizationRetrieve(organization, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PersonalAddressApi - axios parameter creator
 * @export
 */
export const PersonalAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API ednpoint that allows user personal address.
         * @param {PersonalAddressRequest} personalAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressCreate: async (personalAddressRequest: PersonalAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personalAddressRequest' is not null or undefined
            assertParamExists('personalAddressCreate', 'personalAddressRequest', personalAddressRequest)
            const localVarPath = `/api/personal_address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personalAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressDestroy: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personalAddressDestroy', 'id', id)
            const localVarPath = `/api/personal_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/personal_address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {PatchedPersonalAddressRequest} [patchedPersonalAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressPartialUpdate: async (id: number, search?: string, patchedPersonalAddressRequest?: PatchedPersonalAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personalAddressPartialUpdate', 'id', id)
            const localVarPath = `/api/personal_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPersonalAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personalAddressRetrieve', 'id', id)
            const localVarPath = `/api/personal_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {PersonalAddressRequest} personalAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressUpdate: async (id: number, personalAddressRequest: PersonalAddressRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('personalAddressUpdate', 'id', id)
            // verify required parameter 'personalAddressRequest' is not null or undefined
            assertParamExists('personalAddressUpdate', 'personalAddressRequest', personalAddressRequest)
            const localVarPath = `/api/personal_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(personalAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonalAddressApi - functional programming interface
 * @export
 */
export const PersonalAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonalAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * API ednpoint that allows user personal address.
         * @param {PersonalAddressRequest} personalAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalAddressCreate(personalAddressRequest: PersonalAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personalAddressCreate(personalAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalAddressDestroy(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personalAddressDestroy(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalAddressList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalAddressList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personalAddressList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {PatchedPersonalAddressRequest} [patchedPersonalAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalAddressPartialUpdate(id: number, search?: string, patchedPersonalAddressRequest?: PatchedPersonalAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personalAddressPartialUpdate(id, search, patchedPersonalAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalAddressRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personalAddressRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {PersonalAddressRequest} personalAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async personalAddressUpdate(id: number, personalAddressRequest: PersonalAddressRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.personalAddressUpdate(id, personalAddressRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PersonalAddressApi - factory interface
 * @export
 */
export const PersonalAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonalAddressApiFp(configuration)
    return {
        /**
         * API ednpoint that allows user personal address.
         * @param {PersonalAddressRequest} personalAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressCreate(personalAddressRequest: PersonalAddressRequest, options?: any): AxiosPromise<PersonalAddress> {
            return localVarFp.personalAddressCreate(personalAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressDestroy(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.personalAddressDestroy(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PersonalAddressList200Response> {
            return localVarFp.personalAddressList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {PatchedPersonalAddressRequest} [patchedPersonalAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressPartialUpdate(id: number, search?: string, patchedPersonalAddressRequest?: PatchedPersonalAddressRequest, options?: any): AxiosPromise<PersonalAddress> {
            return localVarFp.personalAddressPartialUpdate(id, search, patchedPersonalAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressRetrieve(id: number, search?: string, options?: any): AxiosPromise<PersonalAddress> {
            return localVarFp.personalAddressRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user personal address.
         * @param {number} id A unique integer value identifying this personal address.
         * @param {PersonalAddressRequest} personalAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalAddressUpdate(id: number, personalAddressRequest: PersonalAddressRequest, search?: string, options?: any): AxiosPromise<PersonalAddress> {
            return localVarFp.personalAddressUpdate(id, personalAddressRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonalAddressApi - object-oriented interface
 * @export
 * @class PersonalAddressApi
 * @extends {BaseAPI}
 */
export class PersonalAddressApi extends BaseAPI {
    /**
     * API ednpoint that allows user personal address.
     * @param {PersonalAddressRequest} personalAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalAddressApi
     */
    public personalAddressCreate(personalAddressRequest: PersonalAddressRequest, options?: AxiosRequestConfig) {
        return PersonalAddressApiFp(this.configuration).personalAddressCreate(personalAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user personal address.
     * @param {number} id A unique integer value identifying this personal address.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalAddressApi
     */
    public personalAddressDestroy(id: number, search?: string, options?: AxiosRequestConfig) {
        return PersonalAddressApiFp(this.configuration).personalAddressDestroy(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user personal address.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalAddressApi
     */
    public personalAddressList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return PersonalAddressApiFp(this.configuration).personalAddressList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user personal address.
     * @param {number} id A unique integer value identifying this personal address.
     * @param {string} [search] A search term.
     * @param {PatchedPersonalAddressRequest} [patchedPersonalAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalAddressApi
     */
    public personalAddressPartialUpdate(id: number, search?: string, patchedPersonalAddressRequest?: PatchedPersonalAddressRequest, options?: AxiosRequestConfig) {
        return PersonalAddressApiFp(this.configuration).personalAddressPartialUpdate(id, search, patchedPersonalAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user personal address.
     * @param {number} id A unique integer value identifying this personal address.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalAddressApi
     */
    public personalAddressRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return PersonalAddressApiFp(this.configuration).personalAddressRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user personal address.
     * @param {number} id A unique integer value identifying this personal address.
     * @param {PersonalAddressRequest} personalAddressRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalAddressApi
     */
    public personalAddressUpdate(id: number, personalAddressRequest: PersonalAddressRequest, search?: string, options?: AxiosRequestConfig) {
        return PersonalAddressApiFp(this.configuration).personalAddressUpdate(id, personalAddressRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PointNotificationApi - axios parameter creator
 * @export
 */
export const PointNotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointNotificationList: async (hasRead?: string, ordering?: string, page?: number, pageSize?: number, pointHistoryNotification?: string, search?: string, topPage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/point_notification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hasRead !== undefined) {
                localVarQueryParameter['has_read'] = hasRead;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (pointHistoryNotification !== undefined) {
                localVarQueryParameter['point_history_notification'] = pointHistoryNotification;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (topPage !== undefined) {
                localVarQueryParameter['top_page'] = topPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {number} id A unique integer value identifying this point notification.
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {PatchedPointNotificationRequest} [patchedPointNotificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointNotificationPartialUpdate: async (id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, patchedPointNotificationRequest?: PatchedPointNotificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pointNotificationPartialUpdate', 'id', id)
            const localVarPath = `/api/point_notification/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hasRead !== undefined) {
                localVarQueryParameter['has_read'] = hasRead;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (pointHistoryNotification !== undefined) {
                localVarQueryParameter['point_history_notification'] = pointHistoryNotification;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (topPage !== undefined) {
                localVarQueryParameter['top_page'] = topPage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPointNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {number} id A unique integer value identifying this point notification.
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointNotificationRetrieve: async (id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pointNotificationRetrieve', 'id', id)
            const localVarPath = `/api/point_notification/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hasRead !== undefined) {
                localVarQueryParameter['has_read'] = hasRead;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (pointHistoryNotification !== undefined) {
                localVarQueryParameter['point_history_notification'] = pointHistoryNotification;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (topPage !== undefined) {
                localVarQueryParameter['top_page'] = topPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointNotificationApi - functional programming interface
 * @export
 */
export const PointNotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointNotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointNotificationList(hasRead?: string, ordering?: string, page?: number, pageSize?: number, pointHistoryNotification?: string, search?: string, topPage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointNotificationList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointNotificationList(hasRead, ordering, page, pageSize, pointHistoryNotification, search, topPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {number} id A unique integer value identifying this point notification.
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {PatchedPointNotificationRequest} [patchedPointNotificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointNotificationPartialUpdate(id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, patchedPointNotificationRequest?: PatchedPointNotificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointNotificationPartialUpdate(id, hasRead, ordering, pointHistoryNotification, search, topPage, patchedPointNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {number} id A unique integer value identifying this point notification.
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointNotificationRetrieve(id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointNotificationRetrieve(id, hasRead, ordering, pointHistoryNotification, search, topPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointNotificationApi - factory interface
 * @export
 */
export const PointNotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointNotificationApiFp(configuration)
    return {
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointNotificationList(hasRead?: string, ordering?: string, page?: number, pageSize?: number, pointHistoryNotification?: string, search?: string, topPage?: string, options?: any): AxiosPromise<PointNotificationList200Response> {
            return localVarFp.pointNotificationList(hasRead, ordering, page, pageSize, pointHistoryNotification, search, topPage, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {number} id A unique integer value identifying this point notification.
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {PatchedPointNotificationRequest} [patchedPointNotificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointNotificationPartialUpdate(id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, patchedPointNotificationRequest?: PatchedPointNotificationRequest, options?: any): AxiosPromise<PointNotification> {
            return localVarFp.pointNotificationPartialUpdate(id, hasRead, ordering, pointHistoryNotification, search, topPage, patchedPointNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
         * @param {number} id A unique integer value identifying this point notification.
         * @param {string} [hasRead] Filter by has_read
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [pointHistoryNotification] Get point history notifications list
         * @param {string} [search] A search term.
         * @param {string} [topPage] Get top page notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointNotificationRetrieve(id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, options?: any): AxiosPromise<PointNotification> {
            return localVarFp.pointNotificationRetrieve(id, hasRead, ordering, pointHistoryNotification, search, topPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointNotificationApi - object-oriented interface
 * @export
 * @class PointNotificationApi
 * @extends {BaseAPI}
 */
export class PointNotificationApi extends BaseAPI {
    /**
     * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
     * @param {string} [hasRead] Filter by has_read
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [pointHistoryNotification] Get point history notifications list
     * @param {string} [search] A search term.
     * @param {string} [topPage] Get top page notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointNotificationApi
     */
    public pointNotificationList(hasRead?: string, ordering?: string, page?: number, pageSize?: number, pointHistoryNotification?: string, search?: string, topPage?: string, options?: AxiosRequestConfig) {
        return PointNotificationApiFp(this.configuration).pointNotificationList(hasRead, ordering, page, pageSize, pointHistoryNotification, search, topPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
     * @param {number} id A unique integer value identifying this point notification.
     * @param {string} [hasRead] Filter by has_read
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [pointHistoryNotification] Get point history notifications list
     * @param {string} [search] A search term.
     * @param {string} [topPage] Get top page notifications
     * @param {PatchedPointNotificationRequest} [patchedPointNotificationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointNotificationApi
     */
    public pointNotificationPartialUpdate(id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, patchedPointNotificationRequest?: PatchedPointNotificationRequest, options?: AxiosRequestConfig) {
        return PointNotificationApiFp(this.configuration).pointNotificationPartialUpdate(id, hasRead, ordering, pointHistoryNotification, search, topPage, patchedPointNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows reading of point related notifications - API supports ordering by `created_at` - to get top page notification filter using `top_page=true` - to get point history notification filter using `point_history_notification=true` - filter by `has_read=true/false` PATCH request can be used to mark the notification as read
     * @param {number} id A unique integer value identifying this point notification.
     * @param {string} [hasRead] Filter by has_read
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [pointHistoryNotification] Get point history notifications list
     * @param {string} [search] A search term.
     * @param {string} [topPage] Get top page notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointNotificationApi
     */
    public pointNotificationRetrieve(id: number, hasRead?: string, ordering?: string, pointHistoryNotification?: string, search?: string, topPage?: string, options?: AxiosRequestConfig) {
        return PointNotificationApiFp(this.configuration).pointNotificationRetrieve(id, hasRead, ordering, pointHistoryNotification, search, topPage, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PointUsageApi - axios parameter creator
 * @export
 */
export const PointUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointUsageExportReportRetrieve: async (groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('pointUsageExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/point_usage/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointUsageList: async (groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('pointUsageList', 'groupId', groupId)
            const localVarPath = `/api/point_usage/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointUsageRetrieve: async (groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('pointUsageRetrieve', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pointUsageRetrieve', 'id', id)
            const localVarPath = `/api/point_usage/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointUsageApi - functional programming interface
 * @export
 */
export const PointUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointUsageExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointUsageExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointUsageList(groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointUsageList202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointUsageList(groupId, endDate, groupSearch, page, pageSize, search, startDate, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointUsageRetrieve(groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointUsageRetrieve(groupId, id, endDate, groupSearch, search, startDate, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointUsageApi - factory interface
 * @export
 */
export const PointUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointUsageApiFp(configuration)
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointUsageExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.pointUsageExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointUsageList(groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options?: any): AxiosPromise<PointUsageList202Response> {
            return localVarFp.pointUsageList(groupId, endDate, groupSearch, page, pageSize, search, startDate, userSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointUsageRetrieve(groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.pointUsageRetrieve(groupId, id, endDate, groupSearch, search, startDate, userSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointUsageApi - object-oriented interface
 * @export
 * @class PointUsageApi
 * @extends {BaseAPI}
 */
export class PointUsageApi extends BaseAPI {
    /**
     * 
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointUsageApi
     */
    public pointUsageExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return PointUsageApiFp(this.configuration).pointUsageExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointUsageApi
     */
    public pointUsageList(groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return PointUsageApiFp(this.configuration).pointUsageList(groupId, endDate, groupSearch, page, pageSize, search, startDate, userSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} groupId group_id
     * @param {number} id A unique integer value identifying this personal point history.
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointUsageApi
     */
    public pointUsageRetrieve(groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return PointUsageApiFp(this.configuration).pointUsageRetrieve(groupId, id, endDate, groupSearch, search, startDate, userSearch, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PointsHistoryApi - axios parameter creator
 * @export
 */
export const PointsHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsHistoryList: async (ordering?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/points_history/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsHistoryRetrieve: async (id: number, ordering?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pointsHistoryRetrieve', 'id', id)
            const localVarPath = `/api/points_history/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointsHistoryApi - functional programming interface
 * @export
 */
export const PointsHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointsHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointsHistoryList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointsHistoryList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointsHistoryList(ordering, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pointsHistoryRetrieve(id: number, ordering?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalPointHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pointsHistoryRetrieve(id, ordering, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PointsHistoryApi - factory interface
 * @export
 */
export const PointsHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointsHistoryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsHistoryList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<PointsHistoryList200Response> {
            return localVarFp.pointsHistoryList(ordering, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
         * @param {number} id A unique integer value identifying this personal point history.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pointsHistoryRetrieve(id: number, ordering?: string, search?: string, options?: any): AxiosPromise<PersonalPointHistory> {
            return localVarFp.pointsHistoryRetrieve(id, ordering, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PointsHistoryApi - object-oriented interface
 * @export
 * @class PointsHistoryApi
 * @extends {BaseAPI}
 */
export class PointsHistoryApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsHistoryApi
     */
    public pointsHistoryList(ordering?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return PointsHistoryApiFp(this.configuration).pointsHistoryList(ordering, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to read grant criteria list.  The API will get the current user, find all the point histories that are:   - Visible to the organization that the current user belong to  The List API will return a list of point histories, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by user_id  via the `search` parameter.   - sorted by `points` `created_at` and  The Detail API will return the details of the point history with the given ID.
     * @param {number} id A unique integer value identifying this personal point history.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsHistoryApi
     */
    public pointsHistoryRetrieve(id: number, ordering?: string, search?: string, options?: AxiosRequestConfig) {
        return PointsHistoryApiFp(this.configuration).pointsHistoryRetrieve(id, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductApplicationDataApi - axios parameter creator
 * @export
 */
export const ProductApplicationDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productApplicationDataExportReportRetrieve: async (groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('productApplicationDataExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/product_application_data/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productApplicationDataList: async (groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('productApplicationDataList', 'groupId', groupId)
            const localVarPath = `/api/product_application_data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {number} id A unique integer value identifying this redemption details.
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productApplicationDataRetrieve: async (groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('productApplicationDataRetrieve', 'groupId', groupId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productApplicationDataRetrieve', 'id', id)
            const localVarPath = `/api/product_application_data/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApplicationDataApi - functional programming interface
 * @export
 */
export const ProductApplicationDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApplicationDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productApplicationDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productApplicationDataExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productApplicationDataList(groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointUsageList202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productApplicationDataList(groupId, endDate, groupSearch, page, pageSize, search, startDate, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {number} id A unique integer value identifying this redemption details.
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productApplicationDataRetrieve(groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productApplicationDataRetrieve(groupId, id, endDate, groupSearch, search, startDate, userSearch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApplicationDataApi - factory interface
 * @export
 */
export const ProductApplicationDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApplicationDataApiFp(configuration)
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productApplicationDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.productApplicationDataExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productApplicationDataList(groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options?: any): AxiosPromise<PointUsageList202Response> {
            return localVarFp.productApplicationDataList(groupId, endDate, groupSearch, page, pageSize, search, startDate, userSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} groupId group_id
         * @param {number} id A unique integer value identifying this redemption details.
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productApplicationDataRetrieve(groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.productApplicationDataRetrieve(groupId, id, endDate, groupSearch, search, startDate, userSearch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApplicationDataApi - object-oriented interface
 * @export
 * @class ProductApplicationDataApi
 * @extends {BaseAPI}
 */
export class ProductApplicationDataApi extends BaseAPI {
    /**
     * 
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApplicationDataApi
     */
    public productApplicationDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return ProductApplicationDataApiFp(this.configuration).productApplicationDataExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApplicationDataApi
     */
    public productApplicationDataList(groupId: number, endDate?: string, groupSearch?: string, page?: number, pageSize?: number, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return ProductApplicationDataApiFp(this.configuration).productApplicationDataList(groupId, endDate, groupSearch, page, pageSize, search, startDate, userSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} groupId group_id
     * @param {number} id A unique integer value identifying this redemption details.
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group code or group name ( example :- code OR group name 1)
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApplicationDataApi
     */
    public productApplicationDataRetrieve(groupId: number, id: number, endDate?: string, groupSearch?: string, search?: string, startDate?: string, userSearch?: string, options?: AxiosRequestConfig) {
        return ProductApplicationDataApiFp(this.configuration).productApplicationDataRetrieve(groupId, id, endDate, groupSearch, search, startDate, userSearch, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RandomUserAvatarApi - axios parameter creator
 * @export
 */
export const RandomUserAvatarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to give avatar of other users.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        randomUserAvatarList: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/random_user_avatar/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RandomUserAvatarApi - functional programming interface
 * @export
 */
export const RandomUserAvatarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RandomUserAvatarApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to give avatar of other users.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async randomUserAvatarList(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RandomUserAvatar>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.randomUserAvatarList(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RandomUserAvatarApi - factory interface
 * @export
 */
export const RandomUserAvatarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RandomUserAvatarApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to give avatar of other users.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        randomUserAvatarList(search?: string, options?: any): AxiosPromise<Array<RandomUserAvatar>> {
            return localVarFp.randomUserAvatarList(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RandomUserAvatarApi - object-oriented interface
 * @export
 * @class RandomUserAvatarApi
 * @extends {BaseAPI}
 */
export class RandomUserAvatarApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to give avatar of other users.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RandomUserAvatarApi
     */
    public randomUserAvatarList(search?: string, options?: AxiosRequestConfig) {
        return RandomUserAvatarApiFp(this.configuration).randomUserAvatarList(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RedemptionApi - axios parameter creator
 * @export
 */
export const RedemptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RedemptionRequestRequest} redemptionRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionCreate: async (redemptionRequestRequest: RedemptionRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redemptionRequestRequest' is not null or undefined
            assertParamExists('redemptionCreate', 'redemptionRequestRequest', redemptionRequestRequest)
            const localVarPath = `/api/redemption/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redemptionRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionDestroy: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionDestroy', 'id', id)
            const localVarPath = `/api/redemption/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/redemption/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionPartialUpdate: async (id: number, search?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionPartialUpdate', 'id', id)
            const localVarPath = `/api/redemption/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedRedemptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} redemptionId redemption id to fetch pg url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionPaymentGatewayActivationRetrieve: async (redemptionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redemptionId' is not null or undefined
            assertParamExists('redemptionPaymentGatewayActivationRetrieve', 'redemptionId', redemptionId)
            const localVarPath = `/api/redemption/payment_gateway_activation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (redemptionId !== undefined) {
                localVarQueryParameter['redemption_id'] = redemptionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'cancel' | 'ok'} status status from payment gateway
         * @param {string} tid tid from payment gateway
         * @param {string} [param] param from payment gateway
         * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionPaymentGatewayStatusPartialUpdate: async (status: 'cancel' | 'ok', tid: string, param?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('redemptionPaymentGatewayStatusPartialUpdate', 'status', status)
            // verify required parameter 'tid' is not null or undefined
            assertParamExists('redemptionPaymentGatewayStatusPartialUpdate', 'tid', tid)
            const localVarPath = `/api/redemption/payment_gateway_status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (param !== undefined) {
                localVarQueryParameter['param'] = param;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (tid !== undefined) {
                localVarQueryParameter['tid'] = tid;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedRedemptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionRetrieve', 'id', id)
            const localVarPath = `/api/redemption/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {RedemptionRequest} redemptionRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionUpdate: async (id: number, redemptionRequest: RedemptionRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionUpdate', 'id', id)
            // verify required parameter 'redemptionRequest' is not null or undefined
            assertParamExists('redemptionUpdate', 'redemptionRequest', redemptionRequest)
            const localVarPath = `/api/redemption/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redemptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedemptionApi - functional programming interface
 * @export
 */
export const RedemptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedemptionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RedemptionRequestRequest} redemptionRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionCreate(redemptionRequestRequest: RedemptionRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionCreate(redemptionRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionDestroy(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionDestroy(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionPartialUpdate(id: number, search?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Redemption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionPartialUpdate(id, search, patchedRedemptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} redemptionId redemption id to fetch pg url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionPaymentGatewayActivationRetrieve(redemptionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PGActivation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionPaymentGatewayActivationRetrieve(redemptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'cancel' | 'ok'} status status from payment gateway
         * @param {string} tid tid from payment gateway
         * @param {string} [param] param from payment gateway
         * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionPaymentGatewayStatusPartialUpdate(status: 'cancel' | 'ok', tid: string, param?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionPaymentGatewayStatusPartialUpdate(status, tid, param, patchedRedemptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Redemption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {RedemptionRequest} redemptionRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionUpdate(id: number, redemptionRequest: RedemptionRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Redemption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionUpdate(id, redemptionRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RedemptionApi - factory interface
 * @export
 */
export const RedemptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedemptionApiFp(configuration)
    return {
        /**
         * 
         * @param {RedemptionRequestRequest} redemptionRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionCreate(redemptionRequestRequest: RedemptionRequestRequest, options?: any): AxiosPromise<RedemptionResponse> {
            return localVarFp.redemptionCreate(redemptionRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionDestroy(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.redemptionDestroy(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<RedemptionList200Response> {
            return localVarFp.redemptionList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionPartialUpdate(id: number, search?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options?: any): AxiosPromise<Redemption> {
            return localVarFp.redemptionPartialUpdate(id, search, patchedRedemptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} redemptionId redemption id to fetch pg url
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionPaymentGatewayActivationRetrieve(redemptionId: number, options?: any): AxiosPromise<PGActivation> {
            return localVarFp.redemptionPaymentGatewayActivationRetrieve(redemptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'cancel' | 'ok'} status status from payment gateway
         * @param {string} tid tid from payment gateway
         * @param {string} [param] param from payment gateway
         * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionPaymentGatewayStatusPartialUpdate(status: 'cancel' | 'ok', tid: string, param?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options?: any): AxiosPromise<RedemptionResponse> {
            return localVarFp.redemptionPaymentGatewayStatusPartialUpdate(status, tid, param, patchedRedemptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionRetrieve(id: number, search?: string, options?: any): AxiosPromise<Redemption> {
            return localVarFp.redemptionRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this redemption.
         * @param {RedemptionRequest} redemptionRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionUpdate(id: number, redemptionRequest: RedemptionRequest, search?: string, options?: any): AxiosPromise<Redemption> {
            return localVarFp.redemptionUpdate(id, redemptionRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedemptionApi - object-oriented interface
 * @export
 * @class RedemptionApi
 * @extends {BaseAPI}
 */
export class RedemptionApi extends BaseAPI {
    /**
     * 
     * @param {RedemptionRequestRequest} redemptionRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionCreate(redemptionRequestRequest: RedemptionRequestRequest, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionCreate(redemptionRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this redemption.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionDestroy(id: number, search?: string, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionDestroy(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this redemption.
     * @param {string} [search] A search term.
     * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionPartialUpdate(id: number, search?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionPartialUpdate(id, search, patchedRedemptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} redemptionId redemption id to fetch pg url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionPaymentGatewayActivationRetrieve(redemptionId: number, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionPaymentGatewayActivationRetrieve(redemptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'cancel' | 'ok'} status status from payment gateway
     * @param {string} tid tid from payment gateway
     * @param {string} [param] param from payment gateway
     * @param {PatchedRedemptionRequest} [patchedRedemptionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionPaymentGatewayStatusPartialUpdate(status: 'cancel' | 'ok', tid: string, param?: string, patchedRedemptionRequest?: PatchedRedemptionRequest, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionPaymentGatewayStatusPartialUpdate(status, tid, param, patchedRedemptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this redemption.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this redemption.
     * @param {RedemptionRequest} redemptionRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionApi
     */
    public redemptionUpdate(id: number, redemptionRequest: RedemptionRequest, search?: string, options?: AxiosRequestConfig) {
        return RedemptionApiFp(this.configuration).redemptionUpdate(id, redemptionRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RedemptionShippingAddressApi - axios parameter creator
 * @export
 */
export const RedemptionShippingAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressCreate: async (redemptionShippingAddressRequest: RedemptionShippingAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redemptionShippingAddressRequest' is not null or undefined
            assertParamExists('redemptionShippingAddressCreate', 'redemptionShippingAddressRequest', redemptionShippingAddressRequest)
            const localVarPath = `/api/redemption_shipping_address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redemptionShippingAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressDestroy: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionShippingAddressDestroy', 'id', id)
            const localVarPath = `/api/redemption_shipping_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/redemption_shipping_address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {PatchedRedemptionShippingAddressRequest} [patchedRedemptionShippingAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressPartialUpdate: async (id: number, search?: string, patchedRedemptionShippingAddressRequest?: PatchedRedemptionShippingAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionShippingAddressPartialUpdate', 'id', id)
            const localVarPath = `/api/redemption_shipping_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedRedemptionShippingAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionShippingAddressRetrieve', 'id', id)
            const localVarPath = `/api/redemption_shipping_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressUpdate: async (id: number, redemptionShippingAddressRequest: RedemptionShippingAddressRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('redemptionShippingAddressUpdate', 'id', id)
            // verify required parameter 'redemptionShippingAddressRequest' is not null or undefined
            assertParamExists('redemptionShippingAddressUpdate', 'redemptionShippingAddressRequest', redemptionShippingAddressRequest)
            const localVarPath = `/api/redemption_shipping_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redemptionShippingAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedemptionShippingAddressApi - functional programming interface
 * @export
 */
export const RedemptionShippingAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedemptionShippingAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionShippingAddressCreate(redemptionShippingAddressRequest: RedemptionShippingAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionShippingAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionShippingAddressCreate(redemptionShippingAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionShippingAddressDestroy(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionShippingAddressDestroy(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionShippingAddressList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionShippingAddressList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionShippingAddressList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {PatchedRedemptionShippingAddressRequest} [patchedRedemptionShippingAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionShippingAddressPartialUpdate(id: number, search?: string, patchedRedemptionShippingAddressRequest?: PatchedRedemptionShippingAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionShippingAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionShippingAddressPartialUpdate(id, search, patchedRedemptionShippingAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionShippingAddressRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionShippingAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionShippingAddressRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redemptionShippingAddressUpdate(id: number, redemptionShippingAddressRequest: RedemptionShippingAddressRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionShippingAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redemptionShippingAddressUpdate(id, redemptionShippingAddressRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RedemptionShippingAddressApi - factory interface
 * @export
 */
export const RedemptionShippingAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedemptionShippingAddressApiFp(configuration)
    return {
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressCreate(redemptionShippingAddressRequest: RedemptionShippingAddressRequest, options?: any): AxiosPromise<RedemptionShippingAddress> {
            return localVarFp.redemptionShippingAddressCreate(redemptionShippingAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressDestroy(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.redemptionShippingAddressDestroy(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<RedemptionShippingAddressList200Response> {
            return localVarFp.redemptionShippingAddressList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {PatchedRedemptionShippingAddressRequest} [patchedRedemptionShippingAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressPartialUpdate(id: number, search?: string, patchedRedemptionShippingAddressRequest?: PatchedRedemptionShippingAddressRequest, options?: any): AxiosPromise<RedemptionShippingAddress> {
            return localVarFp.redemptionShippingAddressPartialUpdate(id, search, patchedRedemptionShippingAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressRetrieve(id: number, search?: string, options?: any): AxiosPromise<RedemptionShippingAddress> {
            return localVarFp.redemptionShippingAddressRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user redemption shipping address.
         * @param {number} id A unique integer value identifying this redemption shipping address.
         * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redemptionShippingAddressUpdate(id: number, redemptionShippingAddressRequest: RedemptionShippingAddressRequest, search?: string, options?: any): AxiosPromise<RedemptionShippingAddress> {
            return localVarFp.redemptionShippingAddressUpdate(id, redemptionShippingAddressRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedemptionShippingAddressApi - object-oriented interface
 * @export
 * @class RedemptionShippingAddressApi
 * @extends {BaseAPI}
 */
export class RedemptionShippingAddressApi extends BaseAPI {
    /**
     * API endpoint that allows user redemption shipping address.
     * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionShippingAddressApi
     */
    public redemptionShippingAddressCreate(redemptionShippingAddressRequest: RedemptionShippingAddressRequest, options?: AxiosRequestConfig) {
        return RedemptionShippingAddressApiFp(this.configuration).redemptionShippingAddressCreate(redemptionShippingAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user redemption shipping address.
     * @param {number} id A unique integer value identifying this redemption shipping address.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionShippingAddressApi
     */
    public redemptionShippingAddressDestroy(id: number, search?: string, options?: AxiosRequestConfig) {
        return RedemptionShippingAddressApiFp(this.configuration).redemptionShippingAddressDestroy(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user redemption shipping address.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionShippingAddressApi
     */
    public redemptionShippingAddressList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return RedemptionShippingAddressApiFp(this.configuration).redemptionShippingAddressList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user redemption shipping address.
     * @param {number} id A unique integer value identifying this redemption shipping address.
     * @param {string} [search] A search term.
     * @param {PatchedRedemptionShippingAddressRequest} [patchedRedemptionShippingAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionShippingAddressApi
     */
    public redemptionShippingAddressPartialUpdate(id: number, search?: string, patchedRedemptionShippingAddressRequest?: PatchedRedemptionShippingAddressRequest, options?: AxiosRequestConfig) {
        return RedemptionShippingAddressApiFp(this.configuration).redemptionShippingAddressPartialUpdate(id, search, patchedRedemptionShippingAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user redemption shipping address.
     * @param {number} id A unique integer value identifying this redemption shipping address.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionShippingAddressApi
     */
    public redemptionShippingAddressRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return RedemptionShippingAddressApiFp(this.configuration).redemptionShippingAddressRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user redemption shipping address.
     * @param {number} id A unique integer value identifying this redemption shipping address.
     * @param {RedemptionShippingAddressRequest} redemptionShippingAddressRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedemptionShippingAddressApi
     */
    public redemptionShippingAddressUpdate(id: number, redemptionShippingAddressRequest: RedemptionShippingAddressRequest, search?: string, options?: AxiosRequestConfig) {
        return RedemptionShippingAddressApiFp(this.configuration).redemptionShippingAddressUpdate(id, redemptionShippingAddressRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchemaApi - axios parameter creator
 * @export
 */
export const SchemaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve: async (format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/schema/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemaApi - functional programming interface
 * @export
 */
export const SchemaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemaApiAxiosParamCreator(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schemaRetrieve(format, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchemaApi - factory interface
 * @export
 */
export const SchemaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemaApiFp(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.schemaRetrieve(format, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchemaApi - object-oriented interface
 * @export
 * @class SchemaApi
 * @extends {BaseAPI}
 */
export class SchemaApi extends BaseAPI {
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {'json' | 'yaml'} [format] 
     * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaApi
     */
    public schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: AxiosRequestConfig) {
        return SchemaApiFp(this.configuration).schemaRetrieve(format, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SearchThanksGivingByUserApi - axios parameter creator
 * @export
 */
export const SearchThanksGivingByUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to search thanks points (or Thanks Giving) by username.  The List API will return total number of thanks points exchanged between current user and searched user, with  pagination support (see `page` and `page_size` parameters)  The list API can be:   - searched by username by `search` parameter. eg: `/?search=dev`
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThanksGivingByUserList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/search_thanks_giving_by_user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchThanksGivingByUserApi - functional programming interface
 * @export
 */
export const SearchThanksGivingByUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchThanksGivingByUserApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to search thanks points (or Thanks Giving) by username.  The List API will return total number of thanks points exchanged between current user and searched user, with  pagination support (see `page` and `page_size` parameters)  The list API can be:   - searched by username by `search` parameter. eg: `/?search=dev`
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchThanksGivingByUserList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchThanksGivingByUserList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchThanksGivingByUserList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SearchThanksGivingByUserApi - factory interface
 * @export
 */
export const SearchThanksGivingByUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchThanksGivingByUserApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to search thanks points (or Thanks Giving) by username.  The List API will return total number of thanks points exchanged between current user and searched user, with  pagination support (see `page` and `page_size` parameters)  The list API can be:   - searched by username by `search` parameter. eg: `/?search=dev`
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThanksGivingByUserList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<SearchThanksGivingByUserList200Response> {
            return localVarFp.searchThanksGivingByUserList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchThanksGivingByUserApi - object-oriented interface
 * @export
 * @class SearchThanksGivingByUserApi
 * @extends {BaseAPI}
 */
export class SearchThanksGivingByUserApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to search thanks points (or Thanks Giving) by username.  The List API will return total number of thanks points exchanged between current user and searched user, with  pagination support (see `page` and `page_size` parameters)  The list API can be:   - searched by username by `search` parameter. eg: `/?search=dev`
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchThanksGivingByUserApi
     */
    public searchThanksGivingByUserList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return SearchThanksGivingByUserApiFp(this.configuration).searchThanksGivingByUserList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShoppingCartItemApi - axios parameter creator
 * @export
 */
export const ShoppingCartItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows to add shopping cart item.
         * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemCreate: async (shoppingCartItemRequest: ShoppingCartItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shoppingCartItemRequest' is not null or undefined
            assertParamExists('shoppingCartItemCreate', 'shoppingCartItemRequest', shoppingCartItemRequest)
            const localVarPath = `/api/shopping_cart_item/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shoppingCartItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemDestroy: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shoppingCartItemDestroy', 'id', id)
            const localVarPath = `/api/shopping_cart_item/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows to list shopping cart items.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shopping_cart_item/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows to update shopping cart item.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {PatchedShoppingCartItemRequest} [patchedShoppingCartItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemPartialUpdate: async (id: number, search?: string, patchedShoppingCartItemRequest?: PatchedShoppingCartItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shoppingCartItemPartialUpdate', 'id', id)
            const localVarPath = `/api/shopping_cart_item/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedShoppingCartItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shoppingCartItemRetrieve', 'id', id)
            const localVarPath = `/api/shopping_cart_item/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemUpdate: async (id: number, shoppingCartItemRequest: ShoppingCartItemRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('shoppingCartItemUpdate', 'id', id)
            // verify required parameter 'shoppingCartItemRequest' is not null or undefined
            assertParamExists('shoppingCartItemUpdate', 'shoppingCartItemRequest', shoppingCartItemRequest)
            const localVarPath = `/api/shopping_cart_item/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shoppingCartItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingCartItemApi - functional programming interface
 * @export
 */
export const ShoppingCartItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShoppingCartItemApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows to add shopping cart item.
         * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartItemCreate(shoppingCartItemRequest: ShoppingCartItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartItemCreate(shoppingCartItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartItemDestroy(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartItemDestroy(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows to list shopping cart items.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartItemList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItemList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartItemList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows to update shopping cart item.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {PatchedShoppingCartItemRequest} [patchedShoppingCartItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartItemPartialUpdate(id: number, search?: string, patchedShoppingCartItemRequest?: PatchedShoppingCartItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartItemPartialUpdate(id, search, patchedShoppingCartItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartItemRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartItemRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartItemUpdate(id: number, shoppingCartItemRequest: ShoppingCartItemRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartItemUpdate(id, shoppingCartItemRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShoppingCartItemApi - factory interface
 * @export
 */
export const ShoppingCartItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShoppingCartItemApiFp(configuration)
    return {
        /**
         * API endpoint that allows to add shopping cart item.
         * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemCreate(shoppingCartItemRequest: ShoppingCartItemRequest, options?: any): AxiosPromise<ShoppingCartItem> {
            return localVarFp.shoppingCartItemCreate(shoppingCartItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemDestroy(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.shoppingCartItemDestroy(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows to list shopping cart items.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<ShoppingCartItemList200Response> {
            return localVarFp.shoppingCartItemList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows to update shopping cart item.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {PatchedShoppingCartItemRequest} [patchedShoppingCartItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemPartialUpdate(id: number, search?: string, patchedShoppingCartItemRequest?: PatchedShoppingCartItemRequest, options?: any): AxiosPromise<ShoppingCartItem> {
            return localVarFp.shoppingCartItemPartialUpdate(id, search, patchedShoppingCartItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemRetrieve(id: number, search?: string, options?: any): AxiosPromise<ShoppingCartItem> {
            return localVarFp.shoppingCartItemRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows shopping cart.
         * @param {number} id A unique integer value identifying this shopping cart item.
         * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartItemUpdate(id: number, shoppingCartItemRequest: ShoppingCartItemRequest, search?: string, options?: any): AxiosPromise<ShoppingCartItem> {
            return localVarFp.shoppingCartItemUpdate(id, shoppingCartItemRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShoppingCartItemApi - object-oriented interface
 * @export
 * @class ShoppingCartItemApi
 * @extends {BaseAPI}
 */
export class ShoppingCartItemApi extends BaseAPI {
    /**
     * API endpoint that allows to add shopping cart item.
     * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartItemApi
     */
    public shoppingCartItemCreate(shoppingCartItemRequest: ShoppingCartItemRequest, options?: AxiosRequestConfig) {
        return ShoppingCartItemApiFp(this.configuration).shoppingCartItemCreate(shoppingCartItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows shopping cart.
     * @param {number} id A unique integer value identifying this shopping cart item.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartItemApi
     */
    public shoppingCartItemDestroy(id: number, search?: string, options?: AxiosRequestConfig) {
        return ShoppingCartItemApiFp(this.configuration).shoppingCartItemDestroy(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows to list shopping cart items.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartItemApi
     */
    public shoppingCartItemList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return ShoppingCartItemApiFp(this.configuration).shoppingCartItemList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows to update shopping cart item.
     * @param {number} id A unique integer value identifying this shopping cart item.
     * @param {string} [search] A search term.
     * @param {PatchedShoppingCartItemRequest} [patchedShoppingCartItemRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartItemApi
     */
    public shoppingCartItemPartialUpdate(id: number, search?: string, patchedShoppingCartItemRequest?: PatchedShoppingCartItemRequest, options?: AxiosRequestConfig) {
        return ShoppingCartItemApiFp(this.configuration).shoppingCartItemPartialUpdate(id, search, patchedShoppingCartItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows shopping cart.
     * @param {number} id A unique integer value identifying this shopping cart item.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartItemApi
     */
    public shoppingCartItemRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return ShoppingCartItemApiFp(this.configuration).shoppingCartItemRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows shopping cart.
     * @param {number} id A unique integer value identifying this shopping cart item.
     * @param {ShoppingCartItemRequest} shoppingCartItemRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartItemApi
     */
    public shoppingCartItemUpdate(id: number, shoppingCartItemRequest: ShoppingCartItemRequest, search?: string, options?: AxiosRequestConfig) {
        return ShoppingCartItemApiFp(this.configuration).shoppingCartItemUpdate(id, shoppingCartItemRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShoppingCartPointSummaryApi - axios parameter creator
 * @export
 */
export const ShoppingCartPointSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read their Shopping Cart Points Summary.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartPointSummaryRetrieve: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shopping_cart_point_summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingCartPointSummaryApi - functional programming interface
 * @export
 */
export const ShoppingCartPointSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShoppingCartPointSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Shopping Cart Points Summary.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shoppingCartPointSummaryRetrieve(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartPointSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shoppingCartPointSummaryRetrieve(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShoppingCartPointSummaryApi - factory interface
 * @export
 */
export const ShoppingCartPointSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShoppingCartPointSummaryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Shopping Cart Points Summary.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shoppingCartPointSummaryRetrieve(search?: string, options?: any): AxiosPromise<ShoppingCartPointSummary> {
            return localVarFp.shoppingCartPointSummaryRetrieve(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShoppingCartPointSummaryApi - object-oriented interface
 * @export
 * @class ShoppingCartPointSummaryApi
 * @extends {BaseAPI}
 */
export class ShoppingCartPointSummaryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read their Shopping Cart Points Summary.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartPointSummaryApi
     */
    public shoppingCartPointSummaryRetrieve(search?: string, options?: AxiosRequestConfig) {
        return ShoppingCartPointSummaryApiFp(this.configuration).shoppingCartPointSummaryRetrieve(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemNotificationsApi - axios parameter creator
 * @export
 */
export const SystemNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemNotificationsList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/system_notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemNotificationsRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('systemNotificationsRetrieve', 'id', id)
            const localVarPath = `/api/system_notifications/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemNotificationsApi - functional programming interface
 * @export
 */
export const SystemNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemNotificationsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemNotificationsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemNotificationsList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemNotificationsRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemNotificationsRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemNotificationsApi - factory interface
 * @export
 */
export const SystemNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemNotificationsApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemNotificationsList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<SystemNotificationsList200Response> {
            return localVarFp.systemNotificationsList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemNotificationsRetrieve(id: number, search?: string, options?: any): AxiosPromise<InformationMessage> {
            return localVarFp.systemNotificationsRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemNotificationsApi - object-oriented interface
 * @export
 * @class SystemNotificationsApi
 * @extends {BaseAPI}
 */
export class SystemNotificationsApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemNotificationsApi
     */
    public systemNotificationsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return SystemNotificationsApiFp(this.configuration).systemNotificationsList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read system notification sent from BOJ or company admin.  The API will get the current user, find all the messages that are: - Live. I.e `is_deleted=False` in DB - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date - Visible to the organization that the current user belong to - Based on read unread criteria.  The List API will return a list of available system notifications, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - searched by title and message via the `search` parameter. - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
     * @param {number} id A unique integer value identifying this information message.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemNotificationsApi
     */
    public systemNotificationsRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return SystemNotificationsApiFp(this.configuration).systemNotificationsRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaskProgressApi - axios parameter creator
 * @export
 */
export const TaskProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and  what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskProgressRetrieve: async (taskId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('taskProgressRetrieve', 'taskId', taskId)
            const localVarPath = `/api/task_progress/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskProgressApi - functional programming interface
 * @export
 */
export const TaskProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and  what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskProgressRetrieve(taskId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskProgressRetrieve(taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskProgressApi - factory interface
 * @export
 */
export const TaskProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskProgressApiFp(configuration)
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and  what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskProgressRetrieve(taskId: string, options?: any): AxiosPromise<void> {
            return localVarFp.taskProgressRetrieve(taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskProgressApi - object-oriented interface
 * @export
 * @class TaskProgressApi
 * @extends {BaseAPI}
 */
export class TaskProgressApi extends BaseAPI {
    /**
     * API endpoint that returns whether an Async job is finished, and  what to do with the job.
     * @param {string} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskProgressApi
     */
    public taskProgressRetrieve(taskId: string, options?: AxiosRequestConfig) {
        return TaskProgressApiFp(this.configuration).taskProgressRetrieve(taskId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaxDifferenceApi - axios parameter creator
 * @export
 */
export const TaxDifferenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [month] Filter by month
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [year] Filter by year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxDifferenceList: async (groupId: number, month?: string, page?: number, pageSize?: number, search?: string, year?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('taxDifferenceList', 'groupId', groupId)
            const localVarPath = `/api/tax_difference/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxDifferenceApi - functional programming interface
 * @export
 */
export const TaxDifferenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxDifferenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [month] Filter by month
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [year] Filter by year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taxDifferenceList(groupId: number, month?: string, page?: number, pageSize?: number, search?: string, year?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PointUsageList202Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taxDifferenceList(groupId, month, page, pageSize, search, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaxDifferenceApi - factory interface
 * @export
 */
export const TaxDifferenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxDifferenceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} groupId group_id
         * @param {string} [month] Filter by month
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [year] Filter by year
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taxDifferenceList(groupId: number, month?: string, page?: number, pageSize?: number, search?: string, year?: string, options?: any): AxiosPromise<PointUsageList202Response> {
            return localVarFp.taxDifferenceList(groupId, month, page, pageSize, search, year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxDifferenceApi - object-oriented interface
 * @export
 * @class TaxDifferenceApi
 * @extends {BaseAPI}
 */
export class TaxDifferenceApi extends BaseAPI {
    /**
     * 
     * @param {number} groupId group_id
     * @param {string} [month] Filter by month
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [year] Filter by year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxDifferenceApi
     */
    public taxDifferenceList(groupId: number, month?: string, page?: number, pageSize?: number, search?: string, year?: string, options?: AxiosRequestConfig) {
        return TaxDifferenceApiFp(this.configuration).taxDifferenceList(groupId, month, page, pageSize, search, year, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ThanksGivingApi - axios parameter creator
 * @export
 */
export const ThanksGivingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List the year and month of available Thanksgiving for current user. The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - can be filtered based on status parameter, which can be a comma separated values   - If `search` is given, only thanks giving with title containing the search word is considered Then it finds the unique months, order them from newest to oldest, and return a list of them.
         * @param {string} [expired] Filter expired points
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingListAvailableMonthsList: async (expired?: string, page?: number, pageSize?: number, search?: string, status?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/thanks_giving/list_available_months/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThanksGivingApi - functional programming interface
 * @export
 */
export const ThanksGivingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThanksGivingApiAxiosParamCreator(configuration)
    return {
        /**
         * List the year and month of available Thanksgiving for current user. The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - can be filtered based on status parameter, which can be a comma separated values   - If `search` is given, only thanks giving with title containing the search word is considered Then it finds the unique months, order them from newest to oldest, and return a list of them.
         * @param {string} [expired] Filter expired points
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksGivingListAvailableMonthsList(expired?: string, page?: number, pageSize?: number, search?: string, status?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrantPointsListAvailableMonthsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksGivingListAvailableMonthsList(expired, page, pageSize, search, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ThanksGivingApi - factory interface
 * @export
 */
export const ThanksGivingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThanksGivingApiFp(configuration)
    return {
        /**
         * List the year and month of available Thanksgiving for current user. The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - can be filtered based on status parameter, which can be a comma separated values   - If `search` is given, only thanks giving with title containing the search word is considered Then it finds the unique months, order them from newest to oldest, and return a list of them.
         * @param {string} [expired] Filter expired points
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingListAvailableMonthsList(expired?: string, page?: number, pageSize?: number, search?: string, status?: string, options?: any): AxiosPromise<GrantPointsListAvailableMonthsList200Response> {
            return localVarFp.thanksGivingListAvailableMonthsList(expired, page, pageSize, search, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThanksGivingApi - object-oriented interface
 * @export
 * @class ThanksGivingApi
 * @extends {BaseAPI}
 */
export class ThanksGivingApi extends BaseAPI {
    /**
     * List the year and month of available Thanksgiving for current user. The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Visible to the organization that the current user belong to   - can be filtered based on status parameter, which can be a comma separated values   - If `search` is given, only thanks giving with title containing the search word is considered Then it finds the unique months, order them from newest to oldest, and return a list of them.
     * @param {string} [expired] Filter expired points
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [status] Filter by status values can be comma separated, possible values(approved, pending, rejected)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksGivingApi
     */
    public thanksGivingListAvailableMonthsList(expired?: string, page?: number, pageSize?: number, search?: string, status?: string, options?: AxiosRequestConfig) {
        return ThanksGivingApiFp(this.configuration).thanksGivingListAvailableMonthsList(expired, page, pageSize, search, status, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ThanksGivingMessageApi - axios parameter creator
 * @export
 */
export const ThanksGivingMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {ThanksGivingMessageCreateRequest} thanksGivingMessageCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessageCreate: async (thanksGivingMessageCreateRequest: ThanksGivingMessageCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thanksGivingMessageCreateRequest' is not null or undefined
            assertParamExists('thanksGivingMessageCreate', 'thanksGivingMessageCreateRequest', thanksGivingMessageCreateRequest)
            const localVarPath = `/api/thanks_giving_message/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(thanksGivingMessageCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {boolean} [latestExchanges] Filter by latest_exchanges
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [thanksGiving] Filter by thanks_giving
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessageList: async (latestExchanges?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, thanksGiving?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/thanks_giving_message/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (latestExchanges !== undefined) {
                localVarQueryParameter['latest_exchanges'] = latestExchanges;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (thanksGiving !== undefined) {
                localVarQueryParameter['thanks_giving'] = thanksGiving;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {number} id A unique integer value identifying this thanks giving message.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {PatchedThanksGivingMessageReadRequest} [patchedThanksGivingMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessagePartialUpdate: async (id: number, ordering?: string, search?: string, patchedThanksGivingMessageReadRequest?: PatchedThanksGivingMessageReadRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('thanksGivingMessagePartialUpdate', 'id', id)
            const localVarPath = `/api/thanks_giving_message/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedThanksGivingMessageReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {number} id A unique integer value identifying this thanks giving message.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessageRetrieve: async (id: number, ordering?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('thanksGivingMessageRetrieve', 'id', id)
            const localVarPath = `/api/thanks_giving_message/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThanksGivingMessageApi - functional programming interface
 * @export
 */
export const ThanksGivingMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThanksGivingMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {ThanksGivingMessageCreateRequest} thanksGivingMessageCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksGivingMessageCreate(thanksGivingMessageCreateRequest: ThanksGivingMessageCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksGivingMessageCreate(thanksGivingMessageCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {boolean} [latestExchanges] Filter by latest_exchanges
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [thanksGiving] Filter by thanks_giving
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksGivingMessageList(latestExchanges?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, thanksGiving?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingMessageList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksGivingMessageList(latestExchanges, ordering, page, pageSize, search, thanksGiving, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {number} id A unique integer value identifying this thanks giving message.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {PatchedThanksGivingMessageReadRequest} [patchedThanksGivingMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksGivingMessagePartialUpdate(id: number, ordering?: string, search?: string, patchedThanksGivingMessageReadRequest?: PatchedThanksGivingMessageReadRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingMessageRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksGivingMessagePartialUpdate(id, ordering, search, patchedThanksGivingMessageReadRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {number} id A unique integer value identifying this thanks giving message.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksGivingMessageRetrieve(id: number, ordering?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGivingMessageList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksGivingMessageRetrieve(id, ordering, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ThanksGivingMessageApi - factory interface
 * @export
 */
export const ThanksGivingMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThanksGivingMessageApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {ThanksGivingMessageCreateRequest} thanksGivingMessageCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessageCreate(thanksGivingMessageCreateRequest: ThanksGivingMessageCreateRequest, options?: any): AxiosPromise<ThanksGivingMessageList> {
            return localVarFp.thanksGivingMessageCreate(thanksGivingMessageCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {boolean} [latestExchanges] Filter by latest_exchanges
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [thanksGiving] Filter by thanks_giving
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessageList(latestExchanges?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, thanksGiving?: string, options?: any): AxiosPromise<ThanksGivingMessageList200Response> {
            return localVarFp.thanksGivingMessageList(latestExchanges, ordering, page, pageSize, search, thanksGiving, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {number} id A unique integer value identifying this thanks giving message.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {PatchedThanksGivingMessageReadRequest} [patchedThanksGivingMessageReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessagePartialUpdate(id: number, ordering?: string, search?: string, patchedThanksGivingMessageReadRequest?: PatchedThanksGivingMessageReadRequest, options?: any): AxiosPromise<ThanksGivingMessageRead> {
            return localVarFp.thanksGivingMessagePartialUpdate(id, ordering, search, patchedThanksGivingMessageReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
         * @param {number} id A unique integer value identifying this thanks giving message.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksGivingMessageRetrieve(id: number, ordering?: string, search?: string, options?: any): AxiosPromise<ThanksGivingMessageList> {
            return localVarFp.thanksGivingMessageRetrieve(id, ordering, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThanksGivingMessageApi - object-oriented interface
 * @export
 * @class ThanksGivingMessageApi
 * @extends {BaseAPI}
 */
export class ThanksGivingMessageApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
     * @param {ThanksGivingMessageCreateRequest} thanksGivingMessageCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksGivingMessageApi
     */
    public thanksGivingMessageCreate(thanksGivingMessageCreateRequest: ThanksGivingMessageCreateRequest, options?: AxiosRequestConfig) {
        return ThanksGivingMessageApiFp(this.configuration).thanksGivingMessageCreate(thanksGivingMessageCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
     * @param {boolean} [latestExchanges] Filter by latest_exchanges
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [thanksGiving] Filter by thanks_giving
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksGivingMessageApi
     */
    public thanksGivingMessageList(latestExchanges?: boolean, ordering?: string, page?: number, pageSize?: number, search?: string, thanksGiving?: string, options?: AxiosRequestConfig) {
        return ThanksGivingMessageApiFp(this.configuration).thanksGivingMessageList(latestExchanges, ordering, page, pageSize, search, thanksGiving, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
     * @param {number} id A unique integer value identifying this thanks giving message.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {PatchedThanksGivingMessageReadRequest} [patchedThanksGivingMessageReadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksGivingMessageApi
     */
    public thanksGivingMessagePartialUpdate(id: number, ordering?: string, search?: string, patchedThanksGivingMessageReadRequest?: PatchedThanksGivingMessageReadRequest, options?: AxiosRequestConfig) {
        return ThanksGivingMessageApiFp(this.configuration).thanksGivingMessagePartialUpdate(id, ordering, search, patchedThanksGivingMessageReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read and create and update thanks giving message.  The List API will return a list of thanks messages sent or received by current user, with pagination support (     see `page` and `page_size` parameters)  The list API can also be:   - filtered by thanks giving, by passing the thanks_giving id value via the `thanks_giving` parameter.   eg: `/?thanks_giving=2`   - results are sorted by `created_date` in ascending order   - filtered by latest_exchanges, by passing the true via the `latest_exchanges` parameter.  The Detail API will return the details of the thanks message with the given ID.  The Create API will create a new thanks giving message object. The PATCH API will can be used to update the has_read field of the thanks giving message object.
     * @param {number} id A unique integer value identifying this thanks giving message.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksGivingMessageApi
     */
    public thanksGivingMessageRetrieve(id: number, ordering?: string, search?: string, options?: AxiosRequestConfig) {
        return ThanksGivingMessageApiFp(this.configuration).thanksGivingMessageRetrieve(id, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ThanksOnlyPointsCsvUploadApi - axios parameter creator
 * @export
 */
export const ThanksOnlyPointsCsvUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksOnlyPointsCsvUploadCreate: async (fileUploaded: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUploaded' is not null or undefined
            assertParamExists('thanksOnlyPointsCsvUploadCreate', 'fileUploaded', fileUploaded)
            const localVarPath = `/api/thanks_only_points_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (fileUploaded !== undefined) { 
                localVarFormParams.append('file_uploaded', fileUploaded as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.     
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksOnlyPointsCsvUploadDatabaseOperationRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('thanksOnlyPointsCsvUploadDatabaseOperationRetrieve', 'id', id)
            const localVarPath = `/api/thanks_only_points_csv_upload/database_operation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksOnlyPointsCsvUploadRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('thanksOnlyPointsCsvUploadRetrieve', 'id', id)
            const localVarPath = `/api/thanks_only_points_csv_upload/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThanksOnlyPointsCsvUploadApi - functional programming interface
 * @export
 */
export const ThanksOnlyPointsCsvUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThanksOnlyPointsCsvUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksOnlyPointsCsvUploadCreate(fileUploaded: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksOnlyPointsCsvUploadCreate(fileUploaded, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.     
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksOnlyPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksOnlyPointsCsvUploadRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ThanksOnlyPointsCsvUploadApi - factory interface
 * @export
 */
export const ThanksOnlyPointsCsvUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThanksOnlyPointsCsvUploadApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksOnlyPointsCsvUploadCreate(fileUploaded: File, options?: any): AxiosPromise<Task> {
            return localVarFp.thanksOnlyPointsCsvUploadCreate(fileUploaded, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.     
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksOnlyPointsCsvUploadRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.thanksOnlyPointsCsvUploadRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThanksOnlyPointsCsvUploadApi - object-oriented interface
 * @export
 * @class ThanksOnlyPointsCsvUploadApi
 * @extends {BaseAPI}
 */
export class ThanksOnlyPointsCsvUploadApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
     * @param {File} fileUploaded 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksOnlyPointsCsvUploadApi
     */
    public thanksOnlyPointsCsvUploadCreate(fileUploaded: File, options?: AxiosRequestConfig) {
        return ThanksOnlyPointsCsvUploadApiFp(this.configuration).thanksOnlyPointsCsvUploadCreate(fileUploaded, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to Create records in the database.     
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksOnlyPointsCsvUploadApi
     */
    public thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return ThanksOnlyPointsCsvUploadApiFp(this.configuration).thanksOnlyPointsCsvUploadDatabaseOperationRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Thanks Only Points related CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Only Points CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksOnlyPointsCsvUploadApi
     */
    public thanksOnlyPointsCsvUploadRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return ThanksOnlyPointsCsvUploadApiFp(this.configuration).thanksOnlyPointsCsvUploadRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ThanksPointApi - axios parameter creator
 * @export
 */
export const ThanksPointApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
         * @param {GiveThanksPointRequest} giveThanksPointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointCreate: async (giveThanksPointRequest: GiveThanksPointRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'giveThanksPointRequest' is not null or undefined
            assertParamExists('thanksPointCreate', 'giveThanksPointRequest', giveThanksPointRequest)
            const localVarPath = `/api/thanks_point`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(giveThanksPointRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [transaction] transaction
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointList: async (page?: number, pageSize?: number, search?: string, transaction?: string, user?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/thanks_point`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (transaction !== undefined) {
                localVarQueryParameter['transaction'] = transaction;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThanksPointApi - functional programming interface
 * @export
 */
export const ThanksPointApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThanksPointApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
         * @param {GiveThanksPointRequest} giveThanksPointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksPointCreate(giveThanksPointRequest: GiveThanksPointRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksGiving>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksPointCreate(giveThanksPointRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [transaction] transaction
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksPointList(page?: number, pageSize?: number, search?: string, transaction?: string, user?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThanksPointList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksPointList(page, pageSize, search, transaction, user, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ThanksPointApi - factory interface
 * @export
 */
export const ThanksPointApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThanksPointApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
         * @param {GiveThanksPointRequest} giveThanksPointRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointCreate(giveThanksPointRequest: GiveThanksPointRequest, options?: any): AxiosPromise<ThanksGiving> {
            return localVarFp.thanksPointCreate(giveThanksPointRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [transaction] transaction
         * @param {string} [user] user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointList(page?: number, pageSize?: number, search?: string, transaction?: string, user?: string, options?: any): AxiosPromise<ThanksPointList200Response> {
            return localVarFp.thanksPointList(page, pageSize, search, transaction, user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThanksPointApi - object-oriented interface
 * @export
 * @class ThanksPointApi
 * @extends {BaseAPI}
 */
export class ThanksPointApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
     * @param {GiveThanksPointRequest} giveThanksPointRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksPointApi
     */
    public thanksPointCreate(giveThanksPointRequest: GiveThanksPointRequest, options?: AxiosRequestConfig) {
        return ThanksPointApiFp(this.configuration).thanksPointCreate(giveThanksPointRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to read and create thanks points (or Thanks Giving).  The List API will return a list of thanks points exchanged between current user and other user, with pagination support (see `page` and `page_size` parameters)  The list API can also be:   - searched by title, message by `search` parameter.   - filtered by `transaction` and `user`, by passing the user id value via the `user` parameter.   eg: `/?user=2`   - results are sorted by `created_date` in descending order  The Detail API will return the details of the thanks points(or Thanks Giving) with the given ID.  The Create API will create a new Thanksgiving object.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [transaction] transaction
     * @param {string} [user] user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksPointApi
     */
    public thanksPointList(page?: number, pageSize?: number, search?: string, transaction?: string, user?: string, options?: AxiosRequestConfig) {
        return ThanksPointApiFp(this.configuration).thanksPointList(page, pageSize, search, transaction, user, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ThanksPointsApproveRejectApi - axios parameter creator
 * @export
 */
export const ThanksPointsApproveRejectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointsApproveRejectCreate: async (fileUploaded: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileUploaded' is not null or undefined
            assertParamExists('thanksPointsApproveRejectCreate', 'fileUploaded', fileUploaded)
            const localVarPath = `/api/thanks_points_approve_reject/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (fileUploaded !== undefined) { 
                localVarFormParams.append('file_uploaded', fileUploaded as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.     
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointsApproveRejectDatabaseOperationRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('thanksPointsApproveRejectDatabaseOperationRetrieve', 'id', id)
            const localVarPath = `/api/thanks_points_approve_reject/database_operation/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointsApproveRejectRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('thanksPointsApproveRejectRetrieve', 'id', id)
            const localVarPath = `/api/thanks_points_approve_reject/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThanksPointsApproveRejectApi - functional programming interface
 * @export
 */
export const ThanksPointsApproveRejectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThanksPointsApproveRejectApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksPointsApproveRejectCreate(fileUploaded: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksPointsApproveRejectCreate(fileUploaded, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.     
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksPointsApproveRejectDatabaseOperationRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksPointsApproveRejectDatabaseOperationRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thanksPointsApproveRejectRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thanksPointsApproveRejectRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ThanksPointsApproveRejectApi - factory interface
 * @export
 */
export const ThanksPointsApproveRejectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThanksPointsApproveRejectApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {File} fileUploaded 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointsApproveRejectCreate(fileUploaded: File, options?: any): AxiosPromise<Task> {
            return localVarFp.thanksPointsApproveRejectCreate(fileUploaded, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to Create records in the database.     
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointsApproveRejectDatabaseOperationRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.thanksPointsApproveRejectDatabaseOperationRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
         * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thanksPointsApproveRejectRetrieve(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.thanksPointsApproveRejectRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThanksPointsApproveRejectApi - object-oriented interface
 * @export
 * @class ThanksPointsApproveRejectApi
 * @extends {BaseAPI}
 */
export class ThanksPointsApproveRejectApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
     * @param {File} fileUploaded 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksPointsApproveRejectApi
     */
    public thanksPointsApproveRejectCreate(fileUploaded: File, options?: AxiosRequestConfig) {
        return ThanksPointsApproveRejectApiFp(this.configuration).thanksPointsApproveRejectCreate(fileUploaded, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to Create records in the database.     
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksPointsApproveRejectApi
     */
    public thanksPointsApproveRejectDatabaseOperationRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return ThanksPointsApproveRejectApiFp(this.configuration).thanksPointsApproveRejectDatabaseOperationRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to download and upload the Thanks Points Approve or Reject CSV file. - To Download Sample CSV file pass id = 0 - To Download Thanks Points Approve OR Reject CSV Error file pass the actual id received while uploading the file. - To upload the Thanks Only Points CSV file pass the file to the POST Method
     * @param {number} id To download error file pass the row id/ for sample file pass the id as 0
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThanksPointsApproveRejectApi
     */
    public thanksPointsApproveRejectRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return ThanksPointsApproveRejectApiFp(this.configuration).thanksPointsApproveRejectRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
         * @param {string} [transactionType] Filter by transaction type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionList: async (ordering?: string, page?: number, pageSize?: number, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/transaction/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (transactionDirection !== undefined) {
                localVarQueryParameter['transaction_direction'] = transactionDirection;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transaction_type'] = transactionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this transaction.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
         * @param {string} [transactionType] Filter by transaction type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionRetrieve: async (id: number, ordering?: string, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transactionRetrieve', 'id', id)
            const localVarPath = `/api/transaction/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (transactionDirection !== undefined) {
                localVarQueryParameter['transaction_direction'] = transactionDirection;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transaction_type'] = transactionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
         * @param {string} [transactionType] Filter by transaction type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionList(ordering?: string, page?: number, pageSize?: number, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionList(ordering, page, pageSize, search, transactionDirection, transactionType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this transaction.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
         * @param {string} [transactionType] Filter by transaction type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transactionRetrieve(id: number, ordering?: string, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Transaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transactionRetrieve(id, ordering, search, transactionDirection, transactionType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
         * @param {string} [transactionType] Filter by transaction type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionList(ordering?: string, page?: number, pageSize?: number, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options?: any): AxiosPromise<TransactionList200Response> {
            return localVarFp.transactionList(ordering, page, pageSize, search, transactionDirection, transactionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this transaction.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
         * @param {string} [transactionType] Filter by transaction type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactionRetrieve(id: number, ordering?: string, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options?: any): AxiosPromise<Transaction> {
            return localVarFp.transactionRetrieve(id, ordering, search, transactionDirection, transactionType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
     * @param {string} [transactionType] Filter by transaction type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionList(ordering?: string, page?: number, pageSize?: number, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionList(ordering, page, pageSize, search, transactionDirection, transactionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id A unique integer value identifying this transaction.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {'gaining' | 'losing'} [transactionDirection] transaction_direction
     * @param {string} [transactionType] Filter by transaction type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public transactionRetrieve(id: number, ordering?: string, search?: string, transactionDirection?: 'gaining' | 'losing', transactionType?: string, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).transactionRetrieve(id, ordering, search, transactionDirection, transactionType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadS3UrlApi - axios parameter creator
 * @export
 */
export const UploadS3UrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint to get the AWS S3 presigned URL for uploading images to S3 from browser (CKEditor)
         * @param {string} fileName File name to be uploaded
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadS3UrlRetrieve: async (fileName: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('uploadS3UrlRetrieve', 'fileName', fileName)
            const localVarPath = `/api/upload-s3-url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['file_name'] = fileName;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadS3UrlApi - functional programming interface
 * @export
 */
export const UploadS3UrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadS3UrlApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint to get the AWS S3 presigned URL for uploading images to S3 from browser (CKEditor)
         * @param {string} fileName File name to be uploaded
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadS3UrlRetrieve(fileName: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<S3UploadURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadS3UrlRetrieve(fileName, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadS3UrlApi - factory interface
 * @export
 */
export const UploadS3UrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadS3UrlApiFp(configuration)
    return {
        /**
         * API endpoint to get the AWS S3 presigned URL for uploading images to S3 from browser (CKEditor)
         * @param {string} fileName File name to be uploaded
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadS3UrlRetrieve(fileName: string, search?: string, options?: any): AxiosPromise<S3UploadURLResponse> {
            return localVarFp.uploadS3UrlRetrieve(fileName, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadS3UrlApi - object-oriented interface
 * @export
 * @class UploadS3UrlApi
 * @extends {BaseAPI}
 */
export class UploadS3UrlApi extends BaseAPI {
    /**
     * API endpoint to get the AWS S3 presigned URL for uploading images to S3 from browser (CKEditor)
     * @param {string} fileName File name to be uploaded
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadS3UrlApi
     */
    public uploadS3UrlRetrieve(fileName: string, search?: string, options?: AxiosRequestConfig) {
        return UploadS3UrlApiFp(this.configuration).uploadS3UrlRetrieve(fileName, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAdminDashboardSummaryApi - axios parameter creator
 * @export
 */
export const UserAdminDashboardSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `user_name`,   - `user_image`   - `grant_point_flag`
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminDashboardSummaryRetrieve: async (groupId: number, userId: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userAdminDashboardSummaryRetrieve', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userAdminDashboardSummaryRetrieve', 'userId', userId)
            const localVarPath = `/api/user-admin-dashboard-summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAdminDashboardSummaryApi - functional programming interface
 * @export
 */
export const UserAdminDashboardSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAdminDashboardSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `user_name`,   - `user_image`   - `grant_point_flag`
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAdminDashboardSummaryRetrieve(groupId: number, userId: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminDashboardSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAdminDashboardSummaryRetrieve(groupId, userId, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAdminDashboardSummaryApi - factory interface
 * @export
 */
export const UserAdminDashboardSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAdminDashboardSummaryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `user_name`,   - `user_image`   - `grant_point_flag`
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {number} userId Filter by user id, if logged in user is a admin user
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminDashboardSummaryRetrieve(groupId: number, userId: number, search?: string, options?: any): AxiosPromise<UserAdminDashboardSummary> {
            return localVarFp.userAdminDashboardSummaryRetrieve(groupId, userId, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAdminDashboardSummaryApi - object-oriented interface
 * @export
 * @class UserAdminDashboardSummaryApi
 * @extends {BaseAPI}
 */
export class UserAdminDashboardSummaryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `user_name`,   - `user_image`   - `grant_point_flag`
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {number} userId Filter by user id, if logged in user is a admin user
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminDashboardSummaryApi
     */
    public userAdminDashboardSummaryRetrieve(groupId: number, userId: number, search?: string, options?: AxiosRequestConfig) {
        return UserAdminDashboardSummaryApiFp(this.configuration).userAdminDashboardSummaryRetrieve(groupId, userId, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserAdminGroupDashboardSummaryApi - axios parameter creator
 * @export
 */
export const UserAdminGroupDashboardSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in admin user to read the Group Dashboard Summary.    The API returns a single object with following fields:     - `normal_points`,     - `total_points`,     - `thanks_exclusive_points`,     - `grant_points`,     - `thanks_point_flag`,     - `grant_point_flag`,     - `redeemed_points`,     - `expired_points`,     - `recieved_thanks_points`,     - `gifted_thanks_points`,     - `thanks_giving_pending_request`,     - `user_info`,
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminGroupDashboardSummaryRetrieve: async (groupId: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userAdminGroupDashboardSummaryRetrieve', 'groupId', groupId)
            const localVarPath = `/api/user-admin-group-dashboard-summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAdminGroupDashboardSummaryApi - functional programming interface
 * @export
 */
export const UserAdminGroupDashboardSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserAdminGroupDashboardSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to read the Group Dashboard Summary.    The API returns a single object with following fields:     - `normal_points`,     - `total_points`,     - `thanks_exclusive_points`,     - `grant_points`,     - `thanks_point_flag`,     - `grant_point_flag`,     - `redeemed_points`,     - `expired_points`,     - `recieved_thanks_points`,     - `gifted_thanks_points`,     - `thanks_giving_pending_request`,     - `user_info`,
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userAdminGroupDashboardSummaryRetrieve(groupId: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAdminDashboardGroupSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userAdminGroupDashboardSummaryRetrieve(groupId, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserAdminGroupDashboardSummaryApi - factory interface
 * @export
 */
export const UserAdminGroupDashboardSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserAdminGroupDashboardSummaryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to read the Group Dashboard Summary.    The API returns a single object with following fields:     - `normal_points`,     - `total_points`,     - `thanks_exclusive_points`,     - `grant_points`,     - `thanks_point_flag`,     - `grant_point_flag`,     - `redeemed_points`,     - `expired_points`,     - `recieved_thanks_points`,     - `gifted_thanks_points`,     - `thanks_giving_pending_request`,     - `user_info`,
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminGroupDashboardSummaryRetrieve(groupId: number, search?: string, options?: any): AxiosPromise<UserAdminDashboardGroupSummary> {
            return localVarFp.userAdminGroupDashboardSummaryRetrieve(groupId, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAdminGroupDashboardSummaryApi - object-oriented interface
 * @export
 * @class UserAdminGroupDashboardSummaryApi
 * @extends {BaseAPI}
 */
export class UserAdminGroupDashboardSummaryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in admin user to read the Group Dashboard Summary.    The API returns a single object with following fields:     - `normal_points`,     - `total_points`,     - `thanks_exclusive_points`,     - `grant_points`,     - `thanks_point_flag`,     - `grant_point_flag`,     - `redeemed_points`,     - `expired_points`,     - `recieved_thanks_points`,     - `gifted_thanks_points`,     - `thanks_giving_pending_request`,     - `user_info`,
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdminGroupDashboardSummaryApi
     */
    public userAdminGroupDashboardSummaryRetrieve(groupId: number, search?: string, options?: AxiosRequestConfig) {
        return UserAdminGroupDashboardSummaryApiFp(this.configuration).userAdminGroupDashboardSummaryRetrieve(groupId, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserCountSummaryApi - axios parameter creator
 * @export
 */
export const UserCountSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to Count Summary.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCountSummaryRetrieve: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_count_summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserCountSummaryApi - functional programming interface
 * @export
 */
export const UserCountSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserCountSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to Count Summary.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userCountSummaryRetrieve(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userCountSummaryRetrieve(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserCountSummaryApi - factory interface
 * @export
 */
export const UserCountSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserCountSummaryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to Count Summary.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCountSummaryRetrieve(search?: string, options?: any): AxiosPromise<UserCountSummary> {
            return localVarFp.userCountSummaryRetrieve(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserCountSummaryApi - object-oriented interface
 * @export
 * @class UserCountSummaryApi
 * @extends {BaseAPI}
 */
export class UserCountSummaryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to Count Summary.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserCountSummaryApi
     */
    public userCountSummaryRetrieve(search?: string, options?: AxiosRequestConfig) {
        return UserCountSummaryApiFp(this.configuration).userCountSummaryRetrieve(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserDashboardRankingApi - axios parameter creator
 * @export
 */
export const UserDashboardRankingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDashboardRankingRetrieve: async (endDate: string, startDate: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('userDashboardRankingRetrieve', 'endDate', endDate)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userDashboardRankingRetrieve', 'startDate', startDate)
            const localVarPath = `/api/user_dashboard_ranking/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserDashboardRankingApi - functional programming interface
 * @export
 */
export const UserDashboardRankingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserDashboardRankingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDashboardRankingRetrieve(endDate: string, startDate: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardRanking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userDashboardRankingRetrieve(endDate, startDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserDashboardRankingApi - factory interface
 * @export
 */
export const UserDashboardRankingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserDashboardRankingApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDashboardRankingRetrieve(endDate: string, startDate: string, search?: string, options?: any): AxiosPromise<UserDashboardRanking> {
            return localVarFp.userDashboardRankingRetrieve(endDate, startDate, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserDashboardRankingApi - object-oriented interface
 * @export
 * @class UserDashboardRankingApi
 * @extends {BaseAPI}
 */
export class UserDashboardRankingApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read the ranking of donated and gift points.  The List API will return a list of monthly gifted and donated points ranking for the login user.  - `gift_points` : It will give a list of points detail gifted to the logged-in user from other users     in current month, - `donated_points`: It will give a list of points detail donated from the logged-in user to     other users in current month, - `total_gift_points`: It will give the sum of total points user has received in current month, - `total_gift_times`: It will give the count of number of times user has received points in current     month, - `total_donated_points`:  It will give the sum of total points user has donated in current month, - `total_donated_times`: It will give the count of number of times user has donated points in     current month
     * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
     * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDashboardRankingApi
     */
    public userDashboardRankingRetrieve(endDate: string, startDate: string, search?: string, options?: AxiosRequestConfig) {
        return UserDashboardRankingApiFp(this.configuration).userDashboardRankingRetrieve(endDate, startDate, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserDashboardSummaryApi - axios parameter creator
 * @export
 */
export const UserDashboardSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `grant_point_flag`
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDashboardSummaryRetrieve: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-dashboard-summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserDashboardSummaryApi - functional programming interface
 * @export
 */
export const UserDashboardSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserDashboardSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `grant_point_flag`
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDashboardSummaryRetrieve(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userDashboardSummaryRetrieve(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserDashboardSummaryApi - factory interface
 * @export
 */
export const UserDashboardSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserDashboardSummaryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `grant_point_flag`
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDashboardSummaryRetrieve(search?: string, options?: any): AxiosPromise<UserDashboardSummary> {
            return localVarFp.userDashboardSummaryRetrieve(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserDashboardSummaryApi - object-oriented interface
 * @export
 * @class UserDashboardSummaryApi
 * @extends {BaseAPI}
 */
export class UserDashboardSummaryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read their Dashboard Summary.    The API returns a single object with following fields:   - `total_points`,   - `thanks_exclusive_points`,   - `normal_points`,   - `last_login`,   - `login_counter`,   - `grant_points`,   - `admin_user`,   - `thanks_point_flag`   - `grant_point_flag`
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDashboardSummaryApi
     */
    public userDashboardSummaryRetrieve(search?: string, options?: AxiosRequestConfig) {
        return UserDashboardSummaryApiFp(this.configuration).userDashboardSummaryRetrieve(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserDataApi - axios parameter creator
 * @export
 */
export const UserDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to Download User Data.     - To Download CSV file pass organization_id
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [isEmailRegistered] User with or without email address select (true/false/both)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] Search User with using_employee_id
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {string} [withLoginHistory] Search the User for if User Have Ever Logged in atleast Once
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDataRetrieve: async (groupId: number, endDate?: string, groupSearch?: string, isEmailRegistered?: string, search?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, withLoginHistory?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userDataRetrieve', 'groupId', groupId)
            const localVarPath = `/api/user_data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (isEmailRegistered !== undefined) {
                localVarQueryParameter['is_email_registered'] = isEmailRegistered;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }

            if (usersNotCoveredByTheSystem !== undefined) {
                localVarQueryParameter['users_not_covered_by_the_system'] = usersNotCoveredByTheSystem;
            }

            if (withLoginHistory !== undefined) {
                localVarQueryParameter['with_login_history'] = withLoginHistory;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserDataApi - functional programming interface
 * @export
 */
export const UserDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserDataApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download User Data.     - To Download CSV file pass organization_id
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [isEmailRegistered] User with or without email address select (true/false/both)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] Search User with using_employee_id
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {string} [withLoginHistory] Search the User for if User Have Ever Logged in atleast Once
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDataRetrieve(groupId: number, endDate?: string, groupSearch?: string, isEmailRegistered?: string, search?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, withLoginHistory?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userDataRetrieve(groupId, endDate, groupSearch, isEmailRegistered, search, startDate, userSearch, usersNotCoveredByTheSystem, withLoginHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserDataApi - factory interface
 * @export
 */
export const UserDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserDataApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download User Data.     - To Download CSV file pass organization_id
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [isEmailRegistered] User with or without email address select (true/false/both)
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] Search User with using_employee_id
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {string} [withLoginHistory] Search the User for if User Have Ever Logged in atleast Once
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDataRetrieve(groupId: number, endDate?: string, groupSearch?: string, isEmailRegistered?: string, search?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, withLoginHistory?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userDataRetrieve(groupId, endDate, groupSearch, isEmailRegistered, search, startDate, userSearch, usersNotCoveredByTheSystem, withLoginHistory, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserDataApi - object-oriented interface
 * @export
 * @class UserDataApi
 * @extends {BaseAPI}
 */
export class UserDataApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to Download User Data.     - To Download CSV file pass organization_id
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
     * @param {string} [isEmailRegistered] User with or without email address select (true/false/both)
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] Search User with using_employee_id
     * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
     * @param {string} [withLoginHistory] Search the User for if User Have Ever Logged in atleast Once
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDataApi
     */
    public userDataRetrieve(groupId: number, endDate?: string, groupSearch?: string, isEmailRegistered?: string, search?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, withLoginHistory?: string, options?: AxiosRequestConfig) {
        return UserDataApiFp(this.configuration).userDataRetrieve(groupId, endDate, groupSearch, isEmailRegistered, search, startDate, userSearch, usersNotCoveredByTheSystem, withLoginHistory, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGrantCriteriaRankingApi - axios parameter creator
 * @export
 */
export const UserGrantCriteriaRankingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGrantCriteriaRankingRetrieve: async (endDate: string, startDate: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('userGrantCriteriaRankingRetrieve', 'endDate', endDate)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userGrantCriteriaRankingRetrieve', 'startDate', startDate)
            const localVarPath = `/api/user-grant-criteria-ranking/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGrantCriteriaRankingApi - functional programming interface
 * @export
 */
export const UserGrantCriteriaRankingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGrantCriteriaRankingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGrantCriteriaRankingRetrieve(endDate: string, startDate: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardGranCriteriaRanking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGrantCriteriaRankingRetrieve(endDate, startDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGrantCriteriaRankingApi - factory interface
 * @export
 */
export const UserGrantCriteriaRankingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGrantCriteriaRankingApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGrantCriteriaRankingRetrieve(endDate: string, startDate: string, search?: string, options?: any): AxiosPromise<UserDashboardGranCriteriaRanking> {
            return localVarFp.userGrantCriteriaRankingRetrieve(endDate, startDate, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGrantCriteriaRankingApi - object-oriented interface
 * @export
 * @class UserGrantCriteriaRankingApi
 * @extends {BaseAPI}
 */
export class UserGrantCriteriaRankingApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read the ranking of grant criteria for current month.     If an admin user want to know the ranking of the same group general user then user have to pass     group_id and user_id of general user. If passed user_id not belongs to admin user group - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
     * @param {string} endDate Show the dashboard grant criteria ranking according to user                              selected month end date in format YYYY-MM-DD
     * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month start date in format YYYY-MM-DD
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGrantCriteriaRankingApi
     */
    public userGrantCriteriaRankingRetrieve(endDate: string, startDate: string, search?: string, options?: AxiosRequestConfig) {
        return UserGrantCriteriaRankingApiFp(this.configuration).userGrantCriteriaRankingRetrieve(endDate, startDate, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupDashboardRankingApi - axios parameter creator
 * @export
 */
export const UserGroupDashboardRankingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard thanks giving ranking according to user                              selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupDashboardRankingRetrieve: async (groupId: number, startDate: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userGroupDashboardRankingRetrieve', 'groupId', groupId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userGroupDashboardRankingRetrieve', 'startDate', startDate)
            const localVarPath = `/api/user_group_dashboard_ranking/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupDashboardRankingApi - functional programming interface
 * @export
 */
export const UserGroupDashboardRankingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupDashboardRankingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard thanks giving ranking according to user                              selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGroupDashboardRankingRetrieve(groupId: number, startDate: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupDashboardRanking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGroupDashboardRankingRetrieve(groupId, startDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupDashboardRankingApi - factory interface
 * @export
 */
export const UserGroupDashboardRankingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupDashboardRankingApiFp(configuration)
    return {
        /**
         * 
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard thanks giving ranking according to user                              selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupDashboardRankingRetrieve(groupId: number, startDate: string, search?: string, options?: any): AxiosPromise<UserGroupDashboardRanking> {
            return localVarFp.userGroupDashboardRankingRetrieve(groupId, startDate, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupDashboardRankingApi - object-oriented interface
 * @export
 * @class UserGroupDashboardRankingApi
 * @extends {BaseAPI}
 */
export class UserGroupDashboardRankingApi extends BaseAPI {
    /**
     * 
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} startDate Show the dashboard thanks giving ranking according to user                              selected month date in format YYYY-MM-DD
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupDashboardRankingApi
     */
    public userGroupDashboardRankingRetrieve(groupId: number, startDate: string, search?: string, options?: AxiosRequestConfig) {
        return UserGroupDashboardRankingApiFp(this.configuration).userGroupDashboardRankingRetrieve(groupId, startDate, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupGrantCriteriaRankingApi - axios parameter creator
 * @export
 */
export const UserGroupGrantCriteriaRankingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in admin user to read the ranking of grant criteria for the current month of a Selected Group.  - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupGrantCriteriaRankingRetrieve: async (groupId: number, startDate: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userGroupGrantCriteriaRankingRetrieve', 'groupId', groupId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userGroupGrantCriteriaRankingRetrieve', 'startDate', startDate)
            const localVarPath = `/api/user-group-grant-criteria-ranking/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupGrantCriteriaRankingApi - functional programming interface
 * @export
 */
export const UserGroupGrantCriteriaRankingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupGrantCriteriaRankingApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to read the ranking of grant criteria for the current month of a Selected Group.  - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGroupGrantCriteriaRankingRetrieve(groupId: number, startDate: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardGranCriteriaRanking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGroupGrantCriteriaRankingRetrieve(groupId, startDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupGrantCriteriaRankingApi - factory interface
 * @export
 */
export const UserGroupGrantCriteriaRankingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupGrantCriteriaRankingApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to read the ranking of grant criteria for the current month of a Selected Group.  - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupGrantCriteriaRankingRetrieve(groupId: number, startDate: string, search?: string, options?: any): AxiosPromise<UserDashboardGranCriteriaRanking> {
            return localVarFp.userGroupGrantCriteriaRankingRetrieve(groupId, startDate, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupGrantCriteriaRankingApi - object-oriented interface
 * @export
 * @class UserGroupGrantCriteriaRankingApi
 * @extends {BaseAPI}
 */
export class UserGroupGrantCriteriaRankingApi extends BaseAPI {
    /**
     * API endpoint that allows logged in admin user to read the ranking of grant criteria for the current month of a Selected Group.  - `grant_criteria_points` : It will give a list of grant criteria in descending order of total     points  received from a grant criteria in current month, - `grant_criteria_times`: It will give a list of grant criteria in descending order of total number     of times points received from a grant criteria in current month
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} startDate Show the dashboard grant criteria ranking according to user                              selected month date in format YYYY-MM-DD
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupGrantCriteriaRankingApi
     */
    public userGroupGrantCriteriaRankingRetrieve(groupId: number, startDate: string, search?: string, options?: AxiosRequestConfig) {
        return UserGroupGrantCriteriaRankingApiFp(this.configuration).userGroupGrantCriteriaRankingRetrieve(groupId, startDate, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserGroupPointStatusApi - axios parameter creator
 * @export
 */
export const UserGroupPointStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in admin user to read and points detail.  The API will take `start_date` as an input parameter for the range admin user want to see group point history  The List API will return an object of following: 1. Normal Point 2. Thanks Exclusive Point 3. Monthly User Login Activity 4. Monthly User Point Activity
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the chart data according to user selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupPointStatusRetrieve: async (groupId: number, startDate: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userGroupPointStatusRetrieve', 'groupId', groupId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userGroupPointStatusRetrieve', 'startDate', startDate)
            const localVarPath = `/api/user_group_point_status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupPointStatusApi - functional programming interface
 * @export
 */
export const UserGroupPointStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupPointStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to read and points detail.  The API will take `start_date` as an input parameter for the range admin user want to see group point history  The List API will return an object of following: 1. Normal Point 2. Thanks Exclusive Point 3. Monthly User Login Activity 4. Monthly User Point Activity
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the chart data according to user selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGroupPointStatusRetrieve(groupId: number, startDate: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGroupPointStatusRetrieve(groupId, startDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupPointStatusApi - factory interface
 * @export
 */
export const UserGroupPointStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupPointStatusApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to read and points detail.  The API will take `start_date` as an input parameter for the range admin user want to see group point history  The List API will return an object of following: 1. Normal Point 2. Thanks Exclusive Point 3. Monthly User Login Activity 4. Monthly User Point Activity
         * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
         * @param {string} startDate Show the chart data according to user selected month date in format YYYY-MM-DD
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroupPointStatusRetrieve(groupId: number, startDate: string, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userGroupPointStatusRetrieve(groupId, startDate, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserGroupPointStatusApi - object-oriented interface
 * @export
 * @class UserGroupPointStatusApi
 * @extends {BaseAPI}
 */
export class UserGroupPointStatusApi extends BaseAPI {
    /**
     * API endpoint that allows logged in admin user to read and points detail.  The API will take `start_date` as an input parameter for the range admin user want to see group point history  The List API will return an object of following: 1. Normal Point 2. Thanks Exclusive Point 3. Monthly User Login Activity 4. Monthly User Point Activity
     * @param {number} groupId Filter by group_id, to check admin user and general user belongs                         to same group
     * @param {string} startDate Show the chart data according to user selected month date in format YYYY-MM-DD
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupPointStatusApi
     */
    public userGroupPointStatusRetrieve(groupId: number, startDate: string, search?: string, options?: AxiosRequestConfig) {
        return UserGroupPointStatusApiFp(this.configuration).userGroupPointStatusRetrieve(groupId, startDate, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserNotificationSettingsApi - axios parameter creator
 * @export
 */
export const UserNotificationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API ednpoint that allows user email notification settings.
         * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsCreate: async (userNotificationSettingsRequest: UserNotificationSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userNotificationSettingsRequest' is not null or undefined
            assertParamExists('userNotificationSettingsCreate', 'userNotificationSettingsRequest', userNotificationSettingsRequest)
            const localVarPath = `/api/user_notification_settings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userNotificationSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsDestroy: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userNotificationSettingsDestroy', 'id', id)
            const localVarPath = `/api/user_notification_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_notification_settings/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {PatchedUserNotificationSettingsRequest} [patchedUserNotificationSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsPartialUpdate: async (id: number, search?: string, patchedUserNotificationSettingsRequest?: PatchedUserNotificationSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userNotificationSettingsPartialUpdate', 'id', id)
            const localVarPath = `/api/user_notification_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserNotificationSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userNotificationSettingsRetrieve', 'id', id)
            const localVarPath = `/api/user_notification_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsUpdate: async (id: number, userNotificationSettingsRequest: UserNotificationSettingsRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userNotificationSettingsUpdate', 'id', id)
            // verify required parameter 'userNotificationSettingsRequest' is not null or undefined
            assertParamExists('userNotificationSettingsUpdate', 'userNotificationSettingsRequest', userNotificationSettingsRequest)
            const localVarPath = `/api/user_notification_settings/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userNotificationSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserNotificationSettingsApi - functional programming interface
 * @export
 */
export const UserNotificationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserNotificationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * API ednpoint that allows user email notification settings.
         * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationSettingsCreate(userNotificationSettingsRequest: UserNotificationSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationSettingsCreate(userNotificationSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationSettingsDestroy(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationSettingsDestroy(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationSettingsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationSettingsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationSettingsList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {PatchedUserNotificationSettingsRequest} [patchedUserNotificationSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationSettingsPartialUpdate(id: number, search?: string, patchedUserNotificationSettingsRequest?: PatchedUserNotificationSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationSettingsPartialUpdate(id, search, patchedUserNotificationSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationSettingsRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationSettingsRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationSettingsUpdate(id: number, userNotificationSettingsRequest: UserNotificationSettingsRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationSettingsUpdate(id, userNotificationSettingsRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserNotificationSettingsApi - factory interface
 * @export
 */
export const UserNotificationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserNotificationSettingsApiFp(configuration)
    return {
        /**
         * API ednpoint that allows user email notification settings.
         * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsCreate(userNotificationSettingsRequest: UserNotificationSettingsRequest, options?: any): AxiosPromise<UserNotificationSettings> {
            return localVarFp.userNotificationSettingsCreate(userNotificationSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsDestroy(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.userNotificationSettingsDestroy(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<UserNotificationSettingsList200Response> {
            return localVarFp.userNotificationSettingsList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {PatchedUserNotificationSettingsRequest} [patchedUserNotificationSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsPartialUpdate(id: number, search?: string, patchedUserNotificationSettingsRequest?: PatchedUserNotificationSettingsRequest, options?: any): AxiosPromise<UserNotificationSettings> {
            return localVarFp.userNotificationSettingsPartialUpdate(id, search, patchedUserNotificationSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsRetrieve(id: number, search?: string, options?: any): AxiosPromise<UserNotificationSettings> {
            return localVarFp.userNotificationSettingsRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user email notification settings.
         * @param {number} id A unique integer value identifying this user notification settings.
         * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationSettingsUpdate(id: number, userNotificationSettingsRequest: UserNotificationSettingsRequest, search?: string, options?: any): AxiosPromise<UserNotificationSettings> {
            return localVarFp.userNotificationSettingsUpdate(id, userNotificationSettingsRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserNotificationSettingsApi - object-oriented interface
 * @export
 * @class UserNotificationSettingsApi
 * @extends {BaseAPI}
 */
export class UserNotificationSettingsApi extends BaseAPI {
    /**
     * API ednpoint that allows user email notification settings.
     * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationSettingsApi
     */
    public userNotificationSettingsCreate(userNotificationSettingsRequest: UserNotificationSettingsRequest, options?: AxiosRequestConfig) {
        return UserNotificationSettingsApiFp(this.configuration).userNotificationSettingsCreate(userNotificationSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user email notification settings.
     * @param {number} id A unique integer value identifying this user notification settings.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationSettingsApi
     */
    public userNotificationSettingsDestroy(id: number, search?: string, options?: AxiosRequestConfig) {
        return UserNotificationSettingsApiFp(this.configuration).userNotificationSettingsDestroy(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user email notification settings.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationSettingsApi
     */
    public userNotificationSettingsList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return UserNotificationSettingsApiFp(this.configuration).userNotificationSettingsList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user email notification settings.
     * @param {number} id A unique integer value identifying this user notification settings.
     * @param {string} [search] A search term.
     * @param {PatchedUserNotificationSettingsRequest} [patchedUserNotificationSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationSettingsApi
     */
    public userNotificationSettingsPartialUpdate(id: number, search?: string, patchedUserNotificationSettingsRequest?: PatchedUserNotificationSettingsRequest, options?: AxiosRequestConfig) {
        return UserNotificationSettingsApiFp(this.configuration).userNotificationSettingsPartialUpdate(id, search, patchedUserNotificationSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user email notification settings.
     * @param {number} id A unique integer value identifying this user notification settings.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationSettingsApi
     */
    public userNotificationSettingsRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return UserNotificationSettingsApiFp(this.configuration).userNotificationSettingsRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user email notification settings.
     * @param {number} id A unique integer value identifying this user notification settings.
     * @param {UserNotificationSettingsRequest} userNotificationSettingsRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationSettingsApi
     */
    public userNotificationSettingsUpdate(id: number, userNotificationSettingsRequest: UserNotificationSettingsRequest, search?: string, options?: AxiosRequestConfig) {
        return UserNotificationSettingsApiFp(this.configuration).userNotificationSettingsUpdate(id, userNotificationSettingsRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserPointDataApi - axios parameter creator
 * @export
 */
export const UserPointDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointDataExportReportRetrieve: async (groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('userPointDataExportReportRetrieve', 'groupId', groupId)
            const localVarPath = `/api/user_point_data/export_report/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (groupSearch !== undefined) {
                localVarQueryParameter['group_search'] = groupSearch;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userSearch !== undefined) {
                localVarQueryParameter['user_search'] = userSearch;
            }

            if (usersNotCoveredByTheSystem !== undefined) {
                localVarQueryParameter['users_not_covered_by_the_system'] = usersNotCoveredByTheSystem;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointDataList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user_point_data/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointDataRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userPointDataRetrieve', 'id', id)
            const localVarPath = `/api/user_point_data/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPointDataApi - functional programming interface
 * @export
 */
export const UserPointDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPointDataApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPointDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Task>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPointDataExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, usersNotCoveredByTheSystem, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPointDataList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPointDataList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPointDataList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPointDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPointDataRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPointDataApi - factory interface
 * @export
 */
export const UserPointDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPointDataApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} groupId group_id
         * @param {string} [endDate] Filter by end date
         * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
         * @param {string} [startDate] Filter by start date
         * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
         * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options?: any): AxiosPromise<Task> {
            return localVarFp.userPointDataExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, usersNotCoveredByTheSystem, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointDataList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<UserPointDataList200Response> {
            return localVarFp.userPointDataList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged-in user to Download user points csv.     
         * @param {number} id A unique integer value identifying this ユーザー.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointDataRetrieve(id: number, search?: string, options?: any): AxiosPromise<CustomUser> {
            return localVarFp.userPointDataRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPointDataApi - object-oriented interface
 * @export
 * @class UserPointDataApi
 * @extends {BaseAPI}
 */
export class UserPointDataApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to Download user points csv.     
     * @param {number} groupId group_id
     * @param {string} [endDate] Filter by end date
     * @param {string} [groupSearch] search group_id or group_name ( example :- 1 OR Group name 1)
     * @param {string} [startDate] Filter by start date
     * @param {string} [userSearch] search user_id or username ( example :- 1 OR dev)
     * @param {string} [usersNotCoveredByTheSystem] Users not covered by the system select ( included / not_included )
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPointDataApi
     */
    public userPointDataExportReportRetrieve(groupId: number, endDate?: string, groupSearch?: string, startDate?: string, userSearch?: string, usersNotCoveredByTheSystem?: string, options?: AxiosRequestConfig) {
        return UserPointDataApiFp(this.configuration).userPointDataExportReportRetrieve(groupId, endDate, groupSearch, startDate, userSearch, usersNotCoveredByTheSystem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to Download user points csv.     
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPointDataApi
     */
    public userPointDataList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return UserPointDataApiFp(this.configuration).userPointDataList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged-in user to Download user points csv.     
     * @param {number} id A unique integer value identifying this ユーザー.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPointDataApi
     */
    public userPointDataRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return UserPointDataApiFp(this.configuration).userPointDataRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserPointStatusApi - axios parameter creator
 * @export
 */
export const UserPointStatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
         * @param {string} endDate Filter by end date
         * @param {string} startDate Filter by start date
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointStatusRetrieve: async (endDate: string, startDate: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('userPointStatusRetrieve', 'endDate', endDate)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('userPointStatusRetrieve', 'startDate', startDate)
            const localVarPath = `/api/user_point_status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPointStatusApi - functional programming interface
 * @export
 */
export const UserPointStatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPointStatusApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
         * @param {string} endDate Filter by end date
         * @param {string} startDate Filter by start date
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPointStatusRetrieve(endDate: string, startDate: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDashboardPointChart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userPointStatusRetrieve(endDate, startDate, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserPointStatusApi - factory interface
 * @export
 */
export const UserPointStatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPointStatusApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
         * @param {string} endDate Filter by end date
         * @param {string} startDate Filter by start date
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPointStatusRetrieve(endDate: string, startDate: string, search?: string, options?: any): AxiosPromise<UserDashboardPointChart> {
            return localVarFp.userPointStatusRetrieve(endDate, startDate, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPointStatusApi - object-oriented interface
 * @export
 * @class UserPointStatusApi
 * @extends {BaseAPI}
 */
export class UserPointStatusApi extends BaseAPI {
    /**
     * API endpoint that allows logged-in user to read and points detail.  The API will take `start_date` and `end_date` as an input parameter for the range user want to see point history  The List API will return a list of balanced points, grant points, gifted points, donated points, use points, wipe out points between the user selected date range
     * @param {string} endDate Filter by end date
     * @param {string} startDate Filter by start date
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPointStatusApi
     */
    public userPointStatusRetrieve(endDate: string, startDate: string, search?: string, options?: AxiosRequestConfig) {
        return UserPointStatusApiFp(this.configuration).userPointStatusRetrieve(endDate, startDate, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserProfileSummaryApi - axios parameter creator
 * @export
 */
export const UserProfileSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read their Profile Summary.  The API returns a single object with following fields:   - `grant_points`,   - `total_points`,   - `thanks_exclusive_points`,   - `thanks_points`,   - `points_expire_by_today`   - `gifted_thanks_points`   - `received_thanks_point`
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileSummaryRetrieve: async (search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-profile-summary/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileSummaryApi - functional programming interface
 * @export
 */
export const UserProfileSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Profile Summary.  The API returns a single object with following fields:   - `grant_points`,   - `total_points`,   - `thanks_exclusive_points`,   - `thanks_points`,   - `points_expire_by_today`   - `gifted_thanks_points`   - `received_thanks_point`
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfileSummaryRetrieve(search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfileSummaryRetrieve(search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserProfileSummaryApi - factory interface
 * @export
 */
export const UserProfileSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileSummaryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read their Profile Summary.  The API returns a single object with following fields:   - `grant_points`,   - `total_points`,   - `thanks_exclusive_points`,   - `thanks_points`,   - `points_expire_by_today`   - `gifted_thanks_points`   - `received_thanks_point`
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileSummaryRetrieve(search?: string, options?: any): AxiosPromise<UserProfileSummary> {
            return localVarFp.userProfileSummaryRetrieve(search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileSummaryApi - object-oriented interface
 * @export
 * @class UserProfileSummaryApi
 * @extends {BaseAPI}
 */
export class UserProfileSummaryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read their Profile Summary.  The API returns a single object with following fields:   - `grant_points`,   - `total_points`,   - `thanks_exclusive_points`,   - `thanks_points`,   - `points_expire_by_today`   - `gifted_thanks_points`   - `received_thanks_point`
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileSummaryApi
     */
    public userProfileSummaryRetrieve(search?: string, options?: AxiosRequestConfig) {
        return UserProfileSummaryApiFp(this.configuration).userProfileSummaryRetrieve(search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VoucherAddressApi - axios parameter creator
 * @export
 */
export const VoucherAddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows user voucher address.
         * @param {VoucherAddressRequest} voucherAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressCreate: async (voucherAddressRequest: VoucherAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voucherAddressRequest' is not null or undefined
            assertParamExists('voucherAddressCreate', 'voucherAddressRequest', voucherAddressRequest)
            const localVarPath = `/api/voucher_address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voucherAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressDestroy: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('voucherAddressDestroy', 'id', id)
            const localVarPath = `/api/voucher_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressList: async (page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/voucher_address/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {PatchedVoucherAddressRequest} [patchedVoucherAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressPartialUpdate: async (id: number, search?: string, patchedVoucherAddressRequest?: PatchedVoucherAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('voucherAddressPartialUpdate', 'id', id)
            const localVarPath = `/api/voucher_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedVoucherAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressRetrieve: async (id: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('voucherAddressRetrieve', 'id', id)
            const localVarPath = `/api/voucher_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {VoucherAddressRequest} voucherAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressUpdate: async (id: number, voucherAddressRequest: VoucherAddressRequest, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('voucherAddressUpdate', 'id', id)
            // verify required parameter 'voucherAddressRequest' is not null or undefined
            assertParamExists('voucherAddressUpdate', 'voucherAddressRequest', voucherAddressRequest)
            const localVarPath = `/api/voucher_address/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voucherAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoucherAddressApi - functional programming interface
 * @export
 */
export const VoucherAddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoucherAddressApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows user voucher address.
         * @param {VoucherAddressRequest} voucherAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voucherAddressCreate(voucherAddressRequest: VoucherAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voucherAddressCreate(voucherAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voucherAddressDestroy(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voucherAddressDestroy(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voucherAddressList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherAddressList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voucherAddressList(page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {PatchedVoucherAddressRequest} [patchedVoucherAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voucherAddressPartialUpdate(id: number, search?: string, patchedVoucherAddressRequest?: PatchedVoucherAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voucherAddressPartialUpdate(id, search, patchedVoucherAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voucherAddressRetrieve(id: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voucherAddressRetrieve(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {VoucherAddressRequest} voucherAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voucherAddressUpdate(id: number, voucherAddressRequest: VoucherAddressRequest, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoucherAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voucherAddressUpdate(id, voucherAddressRequest, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VoucherAddressApi - factory interface
 * @export
 */
export const VoucherAddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoucherAddressApiFp(configuration)
    return {
        /**
         * API endpoint that allows user voucher address.
         * @param {VoucherAddressRequest} voucherAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressCreate(voucherAddressRequest: VoucherAddressRequest, options?: any): AxiosPromise<VoucherAddress> {
            return localVarFp.voucherAddressCreate(voucherAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressDestroy(id: number, search?: string, options?: any): AxiosPromise<void> {
            return localVarFp.voucherAddressDestroy(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressList(page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<VoucherAddressList200Response> {
            return localVarFp.voucherAddressList(page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {PatchedVoucherAddressRequest} [patchedVoucherAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressPartialUpdate(id: number, search?: string, patchedVoucherAddressRequest?: PatchedVoucherAddressRequest, options?: any): AxiosPromise<VoucherAddress> {
            return localVarFp.voucherAddressPartialUpdate(id, search, patchedVoucherAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressRetrieve(id: number, search?: string, options?: any): AxiosPromise<VoucherAddress> {
            return localVarFp.voucherAddressRetrieve(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows user voucher address.
         * @param {number} id A unique integer value identifying this voucher address.
         * @param {VoucherAddressRequest} voucherAddressRequest 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voucherAddressUpdate(id: number, voucherAddressRequest: VoucherAddressRequest, search?: string, options?: any): AxiosPromise<VoucherAddress> {
            return localVarFp.voucherAddressUpdate(id, voucherAddressRequest, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VoucherAddressApi - object-oriented interface
 * @export
 * @class VoucherAddressApi
 * @extends {BaseAPI}
 */
export class VoucherAddressApi extends BaseAPI {
    /**
     * API endpoint that allows user voucher address.
     * @param {VoucherAddressRequest} voucherAddressRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoucherAddressApi
     */
    public voucherAddressCreate(voucherAddressRequest: VoucherAddressRequest, options?: AxiosRequestConfig) {
        return VoucherAddressApiFp(this.configuration).voucherAddressCreate(voucherAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user voucher address.
     * @param {number} id A unique integer value identifying this voucher address.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoucherAddressApi
     */
    public voucherAddressDestroy(id: number, search?: string, options?: AxiosRequestConfig) {
        return VoucherAddressApiFp(this.configuration).voucherAddressDestroy(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user voucher address.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoucherAddressApi
     */
    public voucherAddressList(page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return VoucherAddressApiFp(this.configuration).voucherAddressList(page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user voucher address.
     * @param {number} id A unique integer value identifying this voucher address.
     * @param {string} [search] A search term.
     * @param {PatchedVoucherAddressRequest} [patchedVoucherAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoucherAddressApi
     */
    public voucherAddressPartialUpdate(id: number, search?: string, patchedVoucherAddressRequest?: PatchedVoucherAddressRequest, options?: AxiosRequestConfig) {
        return VoucherAddressApiFp(this.configuration).voucherAddressPartialUpdate(id, search, patchedVoucherAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user voucher address.
     * @param {number} id A unique integer value identifying this voucher address.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoucherAddressApi
     */
    public voucherAddressRetrieve(id: number, search?: string, options?: AxiosRequestConfig) {
        return VoucherAddressApiFp(this.configuration).voucherAddressRetrieve(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows user voucher address.
     * @param {number} id A unique integer value identifying this voucher address.
     * @param {VoucherAddressRequest} voucherAddressRequest 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoucherAddressApi
     */
    public voucherAddressUpdate(id: number, voucherAddressRequest: VoucherAddressRequest, search?: string, options?: AxiosRequestConfig) {
        return VoucherAddressApiFp(this.configuration).voucherAddressUpdate(id, voucherAddressRequest, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WhatsNewApi - axios parameter creator
 * @export
 */
export const WhatsNewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewList: async (createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/whats_new/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewRetrieve: async (id: number, createdMonth?: string, createdYear?: string, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('whatsNewRetrieve', 'id', id)
            const localVarPath = `/api/whats_new/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhatsNewApi - functional programming interface
 * @export
 */
export const WhatsNewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhatsNewApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewList(createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemNotificationsList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewList(createdMonth, createdYear, page, pageSize, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewRetrieve(id: number, createdMonth?: string, createdYear?: string, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewRetrieve(id, createdMonth, createdYear, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhatsNewApi - factory interface
 * @export
 */
export const WhatsNewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhatsNewApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewList(createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options?: any): AxiosPromise<SystemNotificationsList200Response> {
            return localVarFp.whatsNewList(createdMonth, createdYear, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewRetrieve(id: number, createdMonth?: string, createdYear?: string, search?: string, options?: any): AxiosPromise<InformationMessage> {
            return localVarFp.whatsNewRetrieve(id, createdMonth, createdYear, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhatsNewApi - object-oriented interface
 * @export
 * @class WhatsNewApi
 * @extends {BaseAPI}
 */
export class WhatsNewApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewApi
     */
    public whatsNewList(createdMonth?: string, createdYear?: string, page?: number, pageSize?: number, search?: string, options?: AxiosRequestConfig) {
        return WhatsNewApiFp(this.configuration).whatsNewList(createdMonth, createdYear, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in user to read messages sent from BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB   - Within \"shown\" period. I.e, the current date should be greater than `start_showing` date   - Visible to the organization that the current user belong to  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message.
     * @param {number} id A unique integer value identifying this information message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewApi
     */
    public whatsNewRetrieve(id: number, createdMonth?: string, createdYear?: string, search?: string, options?: AxiosRequestConfig) {
        return WhatsNewApiFp(this.configuration).whatsNewRetrieve(id, createdMonth, createdYear, search, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WhatsNewAdminApi - axios parameter creator
 * @export
 */
export const WhatsNewAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {InformationMessageAdminCreateRequest} informationMessageAdminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminCreate: async (informationMessageAdminCreateRequest: InformationMessageAdminCreateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'informationMessageAdminCreateRequest' is not null or undefined
            assertParamExists('whatsNewAdminCreate', 'informationMessageAdminCreateRequest', informationMessageAdminCreateRequest)
            const localVarPath = `/api/whats_new_admin/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(informationMessageAdminCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminDestroy: async (id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('whatsNewAdminDestroy', 'id', id)
            const localVarPath = `/api/whats_new_admin/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminList: async (createdMonth?: string, createdYear?: string, endDate?: string, page?: number, pageSize?: number, search?: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/whats_new_admin/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {PatchedInformationMessageAdminUpdateRequest} [patchedInformationMessageAdminUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminPartialUpdate: async (id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, patchedInformationMessageAdminUpdateRequest?: PatchedInformationMessageAdminUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('whatsNewAdminPartialUpdate', 'id', id)
            const localVarPath = `/api/whats_new_admin/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedInformationMessageAdminUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminRetrieve: async (id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('whatsNewAdminRetrieve', 'id', id)
            const localVarPath = `/api/whats_new_admin/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (createdMonth !== undefined) {
                localVarQueryParameter['created_month'] = createdMonth;
            }

            if (createdYear !== undefined) {
                localVarQueryParameter['created_year'] = createdYear;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhatsNewAdminApi - functional programming interface
 * @export
 */
export const WhatsNewAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhatsNewAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {InformationMessageAdminCreateRequest} informationMessageAdminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewAdminCreate(informationMessageAdminCreateRequest: InformationMessageAdminCreateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessageAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewAdminCreate(informationMessageAdminCreateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewAdminDestroy(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewAdminDestroy(id, createdMonth, createdYear, endDate, search, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewAdminList(createdMonth?: string, createdYear?: string, endDate?: string, page?: number, pageSize?: number, search?: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatsNewAdminList200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewAdminList(createdMonth, createdYear, endDate, page, pageSize, search, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {PatchedInformationMessageAdminUpdateRequest} [patchedInformationMessageAdminUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewAdminPartialUpdate(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, patchedInformationMessageAdminUpdateRequest?: PatchedInformationMessageAdminUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessageAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewAdminPartialUpdate(id, createdMonth, createdYear, endDate, search, startDate, patchedInformationMessageAdminUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whatsNewAdminRetrieve(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InformationMessageAdmin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whatsNewAdminRetrieve(id, createdMonth, createdYear, endDate, search, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WhatsNewAdminApi - factory interface
 * @export
 */
export const WhatsNewAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhatsNewAdminApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {InformationMessageAdminCreateRequest} informationMessageAdminCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminCreate(informationMessageAdminCreateRequest: InformationMessageAdminCreateRequest, options?: any): AxiosPromise<InformationMessageAdmin> {
            return localVarFp.whatsNewAdminCreate(informationMessageAdminCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminDestroy(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.whatsNewAdminDestroy(id, createdMonth, createdYear, endDate, search, startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminList(createdMonth?: string, createdYear?: string, endDate?: string, page?: number, pageSize?: number, search?: string, startDate?: string, options?: any): AxiosPromise<WhatsNewAdminList200Response> {
            return localVarFp.whatsNewAdminList(createdMonth, createdYear, endDate, page, pageSize, search, startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {PatchedInformationMessageAdminUpdateRequest} [patchedInformationMessageAdminUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminPartialUpdate(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, patchedInformationMessageAdminUpdateRequest?: PatchedInformationMessageAdminUpdateRequest, options?: any): AxiosPromise<InformationMessageAdmin> {
            return localVarFp.whatsNewAdminPartialUpdate(id, createdMonth, createdYear, endDate, search, startDate, patchedInformationMessageAdminUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
         * @param {number} id A unique integer value identifying this information message.
         * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
         * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
         * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
         * @param {string} [search] A search term.
         * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whatsNewAdminRetrieve(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options?: any): AxiosPromise<InformationMessageAdmin> {
            return localVarFp.whatsNewAdminRetrieve(id, createdMonth, createdYear, endDate, search, startDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhatsNewAdminApi - object-oriented interface
 * @export
 * @class WhatsNewAdminApi
 * @extends {BaseAPI}
 */
export class WhatsNewAdminApi extends BaseAPI {
    /**
     * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
     * @param {InformationMessageAdminCreateRequest} informationMessageAdminCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewAdminApi
     */
    public whatsNewAdminCreate(informationMessageAdminCreateRequest: InformationMessageAdminCreateRequest, options?: AxiosRequestConfig) {
        return WhatsNewAdminApiFp(this.configuration).whatsNewAdminCreate(informationMessageAdminCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
     * @param {number} id A unique integer value identifying this information message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewAdminApi
     */
    public whatsNewAdminDestroy(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options?: AxiosRequestConfig) {
        return WhatsNewAdminApiFp(this.configuration).whatsNewAdminDestroy(id, createdMonth, createdYear, endDate, search, startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewAdminApi
     */
    public whatsNewAdminList(createdMonth?: string, createdYear?: string, endDate?: string, page?: number, pageSize?: number, search?: string, startDate?: string, options?: AxiosRequestConfig) {
        return WhatsNewAdminApiFp(this.configuration).whatsNewAdminList(createdMonth, createdYear, endDate, page, pageSize, search, startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
     * @param {number} id A unique integer value identifying this information message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
     * @param {PatchedInformationMessageAdminUpdateRequest} [patchedInformationMessageAdminUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewAdminApi
     */
    public whatsNewAdminPartialUpdate(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, patchedInformationMessageAdminUpdateRequest?: PatchedInformationMessageAdminUpdateRequest, options?: AxiosRequestConfig) {
        return WhatsNewAdminApiFp(this.configuration).whatsNewAdminPartialUpdate(id, createdMonth, createdYear, endDate, search, startDate, patchedInformationMessageAdminUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that allows logged in admin user to get all the messages created by BOJ or company admin.  The API will get the current user, find all the messages that are:   - Live. I.e `is_deleted=False` in DB  The List API will return a list of available messages, with pagination support (see `page` and `page_size` parameters)  The List API can also be:   - searched by title and message via the `search` parameter.   - filtered by `created_month` and `created_year`  The List API will give message information like   - show msg status to admin user i.e `Published` when start_time is less than current time or     `Publication Reserved` when start_time is greater than current time   - show msg view count to admin user i.e number of user who have read that message  The Detail API will return the details of the message with the given ID. Together with a brief info of the previous/next message/msg status/ view count.  The Post API will create the new message for the admin user organization. The parameter required for the API are:     `Title`, `Message`, `Start Showing`  The Patch API will allow admin user to update the `Title` and `Message` field.  The Delete API will allow admin user to delete the selected message.
     * @param {number} id A unique integer value identifying this information message.
     * @param {string} [createdMonth] limit to the given month. Could be combined with &#x60;created_year&#x60;
     * @param {string} [createdYear] limit to the given year. Could be combined with &#x60;created_month&#x60;
     * @param {string} [endDate] Filter data to this date. eg: 2020-12-02
     * @param {string} [search] A search term.
     * @param {string} [startDate] Filter data from this date. eg: 2020-02-02
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhatsNewAdminApi
     */
    public whatsNewAdminRetrieve(id: number, createdMonth?: string, createdYear?: string, endDate?: string, search?: string, startDate?: string, options?: AxiosRequestConfig) {
        return WhatsNewAdminApiFp(this.configuration).whatsNewAdminRetrieve(id, createdMonth, createdYear, endDate, search, startDate, options).then((request) => request(this.axios, this.basePath));
    }
}


